// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { ApiV5AllauthSchemeRetrieveResponse, ApiV5AccountRetrieveResponse, ApiV5AccountUpdateData, ApiV5AccountUpdateResponse, ApiV5AccountPartialUpdateData, ApiV5AccountPartialUpdateResponse, ApiV5AccountDestroyResponse, ApiV5CheckSsoCreateData, ApiV5CheckSsoCreateResponse, ApiV5JwtObtainCreateData, ApiV5JwtObtainCreateResponse, ApiV5JwtRefreshCreateData, ApiV5JwtRefreshCreateResponse, ApiV5PasswordChangeCreateData, ApiV5PasswordChangeCreateResponse, ApiV5PasswordResetCreateData, ApiV5PasswordResetCreateResponse, ApiV5PasswordResetConfirmCreateData, ApiV5PasswordResetConfirmCreateResponse, ApiV5SignupCreateData, ApiV5SignupCreateResponse, ApiV5SignupWithInvitationCreateData, ApiV5SignupWithInvitationCreateResponse, ApiV5VerifyEmailCreateData, ApiV5VerifyEmailCreateResponse, ActivitiesListData, ActivitiesListResponse, ActivitiesCreateData, ActivitiesCreateResponse, ActivitiesRetrieveData, ActivitiesRetrieveResponse, ActivitiesUpdateData, ActivitiesUpdateResponse, ActivitiesPartialUpdateData, ActivitiesPartialUpdateResponse, ActivitiesDeletePartialUpdateData, ActivitiesDeletePartialUpdateResponse, ActivitiesSetDonePartialUpdateData, ActivitiesSetDonePartialUpdateResponse, ActivitiesSetUndonePartialUpdateData, ActivitiesSetUndonePartialUpdateResponse, ActivitiesContactsListData, ActivitiesContactsListResponse, ActivitytypepricesListData, ActivitytypepricesListResponse, ActivitytypepricesCreateData, ActivitytypepricesCreateResponse, ActivitytypepricesRetrieveData, ActivitytypepricesRetrieveResponse, ActivitytypepricesUpdateData, ActivitytypepricesUpdateResponse, ActivitytypepricesPartialUpdateData, ActivitytypepricesPartialUpdateResponse, ActivitytypepricesDestroyData, ActivitytypepricesDestroyResponse, ActivitytypesListData, ActivitytypesListResponse, ActivitytypesCreateData, ActivitytypesCreateResponse, ActivitytypesRetrieveData, ActivitytypesRetrieveResponse, ActivitytypesUpdateData, ActivitytypesUpdateResponse, ActivitytypesPartialUpdateData, ActivitytypesPartialUpdateResponse, ActivitytypesDestroyData, ActivitytypesDestroyResponse, ApiV5DeviceListResponse, ApiV5DeviceFcmListResponse, ApiV5DeviceFcmCreateData, ApiV5DeviceFcmCreateResponse, ApiV5DeviceFcmRetrieveData, ApiV5DeviceFcmRetrieveResponse, ApiV5DeviceFcmUpdateData, ApiV5DeviceFcmUpdateResponse, ApiV5DeviceFcmPartialUpdateData, ApiV5DeviceFcmPartialUpdateResponse, ApiV5DeviceFcmDestroyData, ApiV5DeviceFcmDestroyResponse, ApiV5DeviceFcmSettingsRetrieveResponse, ApiV5DeviceFcmSettingsPartialUpdateData, ApiV5DeviceFcmSettingsPartialUpdateResponse, ApiV5DeviceFcmSettingsPatchPartialUpdateData, ApiV5DeviceFcmSettingsPatchPartialUpdateResponse, ApiV5OauthUserMicrosoftLoginCreateData, ApiV5OauthUserMicrosoftLoginCreateResponse, ApiV5PlansListData, ApiV5PlansListResponse, AvailabilityEmployeeListData, AvailabilityEmployeeListResponse, AvailabilityEmployeeCreateData, AvailabilityEmployeeCreateResponse, AvailabilityEmployeeRetrieveData, AvailabilityEmployeeRetrieveResponse, AvailabilityEmployeeUpdateData, AvailabilityEmployeeUpdateResponse, AvailabilityEmployeePartialUpdateData, AvailabilityEmployeePartialUpdateResponse, AvailabilityEmployeeDeletePartialUpdateData, AvailabilityEmployeeDeletePartialUpdateResponse, AvailabilityManagerListData, AvailabilityManagerListResponse, AvailabilityManagerCreateData, AvailabilityManagerCreateResponse, AvailabilityManagerRetrieveData, AvailabilityManagerRetrieveResponse, AvailabilityManagerUpdateData, AvailabilityManagerUpdateResponse, AvailabilityManagerPartialUpdateData, AvailabilityManagerPartialUpdateResponse, AvailabilityManagerApprovePartialUpdateData, AvailabilityManagerApprovePartialUpdateResponse, AvailabilityManagerCancelPartialUpdateData, AvailabilityManagerCancelPartialUpdateResponse, AvailabilityManagerDeletePartialUpdateData, AvailabilityManagerDeletePartialUpdateResponse, AvailabilityManagerRejectPartialUpdateData, AvailabilityManagerRejectPartialUpdateResponse, BillableitemsUpdateData, BillableitemsUpdateResponse, BillableitemsPartialUpdateData, BillableitemsPartialUpdateResponse, BillableitemsInvoicedListData, BillableitemsInvoicedListResponse, BillableitemsNotToInvoiceListData, BillableitemsNotToInvoiceListResponse, BillableitemsToInvoiceListData, BillableitemsToInvoiceListResponse, BreedingplanListData, BreedingplanListResponse, BreedingplanCreateData, BreedingplanCreateResponse, BreedingplanRetrieveData, BreedingplanRetrieveResponse, BreedingplanUpdateData, BreedingplanUpdateResponse, BreedingplanPartialUpdateData, BreedingplanPartialUpdateResponse, BreedingplanDestroyData, BreedingplanDestroyResponse, CategoriesListData, CategoriesListResponse, CategoriesCreateData, CategoriesCreateResponse, CategoriesRetrieveData, CategoriesRetrieveResponse, CategoriesUpdateData, CategoriesUpdateResponse, CategoriesPartialUpdateData, CategoriesPartialUpdateResponse, CategoriesDestroyData, CategoriesDestroyResponse, ContactsListData, ContactsListResponse, ContactsCreateData, ContactsCreateResponse, ContactsRetrieveData, ContactsRetrieveResponse, ContactsUpdateData, ContactsUpdateResponse, ContactsPartialUpdateData, ContactsPartialUpdateResponse, ContactsDestroyData, ContactsDestroyResponse, ContactsAuthorizeRvoCreateData, ContactsAuthorizeRvoCreateResponse, ContactsAuthorizeRvoDestroyData, ContactsAuthorizeRvoDestroyResponse, ContactsCheckAuthorizationRvoCreateData, ContactsCheckAuthorizationRvoCreateResponse, ContactsIgnoreForDuplicatePartialUpdateData, ContactsIgnoreForDuplicatePartialUpdateResponse, ContactsMergeAndUpdatePartialUpdateData, ContactsMergeAndUpdatePartialUpdateResponse, ContactsDuplicatesListData, ContactsDuplicatesListResponse, DailynoteListData, DailynoteListResponse, DailynoteCreateData, DailynoteCreateResponse, DailynoteRetrieveData, DailynoteRetrieveResponse, DailynoteUpdateData, DailynoteUpdateResponse, DailynotePartialUpdateData, DailynotePartialUpdateResponse, DailynoteDeletePartialUpdateData, DailynoteDeletePartialUpdateResponse, DailynoteSetDonePartialUpdateData, DailynoteSetDonePartialUpdateResponse, DailynoteSetUndonePartialUpdateData, DailynoteSetUndonePartialUpdateResponse, DaypartsListData, DaypartsListResponse, DaypartsCreateData, DaypartsCreateResponse, DaypartsRetrieveData, DaypartsRetrieveResponse, DaypartsUpdateData, DaypartsUpdateResponse, DaypartsPartialUpdateData, DaypartsPartialUpdateResponse, DaypartsDestroyData, DaypartsDestroyResponse, EmploymentEmployeeListData, EmploymentEmployeeListResponse, EmploymentManagerListData, EmploymentManagerListResponse, EmploymentManagerCreateData, EmploymentManagerCreateResponse, EmploymentManagerRetrieveData, EmploymentManagerRetrieveResponse, EmploymentManagerUpdateData, EmploymentManagerUpdateResponse, EmploymentManagerPartialUpdateData, EmploymentManagerPartialUpdateResponse, EmploymentManagerDestroyData, EmploymentManagerDestroyResponse, EventfeedsListData, EventfeedsListResponse, EventfeedsCreateData, EventfeedsCreateResponse, EventfeedsRetrieveData, EventfeedsRetrieveResponse, EventfeedsUpdateData, EventfeedsUpdateResponse, EventfeedsPartialUpdateData, EventfeedsPartialUpdateResponse, EventfeedsDestroyData, EventfeedsDestroyResponse, FacilitiesListData, FacilitiesListResponse, FacilitiesCreateData, FacilitiesCreateResponse, FacilitiesRetrieveData, FacilitiesRetrieveResponse, FacilitiesUpdateData, FacilitiesUpdateResponse, FacilitiesPartialUpdateData, FacilitiesPartialUpdateResponse, FacilitiesDestroyData, FacilitiesDestroyResponse, FacilitiesContactsListData, FacilitiesContactsListResponse, FacilitiesEventsListData, FacilitiesEventsListResponse, FacilitiesEventsCreateData, FacilitiesEventsCreateResponse, FacilitiesEventsRetrieveData, FacilitiesEventsRetrieveResponse, FacilitiesEventsUpdateData, FacilitiesEventsUpdateResponse, FacilitiesEventsPartialUpdateData, FacilitiesEventsPartialUpdateResponse, FacilitiesEventsDeletePartialUpdateData, FacilitiesEventsDeletePartialUpdateResponse, FacilitiesHorsesListData, FacilitiesHorsesListResponse, FacilitiesMyEventsCreateData, FacilitiesMyEventsCreateResponse, FacilitiesMyEventsUpdateData, FacilitiesMyEventsUpdateResponse, FacilitiesMyEventsPartialUpdateData, FacilitiesMyEventsPartialUpdateResponse, FacilitiesMyEventsDeletePartialUpdateData, FacilitiesMyEventsDeletePartialUpdateResponse, FeedingsListData, FeedingsListResponse, FeedingsCreateData, FeedingsCreateResponse, FeedingsRetrieveData, FeedingsRetrieveResponse, FeedingsUpdateData, FeedingsUpdateResponse, FeedingsPartialUpdateData, FeedingsPartialUpdateResponse, FeedingsDestroyData, FeedingsDestroyResponse, FeedtypesListData, FeedtypesListResponse, FeedtypesCreateData, FeedtypesCreateResponse, FeedtypesRetrieveData, FeedtypesRetrieveResponse, FeedtypesUpdateData, FeedtypesUpdateResponse, FeedtypesPartialUpdateData, FeedtypesPartialUpdateResponse, FeedtypesDestroyData, FeedtypesDestroyResponse, HolidayeventsListData, HolidayeventsListResponse, HolidayeventsCreateData, HolidayeventsCreateResponse, HolidayeventsRetrieveData, HolidayeventsRetrieveResponse, HolidayeventsUpdateData, HolidayeventsUpdateResponse, HolidayeventsPartialUpdateData, HolidayeventsPartialUpdateResponse, HolidayeventsDestroyData, HolidayeventsDestroyResponse, HolidayeventsCreateFromCountryTemplateCreateData, HolidayeventsCreateFromCountryTemplateCreateResponse, HorsefeedsListData, HorsefeedsListResponse, HorsefeedsCreateData, HorsefeedsCreateResponse, HorsefeedsRetrieveData, HorsefeedsRetrieveResponse, HorsefeedsUpdateData, HorsefeedsUpdateResponse, HorsefeedsPartialUpdateData, HorsefeedsPartialUpdateResponse, HorsefeedsDeletePartialUpdateData, HorsefeedsDeletePartialUpdateResponse, HorsegroupsListData, HorsegroupsListResponse, HorsegroupsCreateData, HorsegroupsCreateResponse, HorsegroupsRetrieveData, HorsegroupsRetrieveResponse, HorsegroupsUpdateData, HorsegroupsUpdateResponse, HorsegroupsPartialUpdateData, HorsegroupsPartialUpdateResponse, HorsegroupsDestroyData, HorsegroupsDestroyResponse, HorselocationsListData, HorselocationsListResponse, HorselocationsRetrieveData, HorselocationsRetrieveResponse, HorselocationsUpdateData, HorselocationsUpdateResponse, HorselocationsPartialUpdateData, HorselocationsPartialUpdateResponse, HorselocationsDestroyData, HorselocationsDestroyResponse, HorselocationsHideArrivalCreateData, HorselocationsHideArrivalCreateResponse, HorselocationsHideDepartureCreateData, HorselocationsHideDepartureCreateResponse, HorselocationsMutationsWithoutReportListData, HorselocationsMutationsWithoutReportListResponse, HorsemediaListData, HorsemediaListResponse, HorsemediaCreateData, HorsemediaCreateResponse, HorsemediaRetrieveData, HorsemediaRetrieveResponse, HorsemediaUpdateData, HorsemediaUpdateResponse, HorsemediaPartialUpdateData, HorsemediaPartialUpdateResponse, HorsemediaDestroyData, HorsemediaDestroyResponse, HorseownersListData, HorseownersListResponse, HorseownersCreateData, HorseownersCreateResponse, HorseownersRetrieveData, HorseownersRetrieveResponse, HorseownersUpdateData, HorseownersUpdateResponse, HorseownersPartialUpdateData, HorseownersPartialUpdateResponse, HorseownersDestroyData, HorseownersDestroyResponse, HorseownersHistoryListData, HorseownersHistoryListResponse, HorseownersHistoryRetrieveData, HorseownersHistoryRetrieveResponse, HorsesHorseemployabilitystatusListData, HorsesHorseemployabilitystatusListResponse, HorsesHorseemployabilitystatusCreateData, HorsesHorseemployabilitystatusCreateResponse, HorsesHorseemployabilitystatusRetrieveData, HorsesHorseemployabilitystatusRetrieveResponse, HorsesHorsepagesCreateData, HorsesHorsepagesCreateResponse, HorsesHorsephasestatusListData, HorsesHorsephasestatusListResponse, HorsesHorsephasestatusCreateData, HorsesHorsephasestatusCreateResponse, HorsesHorsephasestatusRetrieveData, HorsesHorsephasestatusRetrieveResponse, HorsesListData, HorsesListResponse, HorsesCreateData, HorsesCreateResponse, HorsesRetrieveData, HorsesRetrieveResponse, HorsesUpdateData, HorsesUpdateResponse, HorsesPartialUpdateData, HorsesPartialUpdateResponse, HorsesDestroyData, HorsesDestroyResponse, HorsesIgnoreForDuplicatePartialUpdateData, HorsesIgnoreForDuplicatePartialUpdateResponse, HorsesMergeAndUpdatePartialUpdateData, HorsesMergeAndUpdatePartialUpdateResponse, HorsesMoveCreateData, HorsesMoveCreateResponse, HorsesSetActiveCreateData, HorsesSetActiveCreateResponse, HorsesSetInactiveCreateData, HorsesSetInactiveCreateResponse, HorsesContactsListData, HorsesContactsListResponse, HorsesCreateGetHorsesFromRvoCreateData, HorsesCreateGetHorsesFromRvoCreateResponse, HorsesDuplicatesListData, HorsesDuplicatesListResponse, HorsesGetHorsesFromRvoListData, HorsesGetHorsesFromRvoListResponse, HorsesGetHorsesFromRvoCreateData, HorsesGetHorsesFromRvoCreateResponse, HorsesGetHorsetelexDetailCreateData, HorsesGetHorsetelexDetailCreateResponse, HorsesSearchHorseCreateData, HorsesSearchHorseCreateResponse, ApiV5InvitationsListData, ApiV5InvitationsListResponse, ApiV5InvitationsRetrieveData, ApiV5InvitationsRetrieveResponse, ApiV5InvitationsAcceptPartialUpdateData, ApiV5InvitationsAcceptPartialUpdateResponse, ApiV5InvitationsDeclinePartialUpdateData, ApiV5InvitationsDeclinePartialUpdateResponse, InvitationsListData, InvitationsListResponse, InvitationsCreateData, InvitationsCreateResponse, InvitationsRetrieveData, InvitationsRetrieveResponse, InvitationsDestroyData, InvitationsDestroyResponse, InvitationsResendInvitationPartialUpdateData, InvitationsResendInvitationPartialUpdateResponse, InvoicefrombillableitemsInvoiceCreateData, InvoicefrombillableitemsInvoiceCreateResponse, InvoicesInvoiceitemsListData, InvoicesInvoiceitemsListResponse, InvoicesInvoiceitemsCreateData, InvoicesInvoiceitemsCreateResponse, InvoicesInvoiceitemsRetrieveData, InvoicesInvoiceitemsRetrieveResponse, InvoicesInvoiceitemsUpdateData, InvoicesInvoiceitemsUpdateResponse, InvoicesInvoiceitemsPartialUpdateData, InvoicesInvoiceitemsPartialUpdateResponse, InvoicesInvoiceitemsDestroyData, InvoicesInvoiceitemsDestroyResponse, InvoicesListData, InvoicesListResponse, InvoicesCreateData, InvoicesCreateResponse, InvoicesRetrieveData, InvoicesRetrieveResponse, InvoicesUpdateData, InvoicesUpdateResponse, InvoicesPartialUpdateData, InvoicesPartialUpdateResponse, InvoicesDestroyData, InvoicesDestroyResponse, InvoicesFinalizeCreateData, InvoicesFinalizeCreateResponse, InvoicesRemoveLinkWithAccountingSoftwareCreateData, InvoicesRemoveLinkWithAccountingSoftwareCreateResponse, InvoicesSendToAccountingSoftwareCreateData, InvoicesSendToAccountingSoftwareCreateResponse, InvoicesSendToClientRetrieveData, InvoicesSendToClientRetrieveResponse, InvoicesSendToClientCreateData, InvoicesSendToClientCreateResponse, InvoicesSendToClientCreateCreateData, InvoicesSendToClientCreateCreateResponse, InvoicesUnfinalizeCreateData, InvoicesUnfinalizeCreateResponse, LeaveMutationListData, LeaveMutationListResponse, LeaveMutationCreateData, LeaveMutationCreateResponse, LeaveMutationRetrieveData, LeaveMutationRetrieveResponse, LeaveMutationUpdateData, LeaveMutationUpdateResponse, LeaveMutationPartialUpdateData, LeaveMutationPartialUpdateResponse, LeaveMutationDestroyData, LeaveMutationDestroyResponse, ManureFertilizerConsumersListData, ManureFertilizerConsumersListResponse, ManureFertilizerConsumersCreateData, ManureFertilizerConsumersCreateResponse, ManureFertilizerConsumersRetrieveData, ManureFertilizerConsumersRetrieveResponse, ManureFertilizerConsumersUpdateData, ManureFertilizerConsumersUpdateResponse, ManureFertilizerConsumersPartialUpdateData, ManureFertilizerConsumersPartialUpdateResponse, ManureFertilizerConsumersDestroyData, ManureFertilizerConsumersDestroyResponse, ManureFertilizerProducersBalanceListData, ManureFertilizerProducersBalanceListResponse, ManureFertilizerProducersBalanceCreateData, ManureFertilizerProducersBalanceCreateResponse, ManureFertilizerProducersBalanceRetrieveData, ManureFertilizerProducersBalanceRetrieveResponse, ManureFertilizerProducersBalanceUpdateData, ManureFertilizerProducersBalanceUpdateResponse, ManureFertilizerProducersBalancePartialUpdateData, ManureFertilizerProducersBalancePartialUpdateResponse, ManureFertilizerProducersBalanceDestroyData, ManureFertilizerProducersBalanceDestroyResponse, ManureFertilizerProducersEffectiveNitrogenListData, ManureFertilizerProducersEffectiveNitrogenListResponse, ManureFertilizerProducersEffectiveNitrogenCreateData, ManureFertilizerProducersEffectiveNitrogenCreateResponse, ManureFertilizerProducersEffectiveNitrogenRetrieveData, ManureFertilizerProducersEffectiveNitrogenRetrieveResponse, ManureFertilizerProducersEffectiveNitrogenUpdateData, ManureFertilizerProducersEffectiveNitrogenUpdateResponse, ManureFertilizerProducersEffectiveNitrogenPartialUpdateData, ManureFertilizerProducersEffectiveNitrogenPartialUpdateResponse, ManureFertilizerProducersEffectiveNitrogenDestroyData, ManureFertilizerProducersEffectiveNitrogenDestroyResponse, ManureStableHistoricHorseCountContactRetrieveData, ManureStableHistoricHorseCountContactRetrieveResponse, MapsListData, MapsListResponse, MapsCreateData, MapsCreateResponse, MapsRetrieveData, MapsRetrieveResponse, MapsUpdateData, MapsUpdateResponse, MapsPartialUpdateData, MapsPartialUpdateResponse, MapsDestroyData, MapsDestroyResponse, MarecyclecheckListData, MarecyclecheckListResponse, MarecyclecheckCreateData, MarecyclecheckCreateResponse, MarecyclecheckRetrieveData, MarecyclecheckRetrieveResponse, MarecyclecheckUpdateData, MarecyclecheckUpdateResponse, MarecyclecheckPartialUpdateData, MarecyclecheckPartialUpdateResponse, MarecyclecheckDestroyData, MarecyclecheckDestroyResponse, ApiV5AuthorizeRetrieveData, ApiV5AuthorizeCreateData, ApiV5OauthLoginCreateData, ApiV5OauthLoginCreateResponse, OauthTokensListData, OauthTokensListResponse, OauthTokensRetrieveData, OauthTokensRetrieveResponse, OauthTokensDestroyData, OauthTokensDestroyResponse, OrdersSuppliedSemenorderitemsPickstallionmountsCreateData, OrdersSuppliedSemenorderitemsPickstallionmountsCreateResponse, OrdersSuppliedSemenorderitemsUnpickstallionmountsDestroyData, OrdersSuppliedSemenorderitemsUnpickstallionmountsDestroyResponse, OrdersPurchasedListData, OrdersPurchasedListResponse, OrdersPurchasedCreateData, OrdersPurchasedCreateResponse, OrdersPurchasedRetrieveData, OrdersPurchasedRetrieveResponse, OrdersPurchasedUpdateData, OrdersPurchasedUpdateResponse, OrdersPurchasedPartialUpdateData, OrdersPurchasedPartialUpdateResponse, OrdersPurchasedFindParentSemenOrdersCreateData, OrdersPurchasedFindParentSemenOrdersCreateResponse, OrdersSuppliedListData, OrdersSuppliedListResponse, OrdersSuppliedCreateData, OrdersSuppliedCreateResponse, OrdersSuppliedRetrieveData, OrdersSuppliedRetrieveResponse, OrdersSuppliedUpdateData, OrdersSuppliedUpdateResponse, OrdersSuppliedPartialUpdateData, OrdersSuppliedPartialUpdateResponse, OrdersSuppliedDestroyData, OrdersSuppliedDestroyResponse, OrdersSuppliedUpdateCustomerContactPartialUpdateData, OrdersSuppliedUpdateCustomerContactPartialUpdateResponse, OrdersSuppliedFindParentSemenOrdersCreateData, OrdersSuppliedFindParentSemenOrdersCreateResponse, RootListData, RootListResponse, RootCreateData, RootCreateResponse, RootRetrieveData, RootRetrieveResponse, RootUpdateData, RootUpdateResponse, RootPartialUpdateData, RootPartialUpdateResponse, RootDestroyData, RootDestroyResponse, PaymentProvidersListData, PaymentProvidersListResponse, PaymentProvidersRetrieveData, PaymentProvidersRetrieveResponse, PaymentProvidersDestroyData, PaymentProvidersDestroyResponse, PaymentProvidersCreateWithMandateCreateData, PaymentProvidersCreateWithMandateCreateResponse, PaymentsListData, PaymentsListResponse, PaymentsCreateData, PaymentsCreateResponse, PaymentsRetrieveData, PaymentsRetrieveResponse, PaymentsUpdateData, PaymentsUpdateResponse, PaymentsPartialUpdateData, PaymentsPartialUpdateResponse, PaymentsDestroyData, PaymentsDestroyResponse, PoiListData, PoiListResponse, PoiCreateData, PoiCreateResponse, PoiRetrieveData, PoiRetrieveResponse, PoiUpdateData, PoiUpdateResponse, PoiPartialUpdateData, PoiPartialUpdateResponse, PoiDestroyData, PoiDestroyResponse, ProductsListData, ProductsListResponse, ProductsCreateData, ProductsCreateResponse, ProductsRetrieveData, ProductsRetrieveResponse, ProductsUpdateData, ProductsUpdateResponse, ProductsPartialUpdateData, ProductsPartialUpdateResponse, ProductsDestroyData, ProductsDestroyResponse, ApiV5AdministrationManureFertilizerNormsListData, ApiV5AdministrationManureFertilizerNormsListResponse, ApiV5HorsepagesRetrieveData, ApiV5HorsepagesRetrieveResponse, ApiV5InvoicesRetrieveData, ApiV5InvoicesRetrieveResponse, ApiV5InvoicesMolliePaymentLinkCreateData, ApiV5InvoicesMolliePaymentLinkCreateResponse, ApiV5OrdersRetrieveData, ApiV5OrdersRetrieveResponse, ApiV5OrdersUpdateData, ApiV5OrdersUpdateResponse, ApiV5OrdersPartialUpdateData, ApiV5OrdersPartialUpdateResponse, ApiV5OrdersMolliePaymentLinkCreateData, ApiV5OrdersMolliePaymentLinkCreateResponse, ApiV5PublicOrganisationsProductCatalogueListData, ApiV5PublicOrganisationsProductCatalogueListResponse, ApiV5PublicOrganisationsVatPercentagesListData, ApiV5PublicOrganisationsVatPercentagesListResponse, ApiV5PublicOrganisationsRetrieveData, ApiV5PublicOrganisationsRetrieveResponse, ReportedhorserelocationsListData, ReportedhorserelocationsListResponse, ReportedhorserelocationsCreateData, ReportedhorserelocationsCreateResponse, ReportedhorserelocationsRetrieveData, ReportedhorserelocationsRetrieveResponse, ReportedhorserelocationsCheckStatusCreateData, ReportedhorserelocationsCheckStatusCreateResponse, ReportedhorserelocationsWithdrawReportCreateData, ReportedhorserelocationsWithdrawReportCreateResponse, ReportedhorserelocationsRvOHorseHairColorsListData, ReportedhorserelocationsRvOHorseHairColorsListResponse, RolesListData, RolesListResponse, RolesCreateData, RolesCreateResponse, RolesRetrieveData, RolesRetrieveResponse, RolesUpdateData, RolesUpdateResponse, RolesPartialUpdateData, RolesPartialUpdateResponse, RolesDestroyData, RolesDestroyResponse, RolesModulePermissionsUpdateData, RolesModulePermissionsUpdateResponse, RolesAllModulePermissionsListData, RolesAllModulePermissionsListResponse, RolesModulePermissionsListData, RolesModulePermissionsListResponse, ServiceListData, ServiceListResponse, ServiceCreateData, ServiceCreateResponse, ServiceRetrieveData, ServiceRetrieveResponse, ServiceUpdateData, ServiceUpdateResponse, ServicePartialUpdateData, ServicePartialUpdateResponse, ServiceDestroyData, ServiceDestroyResponse, ServicecontactsListData, ServicecontactsListResponse, ServicecontactsCreateData, ServicecontactsCreateResponse, ServicecontactsRetrieveData, ServicecontactsRetrieveResponse, ServicecontactsUpdateData, ServicecontactsUpdateResponse, ServicecontactsPartialUpdateData, ServicecontactsPartialUpdateResponse, ServicecontactsDestroyData, ServicecontactsDestroyResponse, ServiceContractsSuppliedListData, ServiceContractsSuppliedListResponse, ServiceContractsSuppliedCreateData, ServiceContractsSuppliedCreateResponse, ServiceContractsSuppliedRetrieveData, ServiceContractsSuppliedRetrieveResponse, ServiceContractsSuppliedUpdateData, ServiceContractsSuppliedUpdateResponse, ServiceContractsSuppliedPartialUpdateData, ServiceContractsSuppliedPartialUpdateResponse, ServiceContractsPurchasedListData, ServiceContractsPurchasedListResponse, ServiceContractsPurchasedRetrieveData, ServiceContractsPurchasedRetrieveResponse, ServiceContractsPurchasedCancelPartialUpdateData, ServiceContractsPurchasedCancelPartialUpdateResponse, ServiceContractsPurchasedChangePartialUpdateData, ServiceContractsPurchasedChangePartialUpdateResponse, ServiceContractsPurchasedReactivatePartialUpdateData, ServiceContractsPurchasedReactivatePartialUpdateResponse, ServiceContractsPurchasedContinueForFreeCreateData, ServiceContractsPurchasedContinueForFreeCreateResponse, StablesListData, StablesListResponse, StablesCreateData, StablesCreateResponse, StablesRetrieveData, StablesRetrieveResponse, StablesUpdateData, StablesUpdateResponse, StablesPartialUpdateData, StablesPartialUpdateResponse, StablesDestroyData, StablesDestroyResponse, StallionmountsListData, StallionmountsListResponse, StallionmountsCreateData, StallionmountsCreateResponse, StallionmountsRetrieveData, StallionmountsRetrieveResponse, StallionmountsUpdateData, StallionmountsUpdateResponse, StallionmountsPartialUpdateData, StallionmountsPartialUpdateResponse, StallionmountsDestroyData, StallionmountsDestroyResponse, StallionmountsDestroyFreshPartialUpdateData, StallionmountsDestroyFreshPartialUpdateResponse, StallionmountsDestroyFrozenPartialUpdateData, StallionmountsDestroyFrozenPartialUpdateResponse, StallionmountsDestroyRemainingPartialUpdateData, StallionmountsDestroyRemainingPartialUpdateResponse, TransactionsListData, TransactionsListResponse, TransactionsCreateData, TransactionsCreateResponse, TransactionsRetrieveData, TransactionsRetrieveResponse, TransactionsUpdateData, TransactionsUpdateResponse, TransactionsPartialUpdateData, TransactionsPartialUpdateResponse, TransactionsDestroyData, TransactionsDestroyResponse, TransactionsItemsListData, TransactionsItemsListResponse, VaccinationrulesListData, VaccinationrulesListResponse, VaccinationrulesCreateData, VaccinationrulesCreateResponse, VaccinationrulesRetrieveData, VaccinationrulesRetrieveResponse, VaccinationrulesUpdateData, VaccinationrulesUpdateResponse, VaccinationrulesPartialUpdateData, VaccinationrulesPartialUpdateResponse, VaccinationrulesDestroyData, VaccinationrulesDestroyResponse, VatpercentageexternalprovideridsListData, VatpercentageexternalprovideridsListResponse, VatpercentageexternalprovideridsCreateData, VatpercentageexternalprovideridsCreateResponse, VatpercentageexternalprovideridsRetrieveData, VatpercentageexternalprovideridsRetrieveResponse, VatpercentageexternalprovideridsUpdateData, VatpercentageexternalprovideridsUpdateResponse, VatpercentageexternalprovideridsPartialUpdateData, VatpercentageexternalprovideridsPartialUpdateResponse, VatpercentageexternalprovideridsDestroyData, VatpercentageexternalprovideridsDestroyResponse, VatpercentagesListData, VatpercentagesListResponse, VatpercentagesCreateData, VatpercentagesCreateResponse, VatpercentagesRetrieveData, VatpercentagesRetrieveResponse, VatpercentagesUpdateData, VatpercentagesUpdateResponse, VatpercentagesPartialUpdateData, VatpercentagesPartialUpdateResponse, VatpercentagesDestroyData, VatpercentagesDestroyResponse, VatpercentagesImportDefaultEuVatPercentagesCreateData, VatpercentagesImportDefaultEuVatPercentagesCreateResponse, ApiV5WebhookMollieMandateCreateData, ApiV5WebhookMollieMandateCreateResponse, ApiV5WebhookMolliePaymentCreateData, ApiV5WebhookMolliePaymentCreateResponse, ApiV5WebhookSnelstartCreateResponse, WorkdayAvailabilityActivitiesListData, WorkdayAvailabilityActivitiesListResponse, WorkdayAvailabilityManagerListData, WorkdayAvailabilityManagerListResponse } from './types.gen';

export class AccountService {
    /**
     * Get allauth scheme
     * @returns unknown Binary Response
     * @throws ApiError
     */
    public static apiV5AllauthSchemeRetrieve(): CancelablePromise<ApiV5AllauthSchemeRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/_allauth/scheme',
            errors: {
                404: 'Resource not found'
            }
        });
    }
    
    /**
     * @returns Account
     * @throws ApiError
     */
    public static apiV5AccountRetrieve(): CancelablePromise<ApiV5AccountRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/account'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Account
     * @throws ApiError
     */
    public static apiV5AccountUpdate(data: ApiV5AccountUpdateData): CancelablePromise<ApiV5AccountUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/account',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Account
     * @throws ApiError
     */
    public static apiV5AccountPartialUpdate(data: ApiV5AccountPartialUpdateData = {}): CancelablePromise<ApiV5AccountPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/account',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns void No response body
     * @throws ApiError
     */
    public static apiV5AccountDestroy(): CancelablePromise<ApiV5AccountDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/account'
        });
    }
    
    /**
     * Input:
     * - an emailaddress
     * Output:
     * - a list of accepted login methods.
     *
     * We check the domain of the email. If that domain has only_use_ad you cannot login using email.
     * If that domain is connected to for example microsft, microsoft will be added to the list.
     *
     * Even if a user (email) does not exist we add 'email' to prevent enumeration attacks!
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SSO
     * @throws ApiError
     */
    public static apiV5CheckSsoCreate(data: ApiV5CheckSsoCreateData): CancelablePromise<ApiV5CheckSsoCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/check_sso',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web
     * token pair to prove the authentication of those credentials.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TokenObtainPair
     * @throws ApiError
     */
    public static apiV5JwtObtainCreate(data: ApiV5JwtObtainCreateData): CancelablePromise<ApiV5JwtObtainCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/jwt/obtain',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web
     * token if the refresh token is valid.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TokenRefresh
     * @throws ApiError
     */
    public static apiV5JwtRefreshCreate(data: ApiV5JwtRefreshCreateData): CancelablePromise<ApiV5JwtRefreshCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/jwt/refresh',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Calls Django Auth SetPasswordForm save method.
     *
     * Accepts the following POST parameters: new_password1, new_password2
     * Returns the success/fail message.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static apiV5PasswordChangeCreate(data: ApiV5PasswordChangeCreateData): CancelablePromise<ApiV5PasswordChangeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/password-change',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Calls Django Auth PasswordResetForm save method.
     *
     * Accepts the following POST parameters: email
     * Returns the success/fail message.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns EquineMPasswordReset
     * @throws ApiError
     */
    public static apiV5PasswordResetCreate(data: ApiV5PasswordResetCreateData): CancelablePromise<ApiV5PasswordResetCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/password-reset',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Password reset e-mail link is confirmed, therefore
     * this resets the user's password.
     *
     * Accepts the following POST parameters: token, uid,
     * new_password1, new_password2
     * Returns the success/fail message.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static apiV5PasswordResetConfirmCreate(data: ApiV5PasswordResetConfirmCreateData): CancelablePromise<ApiV5PasswordResetConfirmCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/password-reset-confirm',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Registers a new user.
     *
     * Accepts the following POST parameters: username, email, password1, password2.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns EquineMRegister
     * @throws ApiError
     */
    public static apiV5SignupCreate(data: ApiV5SignupCreateData): CancelablePromise<ApiV5SignupCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/signup',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * A user can sign up after having received an invitation. The invitation's username and email
     * will be applied to the resulting account.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SignupResponse
     * @throws ApiError
     */
    public static apiV5SignupWithInvitationCreate(data: ApiV5SignupWithInvitationCreateData): CancelablePromise<ApiV5SignupWithInvitationCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/signup_with_invitation',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Verifies the email associated with the provided key.
     *
     * Accepts the following POST parameter: key.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static apiV5VerifyEmailCreate(data: ApiV5VerifyEmailCreateData): CancelablePromise<ApiV5VerifyEmailCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/verify-email',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class ActivitiesService {
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.activityTypeDefault * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     * @param data.activityTypeDefaultIn Multiple values may be separated by commas.
     * @param data.activityTypeHidden
     * @param data.activityTypeUid
     * @param data.activityTypeUidIn Multiple values may be separated by commas.
     * @param data.dtendGt
     * @param data.dtstartLt
     * @param data.horseGroupUid
     * @param data.horseGroupUidIn Multiple values may be separated by commas.
     * @param data.horseStableUid
     * @param data.horseStableUidIn Multiple values may be separated by commas.
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.horseUserActive
     * @param data.lastDoneAndLastAndFirstFuturePerHorseAndActivityType Last done and first future per activity type and horse
     * @param data.o Which field to use when ordering the results.
     * @param data.orderItemUid
     * @param data.orderItemUidIn Multiple values may be separated by commas.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.remind
     * @param data.statusIn Multiple values may be separated by commas.
     * @returns PaginatedRealActivitiesList
     * @throws ApiError
     */
    public static activitiesList(data: ActivitiesListData): CancelablePromise<ActivitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/activities',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                activity_type__default: data.activityTypeDefault,
                activity_type__default__in: data.activityTypeDefaultIn,
                activity_type__hidden: data.activityTypeHidden,
                activity_type__uid: data.activityTypeUid,
                activity_type__uid__in: data.activityTypeUidIn,
                dtend__gt: data.dtendGt,
                dtstart__lt: data.dtstartLt,
                horse__group__uid: data.horseGroupUid,
                horse__group__uid__in: data.horseGroupUidIn,
                horse__stable__uid: data.horseStableUid,
                horse__stable__uid__in: data.horseStableUidIn,
                horse__uid__in: data.horseUidIn,
                horse__user_active: data.horseUserActive,
                lastDoneAndLastAndFirstFuturePerHorseAndActivityType: data.lastDoneAndLastAndFirstFuturePerHorseAndActivityType,
                o: data.o,
                order_item__uid: data.orderItemUid,
                order_item__uid__in: data.orderItemUidIn,
                page: data.page,
                page_size: data.pageSize,
                remind: data.remind,
                status__in: data.statusIn
            }
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns RealActivities
     * @throws ApiError
     */
    public static activitiesCreate(data: ActivitiesCreateData): CancelablePromise<ActivitiesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/activities',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns RealActivities
     * @throws ApiError
     */
    public static activitiesRetrieve(data: ActivitiesRetrieveData): CancelablePromise<ActivitiesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/activities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns RealActivitiesUpdate
     * @throws ApiError
     */
    public static activitiesUpdate(data: ActivitiesUpdateData): CancelablePromise<ActivitiesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/activities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns RealActivitiesUpdate
     * @throws ApiError
     */
    public static activitiesPartialUpdate(data: ActivitiesPartialUpdateData): CancelablePromise<ActivitiesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/activities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static activitiesDeletePartialUpdate(data: ActivitiesDeletePartialUpdateData): CancelablePromise<ActivitiesDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/activities/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns RealActivitiesSetDoneAndUnDone
     * @throws ApiError
     */
    public static activitiesSetDonePartialUpdate(data: ActivitiesSetDonePartialUpdateData): CancelablePromise<ActivitiesSetDonePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/activities/{uid}/set_done',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, update and create activities (model: RealActivities) for your organisations
     *
     * Note on facilities: You can provide one or more facilities where this event should be hosted
     * (see Facilities API). Doing so will 'book' that facility, but only if it is available for the
     * indicated event period and has room for the event's horses. If you *update* the subsequent
     * event you *must* provide the required facilities in the partial update. If you were to leave
     * them out, the corresponding FacilityEvent (see FacilityEvents API) will be deleted, meaning the
     * facility would no longer be planned for your event.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns RealActivitiesSetDoneAndUnDone
     * @throws ApiError
     */
    public static activitiesSetUndonePartialUpdate(data: ActivitiesSetUndonePartialUpdateData): CancelablePromise<ActivitiesSetUndonePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/activities/{uid}/set_undone',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Returns all contacts needed for activities, by looking up the ExtraInfoSettings.roles of the ActivityType and returning all contacts with those roles.
     *
     * Filters on the ActivityTypes the user has access to.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedShallowContactList
     * @throws ApiError
     */
    public static activitiesContactsList(data: ActivitiesContactsListData): CancelablePromise<ActivitiesContactsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/activities/contacts',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
}

export class ActivitytypepricesService {
    /**
     * @param data The data for the request.
     * @param data.activityTypeOrganisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns ActivityTypePrice
     * @throws ApiError
     */
    public static activitytypepricesList(data: ActivitytypepricesListData): CancelablePromise<ActivitytypepricesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{activity_type__organisation__uid}/activitytypeprices',
            path: {
                activity_type__organisation__uid: data.activityTypeOrganisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.activityTypeOrganisationUid
     * @param data.requestBody
     * @returns ActivityTypePrice
     * @throws ApiError
     */
    public static activitytypepricesCreate(data: ActivitytypepricesCreateData): CancelablePromise<ActivitytypepricesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{activity_type__organisation__uid}/activitytypeprices',
            path: {
                activity_type__organisation__uid: data.activityTypeOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.activityTypeOrganisationUid
     * @param data.uid
     * @returns ActivityTypePrice
     * @throws ApiError
     */
    public static activitytypepricesRetrieve(data: ActivitytypepricesRetrieveData): CancelablePromise<ActivitytypepricesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{activity_type__organisation__uid}/activitytypeprices/{uid}',
            path: {
                activity_type__organisation__uid: data.activityTypeOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.activityTypeOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ActivityTypePrice
     * @throws ApiError
     */
    public static activitytypepricesUpdate(data: ActivitytypepricesUpdateData): CancelablePromise<ActivitytypepricesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{activity_type__organisation__uid}/activitytypeprices/{uid}',
            path: {
                activity_type__organisation__uid: data.activityTypeOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.activityTypeOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ActivityTypePrice
     * @throws ApiError
     */
    public static activitytypepricesPartialUpdate(data: ActivitytypepricesPartialUpdateData): CancelablePromise<ActivitytypepricesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{activity_type__organisation__uid}/activitytypeprices/{uid}',
            path: {
                activity_type__organisation__uid: data.activityTypeOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.activityTypeOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static activitytypepricesDestroy(data: ActivitytypepricesDestroyData): CancelablePromise<ActivitytypepricesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{activity_type__organisation__uid}/activitytypeprices/{uid}',
            path: {
                activity_type__organisation__uid: data.activityTypeOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class ActivitytypesService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns ActivityType
     * @throws ApiError
     */
    public static activitytypesList(data: ActivitytypesListData): CancelablePromise<ActivitytypesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/activitytypes',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns ActivityType
     * @throws ApiError
     */
    public static activitytypesCreate(data: ActivitytypesCreateData): CancelablePromise<ActivitytypesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/activitytypes',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns ActivityType
     * @throws ApiError
     */
    public static activitytypesRetrieve(data: ActivitytypesRetrieveData): CancelablePromise<ActivitytypesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/activitytypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ActivityType
     * @throws ApiError
     */
    public static activitytypesUpdate(data: ActivitytypesUpdateData): CancelablePromise<ActivitytypesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/activitytypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ActivityType
     * @throws ApiError
     */
    public static activitytypesPartialUpdate(data: ActivitytypesPartialUpdateData): CancelablePromise<ActivitytypesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/activitytypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static activitytypesDestroy(data: ActivitytypesDestroyData): CancelablePromise<ActivitytypesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/activitytypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class ApiService {
    /**
     * Retrieve or update notification settings, lookup by user_id.
     * @returns NotificationSettings
     * @throws ApiError
     */
    public static apiV5DeviceList(): CancelablePromise<ApiV5DeviceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/device'
        });
    }
    
    /**
     * @returns CustomFCMDevice
     * @throws ApiError
     */
    public static apiV5DeviceFcmList(): CancelablePromise<ApiV5DeviceFcmListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/device/fcm'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CustomFCMDevice
     * @throws ApiError
     */
    public static apiV5DeviceFcmCreate(data: ApiV5DeviceFcmCreateData): CancelablePromise<ApiV5DeviceFcmCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/device/fcm',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.registrationId
     * @returns CustomFCMDevice
     * @throws ApiError
     */
    public static apiV5DeviceFcmRetrieve(data: ApiV5DeviceFcmRetrieveData): CancelablePromise<ApiV5DeviceFcmRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/device/fcm/{registration_id}',
            path: {
                registration_id: data.registrationId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.registrationId
     * @param data.requestBody
     * @returns CustomFCMDevice
     * @throws ApiError
     */
    public static apiV5DeviceFcmUpdate(data: ApiV5DeviceFcmUpdateData): CancelablePromise<ApiV5DeviceFcmUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/device/fcm/{registration_id}',
            path: {
                registration_id: data.registrationId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.registrationId
     * @param data.requestBody
     * @returns CustomFCMDevice
     * @throws ApiError
     */
    public static apiV5DeviceFcmPartialUpdate(data: ApiV5DeviceFcmPartialUpdateData): CancelablePromise<ApiV5DeviceFcmPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/device/fcm/{registration_id}',
            path: {
                registration_id: data.registrationId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.registrationId
     * @returns void No response body
     * @throws ApiError
     */
    public static apiV5DeviceFcmDestroy(data: ApiV5DeviceFcmDestroyData): CancelablePromise<ApiV5DeviceFcmDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/device/fcm/{registration_id}',
            path: {
                registration_id: data.registrationId
            }
        });
    }
    
    /**
     * Retrieve or update notification settings, lookup by user_id.
     * @returns NotificationSettings
     * @throws ApiError
     */
    public static apiV5DeviceFcmSettingsRetrieve(): CancelablePromise<ApiV5DeviceFcmSettingsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/device/fcm_settings'
        });
    }
    
    /**
     * Retrieve or update notification settings, lookup by user_id.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns NotificationSettings
     * @throws ApiError
     */
    public static apiV5DeviceFcmSettingsPartialUpdate(data: ApiV5DeviceFcmSettingsPartialUpdateData = {}): CancelablePromise<ApiV5DeviceFcmSettingsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/device/fcm_settings',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve or update notification settings, lookup by user_id.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns NotificationSettings
     * @throws ApiError
     */
    public static apiV5DeviceFcmSettingsPatchPartialUpdate(data: ApiV5DeviceFcmSettingsPatchPartialUpdateData = {}): CancelablePromise<ApiV5DeviceFcmSettingsPatchPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/device/fcm_settings_patch',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * For example (for testing):
     * https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?response_type=code&client_id=cf028e96-8736-4aaa-bb45-1977d4e24634&redirect_uri=https://app.equinem.com/microsoft/login/callback&scope=User.ReadBasic.All+openid+offline_access&code_challenge_method:S256&code_challenge=nA04yKkP7OWo5OimF8PT-cELJZ5TmjC4W_85JYY4aCQ
     *
     *
     * Code challenge can be generated here: https://example-app.com/pkce
     * @param data The data for the request.
     * @param data.requestBody
     * @returns JWT
     * @throws ApiError
     */
    public static apiV5OauthUserMicrosoftLoginCreate(data: ApiV5OauthUserMicrosoftLoginCreateData = {}): CancelablePromise<ApiV5OauthUserMicrosoftLoginCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/oauthUser/microsoft/login',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.isGeneric
     * @param data.module Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.moduleIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.pricingModel * `FLAT_FEE` - flat fee
     * * `STAIR_STEP` - stair step
     * * `TIERED` - tiered
     * * `CREDITS` - credits
     * @param data.pricingModelIn Multiple values may be separated by commas.
     * @returns Plan
     * @throws ApiError
     */
    public static apiV5PlansList(data: ApiV5PlansListData = {}): CancelablePromise<ApiV5PlansListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/plans',
            query: {
                is_generic: data.isGeneric,
                module: data.module,
                module__in: data.moduleIn,
                o: data.o,
                pricing_model: data.pricingModel,
                pricing_model__in: data.pricingModelIn
            }
        });
    }
}

export class AvailabilityService {
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.availabilityType * `sick` - Sick
     * * `leave` - Leave
     * * `overtime` - Overtime
     * @param data.availabilityTypeIn Multiple values may be separated by commas.
     * @param data.dtendGt
     * @param data.dtstartLt
     * @param data.employmentUid
     * @param data.employmentUidIn Multiple values may be separated by commas.
     * @param data.hasLeaveAllowanceImpact
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.statusIn Multiple values may be separated by commas.
     * @returns PaginatedAvailabilityList
     * @throws ApiError
     */
    public static availabilityEmployeeList(data: AvailabilityEmployeeListData): CancelablePromise<AvailabilityEmployeeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/availability/employee',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                availability_type: data.availabilityType,
                availability_type__in: data.availabilityTypeIn,
                dtend__gt: data.dtendGt,
                dtstart__lt: data.dtstartLt,
                employment__uid: data.employmentUid,
                employment__uid__in: data.employmentUidIn,
                has_leave_allowance_impact: data.hasLeaveAllowanceImpact,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                status__in: data.statusIn
            }
        });
    }
    
    /**
     * Override the create method to add created_by_contact and created_by_employee fields.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Availability
     * @throws ApiError
     */
    public static availabilityEmployeeCreate(data: AvailabilityEmployeeCreateData): CancelablePromise<AvailabilityEmployeeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/availability/employee',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Availability
     * @throws ApiError
     */
    public static availabilityEmployeeRetrieve(data: AvailabilityEmployeeRetrieveData): CancelablePromise<AvailabilityEmployeeRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns AvailabilityEmployeeUpdate
     * @throws ApiError
     */
    public static availabilityEmployeeUpdate(data: AvailabilityEmployeeUpdateData): CancelablePromise<AvailabilityEmployeeUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns AvailabilityEmployeeUpdate
     * @throws ApiError
     */
    public static availabilityEmployeePartialUpdate(data: AvailabilityEmployeePartialUpdateData): CancelablePromise<AvailabilityEmployeePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Checks if the Availability is eligible for deletion.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static availabilityEmployeeDeletePartialUpdate(data: AvailabilityEmployeeDeletePartialUpdateData): CancelablePromise<AvailabilityEmployeeDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.availabilityType * `sick` - Sick
     * * `leave` - Leave
     * * `overtime` - Overtime
     * @param data.availabilityTypeIn Multiple values may be separated by commas.
     * @param data.contactUid
     * @param data.contactUidIn Multiple values may be separated by commas.
     * @param data.dtendGt
     * @param data.dtstartLt
     * @param data.employmentUid
     * @param data.employmentUidIn Multiple values may be separated by commas.
     * @param data.hasLeaveAllowanceImpact
     * @param data.o Which field to use when ordering the results.
     * @param data.statusIn Multiple values may be separated by commas.
     * @returns AvailabilityManager
     * @throws ApiError
     */
    public static availabilityManagerList(data: AvailabilityManagerListData): CancelablePromise<AvailabilityManagerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                availability_type: data.availabilityType,
                availability_type__in: data.availabilityTypeIn,
                contact__uid: data.contactUid,
                contact__uid__in: data.contactUidIn,
                dtend__gt: data.dtendGt,
                dtstart__lt: data.dtstartLt,
                employment__uid: data.employmentUid,
                employment__uid__in: data.employmentUidIn,
                has_leave_allowance_impact: data.hasLeaveAllowanceImpact,
                o: data.o,
                status__in: data.statusIn
            }
        });
    }
    
    /**
     * Override the create method to add created_by_contact and created_by_employee fields.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns AvailabilityManager
     * @throws ApiError
     */
    public static availabilityManagerCreate(data: AvailabilityManagerCreateData): CancelablePromise<AvailabilityManagerCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns AvailabilityManager
     * @throws ApiError
     */
    public static availabilityManagerRetrieve(data: AvailabilityManagerRetrieveData): CancelablePromise<AvailabilityManagerRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns AvailabilityManagerUpdate
     * @throws ApiError
     */
    public static availabilityManagerUpdate(data: AvailabilityManagerUpdateData): CancelablePromise<AvailabilityManagerUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns AvailabilityManagerUpdate
     * @throws ApiError
     */
    public static availabilityManagerPartialUpdate(data: AvailabilityManagerPartialUpdateData): CancelablePromise<AvailabilityManagerPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static availabilityManagerApprovePartialUpdate(data: AvailabilityManagerApprovePartialUpdateData): CancelablePromise<AvailabilityManagerApprovePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/approve',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Availability objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns AvailabilityApproveDecline
     * @throws ApiError
     */
    public static availabilityManagerCancelPartialUpdate(data: AvailabilityManagerCancelPartialUpdateData): CancelablePromise<AvailabilityManagerCancelPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/cancel',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Checks if the Availability is eligible for deletion.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static availabilityManagerDeletePartialUpdate(data: AvailabilityManagerDeletePartialUpdateData): CancelablePromise<AvailabilityManagerDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Rejects a leave request. This method can only be used by a manager.
     *
     * :param request: the request to process
     * :returns: Response with
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns AvailabilityApproveDecline
     * @throws ApiError
     */
    public static availabilityManagerRejectPartialUpdate(data: AvailabilityManagerRejectPartialUpdateData): CancelablePromise<AvailabilityManagerRejectPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/reject',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class BillableitemsService {
    /**
     * Billable items are created whenever an organisation supplies something that can be billed to a customer
     * This endpoint provides the supplying organisation with overviews of items that can be billed, have been
     * billed or should not be billed. These groups are mutually exclusive, proper subsets of the organisation's
     * billable items
     *
     * To invoice or not to invoice: you can move billable items form the to_invoice to the not_to_invoice group
     * (and vice-versa) by setting `hidden` True (and vice-versa)
     *
     * Billable items created from an activity will have that linked over `activity`. If there are other reasons
     * for relating a billable item to activities, that is set (and can be patched) over `related_acitivities`,
     * for example when the transaction item source was related to an activity.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns BillableItem
     * @throws ApiError
     */
    public static billableitemsUpdate(data: BillableitemsUpdateData): CancelablePromise<BillableitemsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/billableitems/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Billable items are created whenever an organisation supplies something that can be billed to a customer
     * This endpoint provides the supplying organisation with overviews of items that can be billed, have been
     * billed or should not be billed. These groups are mutually exclusive, proper subsets of the organisation's
     * billable items
     *
     * To invoice or not to invoice: you can move billable items form the to_invoice to the not_to_invoice group
     * (and vice-versa) by setting `hidden` True (and vice-versa)
     *
     * Billable items created from an activity will have that linked over `activity`. If there are other reasons
     * for relating a billable item to activities, that is set (and can be patched) over `related_acitivities`,
     * for example when the transaction item source was related to an activity.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns BillableItem
     * @throws ApiError
     */
    public static billableitemsPartialUpdate(data: BillableitemsPartialUpdateData): CancelablePromise<BillableitemsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/billableitems/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Returns billable items that are already invoiced
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.activityActivityTypeDefault * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     * @param data.activityActivityTypeDefaultIn Multiple values may be separated by commas.
     * @param data.activityUid
     * @param data.activityUidIn Multiple values may be separated by commas.
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.endDtGte
     * @param data.endDtLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.invoiceItemUid
     * @param data.invoiceItemUidIn Multiple values may be separated by commas.
     * @param data.isActivity
     * @param data.isOrderItem
     * @param data.isServiceContract
     * @param data.isTransactionItem
     * @param data.o Which field to use when ordering the results.
     * @param data.orderItemUid
     * @param data.orderItemUidIn Multiple values may be separated by commas.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.serviceContractProductPlanModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.serviceContractProductPlanModuleIn Multiple values may be separated by commas.
     * @param data.serviceContractUid
     * @param data.serviceContractUidIn Multiple values may be separated by commas.
     * @param data.startDtGte
     * @param data.startDtLte
     * @param data.transactionItemUid
     * @param data.transactionItemUidIn Multiple values may be separated by commas.
     * @returns PaginatedBillableItemList
     * @throws ApiError
     */
    public static billableitemsInvoicedList(data: BillableitemsInvoicedListData): CancelablePromise<BillableitemsInvoicedListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/billableitems/invoiced',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                activity__activity_type__default: data.activityActivityTypeDefault,
                activity__activity_type__default__in: data.activityActivityTypeDefaultIn,
                activity__uid: data.activityUid,
                activity__uid__in: data.activityUidIn,
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                end_dt__gte: data.endDtGte,
                end_dt__lte: data.endDtLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                invoice_item__uid: data.invoiceItemUid,
                invoice_item__uid__in: data.invoiceItemUidIn,
                is_activity: data.isActivity,
                is_order_item: data.isOrderItem,
                is_service_contract: data.isServiceContract,
                is_transaction_item: data.isTransactionItem,
                o: data.o,
                order_item__uid: data.orderItemUid,
                order_item__uid__in: data.orderItemUidIn,
                page: data.page,
                page_size: data.pageSize,
                service_contract__product__plan__module: data.serviceContractProductPlanModule,
                service_contract__product__plan__module__in: data.serviceContractProductPlanModuleIn,
                service_contract__uid: data.serviceContractUid,
                service_contract__uid__in: data.serviceContractUidIn,
                start_dt__gte: data.startDtGte,
                start_dt__lte: data.startDtLte,
                transaction_item__uid: data.transactionItemUid,
                transaction_item__uid__in: data.transactionItemUidIn
            }
        });
    }
    
    /**
     * Returns billable items that should not be invoiced
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.activityActivityTypeDefault * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     * @param data.activityActivityTypeDefaultIn Multiple values may be separated by commas.
     * @param data.activityUid
     * @param data.activityUidIn Multiple values may be separated by commas.
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.endDtGte
     * @param data.endDtLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.invoiceItemUid
     * @param data.invoiceItemUidIn Multiple values may be separated by commas.
     * @param data.isActivity
     * @param data.isOrderItem
     * @param data.isServiceContract
     * @param data.isTransactionItem
     * @param data.o Which field to use when ordering the results.
     * @param data.orderItemUid
     * @param data.orderItemUidIn Multiple values may be separated by commas.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.serviceContractProductPlanModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.serviceContractProductPlanModuleIn Multiple values may be separated by commas.
     * @param data.serviceContractUid
     * @param data.serviceContractUidIn Multiple values may be separated by commas.
     * @param data.startDtGte
     * @param data.startDtLte
     * @param data.transactionItemUid
     * @param data.transactionItemUidIn Multiple values may be separated by commas.
     * @returns PaginatedBillableItemList
     * @throws ApiError
     */
    public static billableitemsNotToInvoiceList(data: BillableitemsNotToInvoiceListData): CancelablePromise<BillableitemsNotToInvoiceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/billableitems/not_to_invoice',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                activity__activity_type__default: data.activityActivityTypeDefault,
                activity__activity_type__default__in: data.activityActivityTypeDefaultIn,
                activity__uid: data.activityUid,
                activity__uid__in: data.activityUidIn,
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                end_dt__gte: data.endDtGte,
                end_dt__lte: data.endDtLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                invoice_item__uid: data.invoiceItemUid,
                invoice_item__uid__in: data.invoiceItemUidIn,
                is_activity: data.isActivity,
                is_order_item: data.isOrderItem,
                is_service_contract: data.isServiceContract,
                is_transaction_item: data.isTransactionItem,
                o: data.o,
                order_item__uid: data.orderItemUid,
                order_item__uid__in: data.orderItemUidIn,
                page: data.page,
                page_size: data.pageSize,
                service_contract__product__plan__module: data.serviceContractProductPlanModule,
                service_contract__product__plan__module__in: data.serviceContractProductPlanModuleIn,
                service_contract__uid: data.serviceContractUid,
                service_contract__uid__in: data.serviceContractUidIn,
                start_dt__gte: data.startDtGte,
                start_dt__lte: data.startDtLte,
                transaction_item__uid: data.transactionItemUid,
                transaction_item__uid__in: data.transactionItemUidIn
            }
        });
    }
    
    /**
     * Returns billable items that can be invoiced.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.activityActivityTypeDefault * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     * @param data.activityActivityTypeDefaultIn Multiple values may be separated by commas.
     * @param data.activityUid
     * @param data.activityUidIn Multiple values may be separated by commas.
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.endDtGte
     * @param data.endDtLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.invoiceItemUid
     * @param data.invoiceItemUidIn Multiple values may be separated by commas.
     * @param data.isActivity
     * @param data.isOrderItem
     * @param data.isServiceContract
     * @param data.isTransactionItem
     * @param data.o Which field to use when ordering the results.
     * @param data.orderItemUid
     * @param data.orderItemUidIn Multiple values may be separated by commas.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.serviceContractProductPlanModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.serviceContractProductPlanModuleIn Multiple values may be separated by commas.
     * @param data.serviceContractUid
     * @param data.serviceContractUidIn Multiple values may be separated by commas.
     * @param data.startDtGte
     * @param data.startDtLte
     * @param data.transactionItemUid
     * @param data.transactionItemUidIn Multiple values may be separated by commas.
     * @returns PaginatedBillableItemList
     * @throws ApiError
     */
    public static billableitemsToInvoiceList(data: BillableitemsToInvoiceListData): CancelablePromise<BillableitemsToInvoiceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/billableitems/to_invoice',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                activity__activity_type__default: data.activityActivityTypeDefault,
                activity__activity_type__default__in: data.activityActivityTypeDefaultIn,
                activity__uid: data.activityUid,
                activity__uid__in: data.activityUidIn,
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                end_dt__gte: data.endDtGte,
                end_dt__lte: data.endDtLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                invoice_item__uid: data.invoiceItemUid,
                invoice_item__uid__in: data.invoiceItemUidIn,
                is_activity: data.isActivity,
                is_order_item: data.isOrderItem,
                is_service_contract: data.isServiceContract,
                is_transaction_item: data.isTransactionItem,
                o: data.o,
                order_item__uid: data.orderItemUid,
                order_item__uid__in: data.orderItemUidIn,
                page: data.page,
                page_size: data.pageSize,
                service_contract__product__plan__module: data.serviceContractProductPlanModule,
                service_contract__product__plan__module__in: data.serviceContractProductPlanModuleIn,
                service_contract__uid: data.serviceContractUid,
                service_contract__uid__in: data.serviceContractUidIn,
                start_dt__gte: data.startDtGte,
                start_dt__lte: data.startDtLte,
                transaction_item__uid: data.transactionItemUid,
                transaction_item__uid__in: data.transactionItemUidIn
            }
        });
    }
}

export class BreedingplanService {
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.mareUid
     * @param data.mareUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.usageType * `KI` - KI (self-pregnancy)
     * * `ET` - ET
     * * `ICSI` - ICSI
     * @param data.usageTypeIn Multiple values may be separated by commas.
     * @param data.year
     * @param data.yearGt
     * @param data.yearGte
     * @param data.yearLt
     * @param data.yearLte
     * @returns PaginatedBreedingPlanList
     * @throws ApiError
     */
    public static breedingplanList(data: BreedingplanListData): CancelablePromise<BreedingplanListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan',
            path: {
                mare__organisation__uid: data.mareOrganisationUid
            },
            query: {
                mare__uid: data.mareUid,
                mare__uid__in: data.mareUidIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                usage_type: data.usageType,
                usage_type__in: data.usageTypeIn,
                year: data.year,
                year__gt: data.yearGt,
                year__gte: data.yearGte,
                year__lt: data.yearLt,
                year__lte: data.yearLte
            }
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.requestBody
     * @returns BreedingPlan
     * @throws ApiError
     */
    public static breedingplanCreate(data: BreedingplanCreateData): CancelablePromise<BreedingplanCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan',
            path: {
                mare__organisation__uid: data.mareOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @returns BreedingPlan
     * @throws ApiError
     */
    public static breedingplanRetrieve(data: BreedingplanRetrieveData): CancelablePromise<BreedingplanRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns BreedingPlan
     * @throws ApiError
     */
    public static breedingplanUpdate(data: BreedingplanUpdateData): CancelablePromise<BreedingplanUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns BreedingPlan
     * @throws ApiError
     */
    public static breedingplanPartialUpdate(data: BreedingplanPartialUpdateData): CancelablePromise<BreedingplanPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static breedingplanDestroy(data: BreedingplanDestroyData): CancelablePromise<BreedingplanDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class CategoriesService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns Category
     * @throws ApiError
     */
    public static categoriesList(data: CategoriesListData): CancelablePromise<CategoriesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/categories',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Category
     * @throws ApiError
     */
    public static categoriesCreate(data: CategoriesCreateData): CancelablePromise<CategoriesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/categories',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Category
     * @throws ApiError
     */
    public static categoriesRetrieve(data: CategoriesRetrieveData): CancelablePromise<CategoriesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/categories/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Category
     * @throws ApiError
     */
    public static categoriesUpdate(data: CategoriesUpdateData): CancelablePromise<CategoriesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/categories/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Category
     * @throws ApiError
     */
    public static categoriesPartialUpdate(data: CategoriesPartialUpdateData): CancelablePromise<CategoriesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/categories/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static categoriesDestroy(data: CategoriesDestroyData): CancelablePromise<CategoriesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/categories/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class ContactsService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.hidden
     * @param data.isDuplicate
     * @param data.isInseminationStation
     * @param data.isSemenCollectionStation
     * @param data.isStable
     * @param data.isUser
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.purchaserContact
     * @param data.useForPicking
     * @param data.userUid
     * @returns PaginatedContactList
     * @throws ApiError
     */
    public static contactsList(data: ContactsListData): CancelablePromise<ContactsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/contacts',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                hidden: data.hidden,
                is_duplicate: data.isDuplicate,
                is_insemination_station: data.isInseminationStation,
                is_semen_collection_station: data.isSemenCollectionStation,
                is_stable: data.isStable,
                is_user: data.isUser,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                purchaser_contact: data.purchaserContact,
                use_for_picking: data.useForPicking,
                user__uid: data.userUid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns ContactDetail
     * @throws ApiError
     */
    public static contactsCreate(data: ContactsCreateData): CancelablePromise<ContactsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/contacts',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns ContactDetail
     * @throws ApiError
     */
    public static contactsRetrieve(data: ContactsRetrieveData): CancelablePromise<ContactsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ContactDetail
     * @throws ApiError
     */
    public static contactsUpdate(data: ContactsUpdateData): CancelablePromise<ContactsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ContactDetail
     * @throws ApiError
     */
    public static contactsPartialUpdate(data: ContactsPartialUpdateData): CancelablePromise<ContactsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static contactsDestroy(data: ContactsDestroyData): CancelablePromise<ContactsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Sets up authorization for doing reports to RvO.
     * UBN, postcode, address_line1, addres_line3, city, country should be given on the contact.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static contactsAuthorizeRvoCreate(data: ContactsAuthorizeRvoCreateData): CancelablePromise<ContactsAuthorizeRvoCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}/authorize_rvo',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static contactsAuthorizeRvoDestroy(data: ContactsAuthorizeRvoDestroyData): CancelablePromise<ContactsAuthorizeRvoDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}/authorize_rvo',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Checks the authorization by RvO of a UBN (from a contact).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static contactsCheckAuthorizationRvoCreate(data: ContactsCheckAuthorizationRvoCreateData): CancelablePromise<ContactsCheckAuthorizationRvoCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}/check_authorization_rvo',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static contactsIgnoreForDuplicatePartialUpdate(data: ContactsIgnoreForDuplicatePartialUpdateData): CancelablePromise<ContactsIgnoreForDuplicatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}/ignore_for_duplicate',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Merge another contact into this resource and optionally update its fields. The other contact will be deleted.
     *
     * All the relations of the `merge_with_uid` contact - the 'alias' will be updated and reference this contact.
     * E.g. an invoice referencing the alias will reference this resource hereafter. This resource will keep its own
     * fields when set and get alias' values when empty, but set on alias. This can be overridden by supplying field
     * names and values like in a regular PATCH request.
     *
     * **NOTE** If the alias cannot be deleted (e.g. because the contact is the default stable contact), but this
     * resource can, then the roles are reversed: `merge_with_uid` is kept and this contact is deleted.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns MergeContacts
     * @throws ApiError
     */
    public static contactsMergeAndUpdatePartialUpdate(data: ContactsMergeAndUpdatePartialUpdateData): CancelablePromise<ContactsMergeAndUpdatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/contacts/{uid}/merge_and_update',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.hidden
     * @param data.isDuplicate
     * @param data.isInseminationStation
     * @param data.isSemenCollectionStation
     * @param data.isStable
     * @param data.isUser
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.purchaserContact
     * @param data.useForPicking
     * @param data.userUid
     * @returns PaginatedContactDetailList
     * @throws ApiError
     */
    public static contactsDuplicatesList(data: ContactsDuplicatesListData): CancelablePromise<ContactsDuplicatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/contacts/duplicates',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                hidden: data.hidden,
                is_duplicate: data.isDuplicate,
                is_insemination_station: data.isInseminationStation,
                is_semen_collection_station: data.isSemenCollectionStation,
                is_stable: data.isStable,
                is_user: data.isUser,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                purchaser_contact: data.purchaserContact,
                use_for_picking: data.useForPicking,
                user__uid: data.userUid
            }
        });
    }
}

export class DailynoteService {
    /**
     * List all DailyJobs.
     *
     * If no filter is included at all, it only shows today.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.dtendGt
     * @param data.dtstartLt
     * @param data.executable
     * @param data.noStable
     * @param data.o Which field to use when ordering the results.
     * @param data.stableUid
     * @param data.stableUidIn Multiple values may be separated by commas.
     * @param data.statusIn Multiple values may be separated by commas.
     * @returns DailyNote
     * @throws ApiError
     */
    public static dailynoteList(data: DailynoteListData): CancelablePromise<DailynoteListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/dailynote',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                dtend__gt: data.dtendGt,
                dtstart__lt: data.dtstartLt,
                executable: data.executable,
                no_stable: data.noStable,
                o: data.o,
                stable__uid: data.stableUid,
                stable__uid__in: data.stableUidIn,
                status__in: data.statusIn
            }
        });
    }
    
    /**
     * List all DailyJobs.
     *
     * If no filter is included at all, it only shows today.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns DailyNote
     * @throws ApiError
     */
    public static dailynoteCreate(data: DailynoteCreateData): CancelablePromise<DailynoteCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/dailynote',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List all DailyJobs.
     *
     * If no filter is included at all, it only shows today.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns DailyNote
     * @throws ApiError
     */
    public static dailynoteRetrieve(data: DailynoteRetrieveData): CancelablePromise<DailynoteRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/dailynote/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * List all DailyJobs.
     *
     * If no filter is included at all, it only shows today.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns DailyNoteUpdate
     * @throws ApiError
     */
    public static dailynoteUpdate(data: DailynoteUpdateData): CancelablePromise<DailynoteUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/dailynote/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List all DailyJobs.
     *
     * If no filter is included at all, it only shows today.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns DailyNoteUpdate
     * @throws ApiError
     */
    public static dailynotePartialUpdate(data: DailynotePartialUpdateData): CancelablePromise<DailynotePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/dailynote/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List all DailyJobs.
     *
     * If no filter is included at all, it only shows today.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static dailynoteDeletePartialUpdate(data: DailynoteDeletePartialUpdateData): CancelablePromise<DailynoteDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/dailynote/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Set the daily job done.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns DailyNoteSetDoneAndUnDone
     * @throws ApiError
     */
    public static dailynoteSetDonePartialUpdate(data: DailynoteSetDonePartialUpdateData): CancelablePromise<DailynoteSetDonePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/dailynote/{uid}/set_done',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Set the daily job done.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns DailyNoteSetDoneAndUnDone
     * @throws ApiError
     */
    public static dailynoteSetUndonePartialUpdate(data: DailynoteSetUndonePartialUpdateData): CancelablePromise<DailynoteSetUndonePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/dailynote/{uid}/set_undone',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class DaypartsService {
    /**
     * Retrieve, update or delete an stable day session instance.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns DayPartStartTime
     * @throws ApiError
     */
    public static daypartsList(data: DaypartsListData): CancelablePromise<DaypartsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/dayparts',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * Retrieve, update or delete an stable day session instance.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns DayPartStartTime
     * @throws ApiError
     */
    public static daypartsCreate(data: DaypartsCreateData): CancelablePromise<DaypartsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/dayparts',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve, update or delete an stable day session instance.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns DayPartStartTime
     * @throws ApiError
     */
    public static daypartsRetrieve(data: DaypartsRetrieveData): CancelablePromise<DaypartsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/dayparts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Retrieve, update or delete an stable day session instance.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns DayPartStartTime
     * @throws ApiError
     */
    public static daypartsUpdate(data: DaypartsUpdateData): CancelablePromise<DaypartsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/dayparts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve, update or delete an stable day session instance.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns DayPartStartTime
     * @throws ApiError
     */
    public static daypartsPartialUpdate(data: DaypartsPartialUpdateData): CancelablePromise<DaypartsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/dayparts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve, update or delete an stable day session instance.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static daypartsDestroy(data: DaypartsDestroyData): CancelablePromise<DaypartsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/dayparts/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class EmploymentService {
    /**
     * List Employments for a contact.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.all
     * @param data.o
     * @returns Employment
     * @throws ApiError
     */
    public static employmentEmployeeList(data: EmploymentEmployeeListData): CancelablePromise<EmploymentEmployeeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/employment/employee',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                all: data.all,
                o: data.o
            }
        });
    }
    
    /**
     * List Employments. Overridden from ModelViewSet because of the extra filters.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.all
     * @param data.contactUid
     * @param data.o
     * @returns Employment
     * @throws ApiError
     */
    public static employmentManagerList(data: EmploymentManagerListData): CancelablePromise<EmploymentManagerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/employment/manager',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                all: data.all,
                contact_uid: data.contactUid,
                o: data.o
            }
        });
    }
    
    /**
     * View set for the Employment objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Employment
     * @throws ApiError
     */
    public static employmentManagerCreate(data: EmploymentManagerCreateData): CancelablePromise<EmploymentManagerCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/employment/manager',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Employment objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Employment
     * @throws ApiError
     */
    public static employmentManagerRetrieve(data: EmploymentManagerRetrieveData): CancelablePromise<EmploymentManagerRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Update an Employment. Overridden from ModelViewSet because the
     * Employment object can be renewed in the process.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Employment
     * @throws ApiError
     */
    public static employmentManagerUpdate(data: EmploymentManagerUpdateData): CancelablePromise<EmploymentManagerUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Overridden to drop the inheritance of the UpdateModelMixin.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Employment
     * @throws ApiError
     */
    public static employmentManagerPartialUpdate(data: EmploymentManagerPartialUpdateData): CancelablePromise<EmploymentManagerPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Employment objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static employmentManagerDestroy(data: EmploymentManagerDestroyData): CancelablePromise<EmploymentManagerDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class EventfeedsService {
    /**
     * activity_type_uids (optional) needs to be a commaseperated list (without spaces)
     *
     * horse_uids (optional) needs to be a commaseperated list (without spaces)
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns EventFeeds
     * @throws ApiError
     */
    public static eventfeedsList(data: EventfeedsListData): CancelablePromise<EventfeedsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/eventfeeds',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * activity_type_uids (optional) needs to be a commaseperated list (without spaces)
     *
     * horse_uids (optional) needs to be a commaseperated list (without spaces)
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns EventFeeds
     * @throws ApiError
     */
    public static eventfeedsCreate(data: EventfeedsCreateData): CancelablePromise<EventfeedsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/eventfeeds',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * activity_type_uids (optional) needs to be a commaseperated list (without spaces)
     *
     * horse_uids (optional) needs to be a commaseperated list (without spaces)
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns EventFeeds
     * @throws ApiError
     */
    public static eventfeedsRetrieve(data: EventfeedsRetrieveData): CancelablePromise<EventfeedsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/eventfeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * activity_type_uids (optional) needs to be a commaseperated list (without spaces)
     *
     * horse_uids (optional) needs to be a commaseperated list (without spaces)
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns EventFeeds
     * @throws ApiError
     */
    public static eventfeedsUpdate(data: EventfeedsUpdateData): CancelablePromise<EventfeedsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/eventfeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * activity_type_uids (optional) needs to be a commaseperated list (without spaces)
     *
     * horse_uids (optional) needs to be a commaseperated list (without spaces)
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns EventFeeds
     * @throws ApiError
     */
    public static eventfeedsPartialUpdate(data: EventfeedsPartialUpdateData): CancelablePromise<EventfeedsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/eventfeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * activity_type_uids (optional) needs to be a commaseperated list (without spaces)
     *
     * horse_uids (optional) needs to be a commaseperated list (without spaces)
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static eventfeedsDestroy(data: EventfeedsDestroyData): CancelablePromise<EventfeedsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/eventfeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class FacilitiesService {
    /**
     * List, edit and create Facilities for a stable. Limitations like facility opening hours are
     * optional and applied in validation when a facility is planned by means of a FacilityEvent.
     * Leaving out a limitation (like max_hours_per_event) will be interpreted as if there is no
     * limit on said attribute.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.availableFromLte
     * @param data.availableToGte
     * @param data.facilityType * `TRANSPORT` - Transport
     * * `WATER_TREADMILL` - Water treadmill
     * * `INDOOR_ARENA` - Indoor arena
     * * `OUTDOOR_ARENA` - Outdoor arena
     * * `GALLOPING_TRACK` - Galloping track
     * * `LUNGING_RING` - Lunging ring
     * * `PADDOCK` - Paddock
     * * `SOLARIUM` - Solarium
     * * `JUMPING_YARD` - Jumping yard
     * * `TREADMILL` - Treadmill
     * * `VIBRATION_PLATE` - Vibration plate
     * * `PASTURES` - Pastures
     * * `WALKER` - walker
     * * `OTHER` - other
     * @param data.facilityTypeIn Multiple values may be separated by commas.
     * @param data.hidden
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.slotCapacityGte
     * @param data.stableUid
     * @param data.stableUidIn Multiple values may be separated by commas.
     * @returns PaginatedFacilityList
     * @throws ApiError
     */
    public static facilitiesList(data: FacilitiesListData): CancelablePromise<FacilitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/facilities',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                available_from__lte: data.availableFromLte,
                available_to__gte: data.availableToGte,
                facility_type: data.facilityType,
                facility_type__in: data.facilityTypeIn,
                hidden: data.hidden,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                slot_capacity__gte: data.slotCapacityGte,
                stable__uid: data.stableUid,
                stable__uid__in: data.stableUidIn
            }
        });
    }
    
    /**
     * List, edit and create Facilities for a stable. Limitations like facility opening hours are
     * optional and applied in validation when a facility is planned by means of a FacilityEvent.
     * Leaving out a limitation (like max_hours_per_event) will be interpreted as if there is no
     * limit on said attribute.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Facility
     * @throws ApiError
     */
    public static facilitiesCreate(data: FacilitiesCreateData): CancelablePromise<FacilitiesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/facilities',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, edit and create Facilities for a stable. Limitations like facility opening hours are
     * optional and applied in validation when a facility is planned by means of a FacilityEvent.
     * Leaving out a limitation (like max_hours_per_event) will be interpreted as if there is no
     * limit on said attribute.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Facility
     * @throws ApiError
     */
    public static facilitiesRetrieve(data: FacilitiesRetrieveData): CancelablePromise<FacilitiesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/facilities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * List, edit and create Facilities for a stable. Limitations like facility opening hours are
     * optional and applied in validation when a facility is planned by means of a FacilityEvent.
     * Leaving out a limitation (like max_hours_per_event) will be interpreted as if there is no
     * limit on said attribute.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Facility
     * @throws ApiError
     */
    public static facilitiesUpdate(data: FacilitiesUpdateData): CancelablePromise<FacilitiesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/facilities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, edit and create Facilities for a stable. Limitations like facility opening hours are
     * optional and applied in validation when a facility is planned by means of a FacilityEvent.
     * Leaving out a limitation (like max_hours_per_event) will be interpreted as if there is no
     * limit on said attribute.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Facility
     * @throws ApiError
     */
    public static facilitiesPartialUpdate(data: FacilitiesPartialUpdateData): CancelablePromise<FacilitiesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/facilities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List, edit and create Facilities for a stable. Limitations like facility opening hours are
     * optional and applied in validation when a facility is planned by means of a FacilityEvent.
     * Leaving out a limitation (like max_hours_per_event) will be interpreted as if there is no
     * limit on said attribute.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static facilitiesDestroy(data: FacilitiesDestroyData): CancelablePromise<FacilitiesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/facilities/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Returns all contacts needed for activities, by looking up the ExtraInfoSettings.roles of the ActivityType and returning all contacts with those roles.
     *
     * Filters on the ActivityTypes the user has access to.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedShallowContactList
     * @throws ApiError
     */
    public static facilitiesContactsList(data: FacilitiesContactsListData): CancelablePromise<FacilitiesContactsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/facilities/contacts',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.activityActivityTypeUid
     * @param data.activityActivityTypeUidIn Multiple values may be separated by commas.
     * @param data.contactOrOwnerUid
     * @param data.createdByUid
     * @param data.dtendGt
     * @param data.dtstartLt
     * @param data.facilityStableUid
     * @param data.facilityStableUidIn Multiple values may be separated by commas.
     * @param data.facilityUid
     * @param data.facilityUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedFacilityEventList
     * @throws ApiError
     */
    public static facilitiesEventsList(data: FacilitiesEventsListData): CancelablePromise<FacilitiesEventsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/facilities/events',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                activity__activity_type__uid: data.activityActivityTypeUid,
                activity__activity_type__uid__in: data.activityActivityTypeUidIn,
                contact_or_owner__uid: data.contactOrOwnerUid,
                created_by__uid: data.createdByUid,
                dtend__gt: data.dtendGt,
                dtstart__lt: data.dtstartLt,
                facility__stable__uid: data.facilityStableUid,
                facility__stable__uid__in: data.facilityStableUidIn,
                facility__uid: data.facilityUid,
                facility__uid__in: data.facilityUidIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns FacilityEvent
     * @throws ApiError
     */
    public static facilitiesEventsCreate(data: FacilitiesEventsCreateData): CancelablePromise<FacilitiesEventsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/facilities/events',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns FacilityEvent
     * @throws ApiError
     */
    public static facilitiesEventsRetrieve(data: FacilitiesEventsRetrieveData): CancelablePromise<FacilitiesEventsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/facilities/events/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FacilityEventUpdate
     * @throws ApiError
     */
    public static facilitiesEventsUpdate(data: FacilitiesEventsUpdateData): CancelablePromise<FacilitiesEventsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/facilities/events/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FacilityEventUpdate
     * @throws ApiError
     */
    public static facilitiesEventsPartialUpdate(data: FacilitiesEventsPartialUpdateData): CancelablePromise<FacilitiesEventsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/facilities/events/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static facilitiesEventsDeletePartialUpdate(data: FacilitiesEventsDeletePartialUpdateData): CancelablePromise<FacilitiesEventsDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/facilities/events/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Returns all contacts needed for activities, by looking up the ExtraInfoSettings.roles of the ActivityType and returning all contacts with those roles.
     *
     * Filters on the ActivityTypes the user has access to.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedPublicHorseList
     * @throws ApiError
     */
    public static facilitiesHorsesList(data: FacilitiesHorsesListData): CancelablePromise<FacilitiesHorsesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/facilities/horses',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns MyFacilityEvent
     * @throws ApiError
     */
    public static facilitiesMyEventsCreate(data: FacilitiesMyEventsCreateData): CancelablePromise<FacilitiesMyEventsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/facilities/my_events',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns MyFacilityEventUpdate
     * @throws ApiError
     */
    public static facilitiesMyEventsUpdate(data: FacilitiesMyEventsUpdateData): CancelablePromise<FacilitiesMyEventsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/facilities/my_events/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns MyFacilityEventUpdate
     * @throws ApiError
     */
    public static facilitiesMyEventsPartialUpdate(data: FacilitiesMyEventsPartialUpdateData): CancelablePromise<FacilitiesMyEventsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/facilities/my_events/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * You can plan (book) a facility through means of FacilityEvents. The underlying model is an Event
     * that combines a Facility with one or more Horses and an optional RealActivities.
     *
     * Typically, users may create events as long as the facilities time related constraints are respected.
     * Users may edit and delete their own facility events (again, respecting said constraints). A user who
     * is facility manager may create and edit events that fall outside said constraints and do the same for
     * events made by colleagues.
     *
     * Facility events are also created through linking facilities when creating or updating activities
     * over the organisation activities endpoints.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static facilitiesMyEventsDeletePartialUpdate(data: FacilitiesMyEventsDeletePartialUpdateData): CancelablePromise<FacilitiesMyEventsDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/facilities/my_events/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class FeedingsService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @param data.uidIn Multiple values may be separated by commas.
     * @returns Feeding
     * @throws ApiError
     */
    public static feedingsList(data: FeedingsListData): CancelablePromise<FeedingsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/feedings',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o,
                uid__in: data.uidIn
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Feeding
     * @throws ApiError
     */
    public static feedingsCreate(data: FeedingsCreateData): CancelablePromise<FeedingsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/feedings',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Feeding
     * @throws ApiError
     */
    public static feedingsRetrieve(data: FeedingsRetrieveData): CancelablePromise<FeedingsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/feedings/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Feeding
     * @throws ApiError
     */
    public static feedingsUpdate(data: FeedingsUpdateData): CancelablePromise<FeedingsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/feedings/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Feeding
     * @throws ApiError
     */
    public static feedingsPartialUpdate(data: FeedingsPartialUpdateData): CancelablePromise<FeedingsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/feedings/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static feedingsDestroy(data: FeedingsDestroyData): CancelablePromise<FeedingsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/feedings/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class FeedtypesService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.displayNameIcontains
     * @param data.hidden
     * @param data.o Which field to use when ordering the results.
     * @returns FeedType
     * @throws ApiError
     */
    public static feedtypesList(data: FeedtypesListData): CancelablePromise<FeedtypesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/feedtypes',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                display_name__icontains: data.displayNameIcontains,
                hidden: data.hidden,
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns FeedType
     * @throws ApiError
     */
    public static feedtypesCreate(data: FeedtypesCreateData): CancelablePromise<FeedtypesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/feedtypes',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns FeedType
     * @throws ApiError
     */
    public static feedtypesRetrieve(data: FeedtypesRetrieveData): CancelablePromise<FeedtypesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/feedtypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FeedType
     * @throws ApiError
     */
    public static feedtypesUpdate(data: FeedtypesUpdateData): CancelablePromise<FeedtypesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/feedtypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FeedType
     * @throws ApiError
     */
    public static feedtypesPartialUpdate(data: FeedtypesPartialUpdateData): CancelablePromise<FeedtypesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/feedtypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static feedtypesDestroy(data: FeedtypesDestroyData): CancelablePromise<FeedtypesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/feedtypes/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class HolidayeventsService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.dtend
     * @param data.dtendGt
     * @param data.dtstart
     * @param data.dtstartLt
     * @param data.o Which field to use when ordering the results.
     * @param data.year
     * @returns HolidayEvent
     * @throws ApiError
     */
    public static holidayeventsList(data: HolidayeventsListData): CancelablePromise<HolidayeventsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                dtend: data.dtend,
                dtend__gt: data.dtendGt,
                dtstart: data.dtstart,
                dtstart__lt: data.dtstartLt,
                o: data.o,
                year: data.year
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns HolidayEvent
     * @throws ApiError
     */
    public static holidayeventsCreate(data: HolidayeventsCreateData): CancelablePromise<HolidayeventsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns HolidayEvent
     * @throws ApiError
     */
    public static holidayeventsRetrieve(data: HolidayeventsRetrieveData): CancelablePromise<HolidayeventsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HolidayEvent
     * @throws ApiError
     */
    public static holidayeventsUpdate(data: HolidayeventsUpdateData): CancelablePromise<HolidayeventsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HolidayEvent
     * @throws ApiError
     */
    public static holidayeventsPartialUpdate(data: HolidayeventsPartialUpdateData): CancelablePromise<HolidayeventsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static holidayeventsDestroy(data: HolidayeventsDestroyData): CancelablePromise<HolidayeventsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns CountryYear
     * @throws ApiError
     */
    public static holidayeventsCreateFromCountryTemplateCreate(data: HolidayeventsCreateFromCountryTemplateCreateData): CancelablePromise<HolidayeventsCreateFromCountryTemplateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/holidayevents/create_from_country_template',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class HorsefeedsService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.dtendGt
     * @param data.dtstartLt
     * @param data.feedingUidIn Multiple values may be separated by commas.
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.statusIn Multiple values may be separated by commas.
     * @returns PaginatedFeedList
     * @throws ApiError
     */
    public static horsefeedsList(data: HorsefeedsListData): CancelablePromise<HorsefeedsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horsefeeds',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                dtend__gt: data.dtendGt,
                dtstart__lt: data.dtstartLt,
                feeding__uid__in: data.feedingUidIn,
                horse__uid__in: data.horseUidIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                status__in: data.statusIn
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Feed
     * @throws ApiError
     */
    public static horsefeedsCreate(data: HorsefeedsCreateData): CancelablePromise<HorsefeedsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horsefeeds',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Feed
     * @throws ApiError
     */
    public static horsefeedsRetrieve(data: HorsefeedsRetrieveData): CancelablePromise<HorsefeedsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horsefeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FeedUpdate
     * @throws ApiError
     */
    public static horsefeedsUpdate(data: HorsefeedsUpdateData): CancelablePromise<HorsefeedsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/horsefeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FeedUpdate
     * @throws ApiError
     */
    public static horsefeedsPartialUpdate(data: HorsefeedsPartialUpdateData): CancelablePromise<HorsefeedsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/horsefeeds/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static horsefeedsDeletePartialUpdate(data: HorsefeedsDeletePartialUpdateData): CancelablePromise<HorsefeedsDeletePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/horsefeeds/{uid}/delete',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class HorsegroupsService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns HorseGroup
     * @throws ApiError
     */
    public static horsegroupsList(data: HorsegroupsListData): CancelablePromise<HorsegroupsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horsegroups',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns HorseGroup
     * @throws ApiError
     */
    public static horsegroupsCreate(data: HorsegroupsCreateData): CancelablePromise<HorsegroupsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horsegroups',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns HorseGroup
     * @throws ApiError
     */
    public static horsegroupsRetrieve(data: HorsegroupsRetrieveData): CancelablePromise<HorsegroupsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horsegroups/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseGroup
     * @throws ApiError
     */
    public static horsegroupsUpdate(data: HorsegroupsUpdateData): CancelablePromise<HorsegroupsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/horsegroups/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseGroup
     * @throws ApiError
     */
    public static horsegroupsPartialUpdate(data: HorsegroupsPartialUpdateData): CancelablePromise<HorsegroupsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/horsegroups/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static horsegroupsDestroy(data: HorsegroupsDestroyData): CancelablePromise<HorsegroupsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/horsegroups/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class HorselocationsService {
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.arrivalDateGt
     * @param data.arrivalDateLte
     * @param data.departureDateGt
     * @param data.departureDateLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.horseOrLocationStable
     * @param data.location
     * @param data.locationIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedHorseLocationList
     * @throws ApiError
     */
    public static horselocationsList(data: HorselocationsListData): CancelablePromise<HorselocationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations',
            path: {
                location__organisation__uid: data.locationOrganisationUid
            },
            query: {
                arrival_date__gt: data.arrivalDateGt,
                arrival_date__lte: data.arrivalDateLte,
                departure_date__gt: data.departureDateGt,
                departure_date__lte: data.departureDateLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                horse_or_location_stable: data.horseOrLocationStable,
                location: data.location,
                location__in: data.locationIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.uid
     * @returns HorseLocation
     * @throws ApiError
     */
    public static horselocationsRetrieve(data: HorselocationsRetrieveData): CancelablePromise<HorselocationsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/{uid}',
            path: {
                location__organisation__uid: data.locationOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseLocation
     * @throws ApiError
     */
    public static horselocationsUpdate(data: HorselocationsUpdateData): CancelablePromise<HorselocationsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/{uid}',
            path: {
                location__organisation__uid: data.locationOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseLocation
     * @throws ApiError
     */
    public static horselocationsPartialUpdate(data: HorselocationsPartialUpdateData): CancelablePromise<HorselocationsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/{uid}',
            path: {
                location__organisation__uid: data.locationOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static horselocationsDestroy(data: HorselocationsDestroyData): CancelablePromise<HorselocationsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/{uid}',
            path: {
                location__organisation__uid: data.locationOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static horselocationsHideArrivalCreate(data: HorselocationsHideArrivalCreateData): CancelablePromise<HorselocationsHideArrivalCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/{uid}/hide_arrival',
            path: {
                location__organisation__uid: data.locationOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static horselocationsHideDepartureCreate(data: HorselocationsHideDepartureCreateData): CancelablePromise<HorselocationsHideDepartureCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/{uid}/hide_departure',
            path: {
                location__organisation__uid: data.locationOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationOrganisationUid
     * @param data.arrivalDateGt
     * @param data.arrivalDateLte
     * @param data.departureDateGt
     * @param data.departureDateLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.horseOrLocationStable
     * @param data.location
     * @param data.locationIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedHorseLocationMutationList
     * @throws ApiError
     */
    public static horselocationsMutationsWithoutReportList(data: HorselocationsMutationsWithoutReportListData): CancelablePromise<HorselocationsMutationsWithoutReportListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{location__organisation__uid}/horselocations/mutations_without_report',
            path: {
                location__organisation__uid: data.locationOrganisationUid
            },
            query: {
                arrival_date__gt: data.arrivalDateGt,
                arrival_date__lte: data.arrivalDateLte,
                departure_date__gt: data.departureDateGt,
                departure_date__lte: data.departureDateLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                horse_or_location_stable: data.horseOrLocationStable,
                location: data.location,
                location__in: data.locationIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
}

export class HorsemediaService {
    /**
     * List all Horsemedia that the user has access to.
     * If you want to upload a file, use multipart/form-data as content_type instead of application/json.
     * Example here: https://dev.to/thomz/uploading-images-to-django-rest-framework-from-forms-in-react-3jhj
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.createdOnGte
     * @param data.createdOnLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedHorseMediaList
     * @throws ApiError
     */
    public static horsemediaList(data: HorsemediaListData): CancelablePromise<HorsemediaListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horsemedia',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            query: {
                created_on__gte: data.createdOnGte,
                created_on__lte: data.createdOnLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * List all Horsemedia that the user has access to.
     * If you want to upload a file, use multipart/form-data as content_type instead of application/json.
     * Example here: https://dev.to/thomz/uploading-images-to-django-rest-framework-from-forms-in-react-3jhj
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.requestBody
     * @returns HorseMedia
     * @throws ApiError
     */
    public static horsemediaCreate(data: HorsemediaCreateData): CancelablePromise<HorsemediaCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/horsemedia',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List all Horsemedia that the user has access to.
     * If you want to upload a file, use multipart/form-data as content_type instead of application/json.
     * Example here: https://dev.to/thomz/uploading-images-to-django-rest-framework-from-forms-in-react-3jhj
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns HorseMedia
     * @throws ApiError
     */
    public static horsemediaRetrieve(data: HorsemediaRetrieveData): CancelablePromise<HorsemediaRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horsemedia/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * List all Horsemedia that the user has access to.
     * If you want to upload a file, use multipart/form-data as content_type instead of application/json.
     * Example here: https://dev.to/thomz/uploading-images-to-django-rest-framework-from-forms-in-react-3jhj
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseMediaUpdate
     * @throws ApiError
     */
    public static horsemediaUpdate(data: HorsemediaUpdateData): CancelablePromise<HorsemediaUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{horse__organisation__uid}/horsemedia/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List all Horsemedia that the user has access to.
     * If you want to upload a file, use multipart/form-data as content_type instead of application/json.
     * Example here: https://dev.to/thomz/uploading-images-to-django-rest-framework-from-forms-in-react-3jhj
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseMediaUpdate
     * @throws ApiError
     */
    public static horsemediaPartialUpdate(data: HorsemediaPartialUpdateData): CancelablePromise<HorsemediaPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{horse__organisation__uid}/horsemedia/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List all Horsemedia that the user has access to.
     * If you want to upload a file, use multipart/form-data as content_type instead of application/json.
     * Example here: https://dev.to/thomz/uploading-images-to-django-rest-framework-from-forms-in-react-3jhj
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static horsemediaDestroy(data: HorsemediaDestroyData): CancelablePromise<HorsemediaDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{horse__organisation__uid}/horsemedia/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class HorseownersService {
    /**
     * CRUD a horse's ownership by linking one of the organisation's horses to one of the organisation's contacts.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.contactUid
     * @param data.horseUid
     * @param data.o Which field to use when ordering the results.
     * @param data.ownerSinceGte
     * @param data.ownerSinceLte
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedHorseOwnerList
     * @throws ApiError
     */
    public static horseownersList(data: HorseownersListData): CancelablePromise<HorseownersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            query: {
                contact__uid: data.contactUid,
                horse__uid: data.horseUid,
                o: data.o,
                owner_since__gte: data.ownerSinceGte,
                owner_since__lte: data.ownerSinceLte,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * CRUD a horse's ownership by linking one of the organisation's horses to one of the organisation's contacts.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.requestBody
     * @returns HorseOwner
     * @throws ApiError
     */
    public static horseownersCreate(data: HorseownersCreateData): CancelablePromise<HorseownersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * CRUD a horse's ownership by linking one of the organisation's horses to one of the organisation's contacts.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns HorseOwner
     * @throws ApiError
     */
    public static horseownersRetrieve(data: HorseownersRetrieveData): CancelablePromise<HorseownersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * CRUD a horse's ownership by linking one of the organisation's horses to one of the organisation's contacts.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseOwner
     * @throws ApiError
     */
    public static horseownersUpdate(data: HorseownersUpdateData): CancelablePromise<HorseownersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * CRUD a horse's ownership by linking one of the organisation's horses to one of the organisation's contacts.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseOwner
     * @throws ApiError
     */
    public static horseownersPartialUpdate(data: HorseownersPartialUpdateData): CancelablePromise<HorseownersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * CRUD a horse's ownership by linking one of the organisation's horses to one of the organisation's contacts.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static horseownersDestroy(data: HorseownersDestroyData): CancelablePromise<HorseownersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class HorseownersHistoryService {
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.contactUid
     * @param data.historyDateGte
     * @param data.historyDateLte
     * @param data.historyUserUid
     * @param data.historyUserUidIn Multiple values may be separated by commas.
     * @param data.horseUid
     * @param data.o Which field to use when ordering the results.
     * @param data.ownerSinceGte
     * @param data.ownerSinceLte
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedHorseOwnerHistoryList
     * @throws ApiError
     */
    public static horseownersHistoryList(data: HorseownersHistoryListData): CancelablePromise<HorseownersHistoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners-history',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            query: {
                contact__uid: data.contactUid,
                history_date__gte: data.historyDateGte,
                history_date__lte: data.historyDateLte,
                history_user__uid: data.historyUserUid,
                history_user__uid__in: data.historyUserUidIn,
                horse__uid: data.horseUid,
                o: data.o,
                owner_since__gte: data.ownerSinceGte,
                owner_since__lte: data.ownerSinceLte,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns HorseOwnerHistory
     * @throws ApiError
     */
    public static horseownersHistoryRetrieve(data: HorseownersHistoryRetrieveData): CancelablePromise<HorseownersHistoryRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horseowners-history/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class HorsesService {
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.o Which field to use when ordering the results.
     * @returns HorseEmployabilityStatus
     * @throws ApiError
     */
    public static horsesHorseemployabilitystatusList(data: HorsesHorseemployabilitystatusListData): CancelablePromise<HorsesHorseemployabilitystatusListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horseemployabilitystatus',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.requestBody
     * @returns HorseEmployabilityStatus
     * @throws ApiError
     */
    public static horsesHorseemployabilitystatusCreate(data: HorsesHorseemployabilitystatusCreateData): CancelablePromise<HorsesHorseemployabilitystatusCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horseemployabilitystatus',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.id A unique integer value identifying this horse employability status.
     * @returns HorseEmployabilityStatus
     * @throws ApiError
     */
    public static horsesHorseemployabilitystatusRetrieve(data: HorsesHorseemployabilitystatusRetrieveData): CancelablePromise<HorsesHorseemployabilitystatusRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horseemployabilitystatus/{id}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid,
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.requestBody
     * @returns HorsePage
     * @throws ApiError
     */
    public static horsesHorsepagesCreate(data: HorsesHorsepagesCreateData): CancelablePromise<HorsesHorsepagesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horsepages',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.o Which field to use when ordering the results.
     * @returns HorsePhaseStatus
     * @throws ApiError
     */
    public static horsesHorsephasestatusList(data: HorsesHorsephasestatusListData): CancelablePromise<HorsesHorsephasestatusListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horsephasestatus',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.requestBody
     * @returns HorsePhaseStatus
     * @throws ApiError
     */
    public static horsesHorsephasestatusCreate(data: HorsesHorsephasestatusCreateData): CancelablePromise<HorsesHorsephasestatusCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horsephasestatus',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.horseUid
     * @param data.id A unique integer value identifying this horse phase status.
     * @returns HorsePhaseStatus
     * @throws ApiError
     */
    public static horsesHorsephasestatusRetrieve(data: HorsesHorsephasestatusRetrieveData): CancelablePromise<HorsesHorsephasestatusRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/horses/{horse__uid}/horsephasestatus/{id}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                horse__uid: data.horseUid,
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uelnIexact
     * @param data.chipNrIexact
     * @param data.currentEmployabilityStatus Employability status
     *
     * * `1` - Full
     * * `2` - Limited for training
     * * `3` - Limited for service
     * * `4` - Limited for service and training
     * * `5` - Not employable
     * @param data.currentPhaseStatus Phase status
     *
     * * `1` - F1
     * * `2` - F2
     * * `3` - F3
     * * `4` - F4
     * * `5` - F5
     * * `6` - Proef
     * * `7` - Les
     * @param data.damIcontains
     * @param data.damsireIcontains
     * @param data.dateOfBirth
     * @param data.groupType * `1` - Training
     * * `2` - youngsters
     * * `3` - mares for breeding
     * * `5` - full care
     * @param data.hasStable
     * @param data.hidden
     * @param data.isDuplicate
     * @param data.isProduct
     * @param data.nameIcontains
     * @param data.nameIstartswith
     * @param data.notOnLocation
     * @param data.o Which field to use when ordering the results.
     * @param data.onLocations
     * @param data.onUnknownLocation
     * @param data.ownerUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.purchaserHorse
     * @param data.sex * `1` - stallion
     * * `2` - mare
     * * `3` - gelding
     * @param data.sexIn Multiple values may be separated by commas.
     * @param data.sireIcontains
     * @param data.siredamIcontains
     * @param data.uid
     * @param data.uidIn Multiple values may be separated by commas.
     * @returns PaginatedHorseList
     * @throws ApiError
     */
    public static horsesList(data: HorsesListData): CancelablePromise<HorsesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horses',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                UELN__iexact: data.uelnIexact,
                chip_nr__iexact: data.chipNrIexact,
                current_employability_status: data.currentEmployabilityStatus,
                current_phase_status: data.currentPhaseStatus,
                dam__icontains: data.damIcontains,
                damsire__icontains: data.damsireIcontains,
                date_of_birth: data.dateOfBirth,
                group__type: data.groupType,
                has_stable: data.hasStable,
                hidden: data.hidden,
                is_duplicate: data.isDuplicate,
                is_product: data.isProduct,
                name__icontains: data.nameIcontains,
                name__istartswith: data.nameIstartswith,
                not_on_location: data.notOnLocation,
                o: data.o,
                on_locations: data.onLocations,
                on_unknown_location: data.onUnknownLocation,
                owner_uid: data.ownerUid,
                page: data.page,
                page_size: data.pageSize,
                purchaser_horse: data.purchaserHorse,
                sex: data.sex,
                sex__in: data.sexIn,
                sire__icontains: data.sireIcontains,
                siredam__icontains: data.siredamIcontains,
                uid: data.uid,
                uid__in: data.uidIn
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns HorseDetail
     * @throws ApiError
     */
    public static horsesCreate(data: HorsesCreateData): CancelablePromise<HorsesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns HorseDetail
     * @throws ApiError
     */
    public static horsesRetrieve(data: HorsesRetrieveData): CancelablePromise<HorsesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseDetail
     * @throws ApiError
     */
    public static horsesUpdate(data: HorsesUpdateData): CancelablePromise<HorsesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseDetail
     * @throws ApiError
     */
    public static horsesPartialUpdate(data: HorsesPartialUpdateData): CancelablePromise<HorsesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static horsesDestroy(data: HorsesDestroyData): CancelablePromise<HorsesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static horsesIgnoreForDuplicatePartialUpdate(data: HorsesIgnoreForDuplicatePartialUpdateData): CancelablePromise<HorsesIgnoreForDuplicatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}/ignore_for_duplicate',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Merge another horse into this resource; the other horse will be deleted.
     * TODO: and optionally updates its fields
     *
     * All the relations of the `merge_with_uid` contact - the 'alias' will be updated and reference this horse.
     * E.g. an invoice referencing the alias will reference this resource hereafter. This resource will keep its own
     * fields when set and get alias' values when empty, but set on alias.
     *
     * TODO: This can be overridden by supplying field names and values like in a regular PATCH request.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns MergeHorses
     * @throws ApiError
     */
    public static horsesMergeAndUpdatePartialUpdate(data: HorsesMergeAndUpdatePartialUpdateData): CancelablePromise<HorsesMergeAndUpdatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}/merge_and_update',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns HorseMoveResponse
     * @throws ApiError
     */
    public static horsesMoveCreate(data: HorsesMoveCreateData): CancelablePromise<HorsesMoveCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}/move',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns HorseDetail
     * @throws ApiError
     */
    public static horsesSetActiveCreate(data: HorsesSetActiveCreateData): CancelablePromise<HorsesSetActiveCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}/set_active',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns HorseDetail
     * @throws ApiError
     */
    public static horsesSetInactiveCreate(data: HorsesSetInactiveCreateData): CancelablePromise<HorsesSetInactiveCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/{uid}/set_inactive',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Returns all contacts needed for horses, such as owners of horses, locations and default riders/grooms/vet/farriers.
     *
     * Filters on the horses the user has access to.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedShallowContactList
     * @throws ApiError
     */
    public static horsesContactsList(data: HorsesContactsListData): CancelablePromise<HorsesContactsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horses/contacts',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * Gets horses and the last reportedrelocation (melding) for each horse from RvO.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static horsesCreateGetHorsesFromRvoCreate(data: HorsesCreateGetHorsesFromRvoCreateData): CancelablePromise<HorsesCreateGetHorsesFromRvoCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/create_get_horses_from_rvo',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uelnIexact
     * @param data.chipNrIexact
     * @param data.currentEmployabilityStatus Employability status
     *
     * * `1` - Full
     * * `2` - Limited for training
     * * `3` - Limited for service
     * * `4` - Limited for service and training
     * * `5` - Not employable
     * @param data.currentPhaseStatus Phase status
     *
     * * `1` - F1
     * * `2` - F2
     * * `3` - F3
     * * `4` - F4
     * * `5` - F5
     * * `6` - Proef
     * * `7` - Les
     * @param data.damIcontains
     * @param data.damsireIcontains
     * @param data.dateOfBirth
     * @param data.groupType * `1` - Training
     * * `2` - youngsters
     * * `3` - mares for breeding
     * * `5` - full care
     * @param data.hasStable
     * @param data.hidden
     * @param data.isDuplicate
     * @param data.isProduct
     * @param data.nameIcontains
     * @param data.nameIstartswith
     * @param data.notOnLocation
     * @param data.o Which field to use when ordering the results.
     * @param data.onLocations
     * @param data.onUnknownLocation
     * @param data.ownerUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.purchaserHorse
     * @param data.sex * `1` - stallion
     * * `2` - mare
     * * `3` - gelding
     * @param data.sexIn Multiple values may be separated by commas.
     * @param data.sireIcontains
     * @param data.siredamIcontains
     * @param data.uid
     * @param data.uidIn Multiple values may be separated by commas.
     * @returns PaginatedHorseWithDuplicatesList
     * @throws ApiError
     */
    public static horsesDuplicatesList(data: HorsesDuplicatesListData): CancelablePromise<HorsesDuplicatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horses/duplicates',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                UELN__iexact: data.uelnIexact,
                chip_nr__iexact: data.chipNrIexact,
                current_employability_status: data.currentEmployabilityStatus,
                current_phase_status: data.currentPhaseStatus,
                dam__icontains: data.damIcontains,
                damsire__icontains: data.damsireIcontains,
                date_of_birth: data.dateOfBirth,
                group__type: data.groupType,
                has_stable: data.hasStable,
                hidden: data.hidden,
                is_duplicate: data.isDuplicate,
                is_product: data.isProduct,
                name__icontains: data.nameIcontains,
                name__istartswith: data.nameIstartswith,
                not_on_location: data.notOnLocation,
                o: data.o,
                on_locations: data.onLocations,
                on_unknown_location: data.onUnknownLocation,
                owner_uid: data.ownerUid,
                page: data.page,
                page_size: data.pageSize,
                purchaser_horse: data.purchaserHorse,
                sex: data.sex,
                sex__in: data.sexIn,
                sire__icontains: data.sireIcontains,
                siredam__icontains: data.siredamIcontains,
                uid: data.uid,
                uid__in: data.uidIn
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns LocationResponse
     * @throws ApiError
     */
    public static horsesGetHorsesFromRvoList(data: HorsesGetHorsesFromRvoListData): CancelablePromise<HorsesGetHorsesFromRvoListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/horses/get_horses_from_rvo',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * Gets horses and the last reportedrelocation (melding) for each horse from RvO.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static horsesGetHorsesFromRvoCreate(data: HorsesGetHorsesFromRvoCreateData): CancelablePromise<HorsesGetHorsesFromRvoCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/get_horses_from_rvo',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * Requires a id_horsetelex or uid to get the horse details from horsetelex.
     * If a uid is given, the id_horsetelex on the horse needs to be set.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns HorseDetailHorseTelex
     * @throws ApiError
     */
    public static horsesGetHorsetelexDetailCreate(data: HorsesGetHorsetelexDetailCreateData): CancelablePromise<HorsesGetHorsetelexDetailCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/get_horsetelex_detail',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns EquineMSearchLastPage
     * @throws ApiError
     */
    public static horsesSearchHorseCreate(data: HorsesSearchHorseCreateData): CancelablePromise<HorsesSearchHorseCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/horses/search_horse',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class InvitationsService {
    /**
     * Shows a list of received invitations for logged in users and a detailed received invitation based on the uuid.
     *
     * invitee={pk}, status={pending|declined|accepted}
     * @param data The data for the request.
     * @param data.acceptedOnIcontains
     * @param data.contact
     * @param data.declinedOnIcontains
     * @param data.invitee
     * @param data.inviter
     * @param data.resendOnIcontains
     * @param data.sentOnIcontains
     * @param data.status status
     * @returns ReceivedInvitation
     * @throws ApiError
     */
    public static apiV5InvitationsList(data: ApiV5InvitationsListData = {}): CancelablePromise<ApiV5InvitationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/invitations',
            query: {
                accepted_on__icontains: data.acceptedOnIcontains,
                contact: data.contact,
                declined_on__icontains: data.declinedOnIcontains,
                invitee: data.invitee,
                inviter: data.inviter,
                resend_on__icontains: data.resendOnIcontains,
                sent_on__icontains: data.sentOnIcontains,
                status: data.status
            }
        });
    }
    
    /**
     * Shows a list of received invitations for logged in users and a detailed received invitation based on the uuid.
     *
     * invitee={pk}, status={pending|declined|accepted}
     * @param data The data for the request.
     * @param data.uuid
     * @returns ReceivedInvitation
     * @throws ApiError
     */
    public static apiV5InvitationsRetrieve(data: ApiV5InvitationsRetrieveData): CancelablePromise<ApiV5InvitationsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/invitations/{uuid}',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Accept an invitation (needs to be logged in)
     * @param data The data for the request.
     * @param data.uuid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static apiV5InvitationsAcceptPartialUpdate(data: ApiV5InvitationsAcceptPartialUpdateData): CancelablePromise<ApiV5InvitationsAcceptPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/invitations/{uuid}/accept',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Decline an invitation (needs to be logged in)
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns DeclinedInvitation
     * @throws ApiError
     */
    public static apiV5InvitationsDeclinePartialUpdate(data: ApiV5InvitationsDeclinePartialUpdateData): CancelablePromise<ApiV5InvitationsDeclinePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/invitations/{uuid}/decline',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * General List View which will show the Sent Invitations
     * POST to this view to create a new invitation
     *
     * It is also possible to add filters:
     *
     * invitee={pk}, status={pending|declined|accepted}, send_only={True}, received_only={True}
     * @param data The data for the request.
     * @param data.inviterOrganisationUid
     * @param data.acceptedOnIcontains
     * @param data.contact
     * @param data.declinedOnIcontains
     * @param data.invitee
     * @param data.inviter
     * @param data.resendOnIcontains
     * @param data.sentOnIcontains
     * @param data.status status
     * @returns SentInvitation
     * @throws ApiError
     */
    public static invitationsList(data: InvitationsListData): CancelablePromise<InvitationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{inviter_organisation__uid}/invitations',
            path: {
                inviter_organisation__uid: data.inviterOrganisationUid
            },
            query: {
                accepted_on__icontains: data.acceptedOnIcontains,
                contact: data.contact,
                declined_on__icontains: data.declinedOnIcontains,
                invitee: data.invitee,
                inviter: data.inviter,
                resend_on__icontains: data.resendOnIcontains,
                sent_on__icontains: data.sentOnIcontains,
                status: data.status
            }
        });
    }
    
    /**
     * General List View which will show the Sent Invitations
     * POST to this view to create a new invitation
     *
     * It is also possible to add filters:
     *
     * invitee={pk}, status={pending|declined|accepted}, send_only={True}, received_only={True}
     * @param data The data for the request.
     * @param data.inviterOrganisationUid
     * @param data.requestBody
     * @returns SentInvitation
     * @throws ApiError
     */
    public static invitationsCreate(data: InvitationsCreateData): CancelablePromise<InvitationsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{inviter_organisation__uid}/invitations',
            path: {
                inviter_organisation__uid: data.inviterOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * General List View which will show the Sent Invitations
     * POST to this view to create a new invitation
     *
     * It is also possible to add filters:
     *
     * invitee={pk}, status={pending|declined|accepted}, send_only={True}, received_only={True}
     * @param data The data for the request.
     * @param data.inviterOrganisationUid
     * @param data.uuid
     * @returns SentInvitation
     * @throws ApiError
     */
    public static invitationsRetrieve(data: InvitationsRetrieveData): CancelablePromise<InvitationsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{inviter_organisation__uid}/invitations/{uuid}',
            path: {
                inviter_organisation__uid: data.inviterOrganisationUid,
                uuid: data.uuid
            }
        });
    }
    
    /**
     * General List View which will show the Sent Invitations
     * POST to this view to create a new invitation
     *
     * It is also possible to add filters:
     *
     * invitee={pk}, status={pending|declined|accepted}, send_only={True}, received_only={True}
     * @param data The data for the request.
     * @param data.inviterOrganisationUid
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static invitationsDestroy(data: InvitationsDestroyData): CancelablePromise<InvitationsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{inviter_organisation__uid}/invitations/{uuid}',
            path: {
                inviter_organisation__uid: data.inviterOrganisationUid,
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Try a resend. There should be 1 days in between and a user may resend 2 times.
     * @param data The data for the request.
     * @param data.inviterOrganisationUid
     * @param data.uuid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static invitationsResendInvitationPartialUpdate(data: InvitationsResendInvitationPartialUpdateData): CancelablePromise<InvitationsResendInvitationPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{inviter_organisation__uid}/invitations/{uuid}/resend_invitation',
            path: {
                inviter_organisation__uid: data.inviterOrganisationUid,
                uuid: data.uuid
            }
        });
    }
}

export class InvoicefrombillableitemsService {
    /**
     * Make one or more invoices from a list of billable items.
     * Supply a list of Billable Item objects where only the uid needs to be supplied, e.g.
     * `[{"uid":"BI8gZkz"}, {"uid":"BI2jWc9"}, ...]`
     *
     * Backend will aggregate them by customer and make an invoice for each.
     * These invoices don't exist yet, they are made in a 'dry-run' process. When you are happy with the
     * invoice and its contents, post it to the invoice endpoint.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @param data.o Which field to use when ordering the results.
     * @returns InMemoryInvoiceDetail
     * @throws ApiError
     */
    public static invoicefrombillableitemsInvoiceCreate(data: InvoicefrombillableitemsInvoiceCreateData): CancelablePromise<InvoicefrombillableitemsInvoiceCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoicefrombillableitems/invoice',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class InvoicesService {
    /**
     * @param data The data for the request.
     * @param data.invoiceOrganisationUid
     * @param data.invoiceUid
     * @param data.o Which field to use when ordering the results.
     * @returns InvoiceItem
     * @throws ApiError
     */
    public static invoicesInvoiceitemsList(data: InvoicesInvoiceitemsListData): CancelablePromise<InvoicesInvoiceitemsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{invoice__organisation__uid}/invoices/{invoice__uid}/invoiceitems',
            path: {
                invoice__organisation__uid: data.invoiceOrganisationUid,
                invoice__uid: data.invoiceUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.invoiceOrganisationUid
     * @param data.invoiceUid
     * @param data.requestBody
     * @returns InvoiceItem
     * @throws ApiError
     */
    public static invoicesInvoiceitemsCreate(data: InvoicesInvoiceitemsCreateData): CancelablePromise<InvoicesInvoiceitemsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{invoice__organisation__uid}/invoices/{invoice__uid}/invoiceitems',
            path: {
                invoice__organisation__uid: data.invoiceOrganisationUid,
                invoice__uid: data.invoiceUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.invoiceOrganisationUid
     * @param data.invoiceUid
     * @param data.uid
     * @returns InvoiceItem
     * @throws ApiError
     */
    public static invoicesInvoiceitemsRetrieve(data: InvoicesInvoiceitemsRetrieveData): CancelablePromise<InvoicesInvoiceitemsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{invoice__organisation__uid}/invoices/{invoice__uid}/invoiceitems/{uid}',
            path: {
                invoice__organisation__uid: data.invoiceOrganisationUid,
                invoice__uid: data.invoiceUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.invoiceOrganisationUid
     * @param data.invoiceUid
     * @param data.uid
     * @param data.requestBody
     * @returns InvoiceItem
     * @throws ApiError
     */
    public static invoicesInvoiceitemsUpdate(data: InvoicesInvoiceitemsUpdateData): CancelablePromise<InvoicesInvoiceitemsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{invoice__organisation__uid}/invoices/{invoice__uid}/invoiceitems/{uid}',
            path: {
                invoice__organisation__uid: data.invoiceOrganisationUid,
                invoice__uid: data.invoiceUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.invoiceOrganisationUid
     * @param data.invoiceUid
     * @param data.uid
     * @param data.requestBody
     * @returns InvoiceItem
     * @throws ApiError
     */
    public static invoicesInvoiceitemsPartialUpdate(data: InvoicesInvoiceitemsPartialUpdateData): CancelablePromise<InvoicesInvoiceitemsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{invoice__organisation__uid}/invoices/{invoice__uid}/invoiceitems/{uid}',
            path: {
                invoice__organisation__uid: data.invoiceOrganisationUid,
                invoice__uid: data.invoiceUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.invoiceOrganisationUid
     * @param data.invoiceUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static invoicesInvoiceitemsDestroy(data: InvoicesInvoiceitemsDestroyData): CancelablePromise<InvoicesInvoiceitemsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{invoice__organisation__uid}/invoices/{invoice__uid}/invoiceitems/{uid}',
            path: {
                invoice__organisation__uid: data.invoiceOrganisationUid,
                invoice__uid: data.invoiceUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.createdByUid
     * @param data.createdOn
     * @param data.createdOnGt
     * @param data.createdOnGte
     * @param data.createdOnLt
     * @param data.createdOnLte
     * @param data.customerCustomerId
     * @param data.customerCustomerIdIn Multiple values may be separated by commas.
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.date
     * @param data.dateGt
     * @param data.dateGte
     * @param data.dateLt
     * @param data.dateLte
     * @param data.draft
     * @param data.endDateActivities
     * @param data.endDateActivitiesGt
     * @param data.endDateActivitiesGte
     * @param data.endDateActivitiesLt
     * @param data.endDateActivitiesLte
     * @param data.endDateServices
     * @param data.endDateServicesGt
     * @param data.endDateServicesGte
     * @param data.endDateServicesLt
     * @param data.endDateServicesLte
     * @param data.exactnlInvoiceId
     * @param data.expirationDate
     * @param data.expirationDateGt
     * @param data.expirationDateGte
     * @param data.expirationDateLt
     * @param data.expirationDateLte
     * @param data.finalizedOn
     * @param data.finalizedOnGt
     * @param data.finalizedOnGte
     * @param data.finalizedOnLt
     * @param data.finalizedOnLte
     * @param data.invoiceNo
     * @param data.lastModifiedOn
     * @param data.lastModifiedOnGt
     * @param data.lastModifiedOnGte
     * @param data.lastModifiedOnLt
     * @param data.lastModifiedOnLte
     * @param data.moneybirdInvoiceId
     * @param data.o Which field to use when ordering the results.
     * @param data.orderUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.paymentStatus * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     * @param data.paymentStatusIn Multiple values may be separated by commas.
     * @param data.sent
     * @param data.sentToExactnl
     * @param data.sentToMoneybird
     * @param data.sentToSnelstart
     * @param data.sentToYuki
     * @param data.startDateActivities
     * @param data.startDateActivitiesGt
     * @param data.startDateActivitiesGte
     * @param data.startDateActivitiesLt
     * @param data.startDateActivitiesLte
     * @param data.startDateServices
     * @param data.startDateServicesGt
     * @param data.startDateServicesGte
     * @param data.startDateServicesLt
     * @param data.startDateServicesLte
     * @param data.supplierUid
     * @param data.supplierUidIn Multiple values may be separated by commas.
     * @param data.yukiInvoiceId
     * @returns PaginatedInvoiceList
     * @throws ApiError
     */
    public static invoicesList(data: InvoicesListData): CancelablePromise<InvoicesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/invoices',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                created_by__uid: data.createdByUid,
                created_on: data.createdOn,
                created_on__gt: data.createdOnGt,
                created_on__gte: data.createdOnGte,
                created_on__lt: data.createdOnLt,
                created_on__lte: data.createdOnLte,
                customer__customer_id: data.customerCustomerId,
                customer__customer_id__in: data.customerCustomerIdIn,
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                date: data.date,
                date__gt: data.dateGt,
                date__gte: data.dateGte,
                date__lt: data.dateLt,
                date__lte: data.dateLte,
                draft: data.draft,
                end_date_activities: data.endDateActivities,
                end_date_activities__gt: data.endDateActivitiesGt,
                end_date_activities__gte: data.endDateActivitiesGte,
                end_date_activities__lt: data.endDateActivitiesLt,
                end_date_activities__lte: data.endDateActivitiesLte,
                end_date_services: data.endDateServices,
                end_date_services__gt: data.endDateServicesGt,
                end_date_services__gte: data.endDateServicesGte,
                end_date_services__lt: data.endDateServicesLt,
                end_date_services__lte: data.endDateServicesLte,
                exactnl_invoice_id: data.exactnlInvoiceId,
                expiration_date: data.expirationDate,
                expiration_date__gt: data.expirationDateGt,
                expiration_date__gte: data.expirationDateGte,
                expiration_date__lt: data.expirationDateLt,
                expiration_date__lte: data.expirationDateLte,
                finalized_on: data.finalizedOn,
                finalized_on__gt: data.finalizedOnGt,
                finalized_on__gte: data.finalizedOnGte,
                finalized_on__lt: data.finalizedOnLt,
                finalized_on__lte: data.finalizedOnLte,
                invoice_no: data.invoiceNo,
                last_modified_on: data.lastModifiedOn,
                last_modified_on__gt: data.lastModifiedOnGt,
                last_modified_on__gte: data.lastModifiedOnGte,
                last_modified_on__lt: data.lastModifiedOnLt,
                last_modified_on__lte: data.lastModifiedOnLte,
                moneybird_invoice_id: data.moneybirdInvoiceId,
                o: data.o,
                order__uid: data.orderUid,
                page: data.page,
                page_size: data.pageSize,
                payment_status: data.paymentStatus,
                payment_status__in: data.paymentStatusIn,
                sent: data.sent,
                sent_to_exactnl: data.sentToExactnl,
                sent_to_moneybird: data.sentToMoneybird,
                sent_to_snelstart: data.sentToSnelstart,
                sent_to_yuki: data.sentToYuki,
                start_date_activities: data.startDateActivities,
                start_date_activities__gt: data.startDateActivitiesGt,
                start_date_activities__gte: data.startDateActivitiesGte,
                start_date_activities__lt: data.startDateActivitiesLt,
                start_date_activities__lte: data.startDateActivitiesLte,
                start_date_services: data.startDateServices,
                start_date_services__gt: data.startDateServicesGt,
                start_date_services__gte: data.startDateServicesGte,
                start_date_services__lt: data.startDateServicesLt,
                start_date_services__lte: data.startDateServicesLte,
                supplier__uid: data.supplierUid,
                supplier__uid__in: data.supplierUidIn,
                yuki_invoice_id: data.yukiInvoiceId
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns InvoiceDetail
     * @throws ApiError
     */
    public static invoicesCreate(data: InvoicesCreateData): CancelablePromise<InvoicesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns InvoiceDetail
     * @throws ApiError
     */
    public static invoicesRetrieve(data: InvoicesRetrieveData): CancelablePromise<InvoicesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns InvoiceDetail
     * @throws ApiError
     */
    public static invoicesUpdate(data: InvoicesUpdateData): CancelablePromise<InvoicesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns InvoiceDetail
     * @throws ApiError
     */
    public static invoicesPartialUpdate(data: InvoicesPartialUpdateData): CancelablePromise<InvoicesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static invoicesDestroy(data: InvoicesDestroyData): CancelablePromise<InvoicesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Will finalize an invoice and possibly send it to the accounting software.
     * If the invoice is already finalized, it will not change the finalized_on, but you can still send it to the accounting software.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns InvoiceFinalize
     * @throws ApiError
     */
    public static invoicesFinalizeCreate(data: InvoicesFinalizeCreateData): CancelablePromise<InvoicesFinalizeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/finalize',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Removes the link with ALL accounting software for this invoice.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static invoicesRemoveLinkWithAccountingSoftwareCreate(data: InvoicesRemoveLinkWithAccountingSoftwareCreateData): CancelablePromise<InvoicesRemoveLinkWithAccountingSoftwareCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/remove_link_with_accounting_software',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static invoicesSendToAccountingSoftwareCreate(data: InvoicesSendToAccountingSoftwareCreateData): CancelablePromise<InvoicesSendToAccountingSoftwareCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/send_to_accounting_software',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns BackGroundTask
     * @throws ApiError
     */
    public static invoicesSendToClientRetrieve(data: InvoicesSendToClientRetrieveData): CancelablePromise<InvoicesSendToClientRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/send_to_client',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static invoicesSendToClientCreate(data: InvoicesSendToClientCreateData): CancelablePromise<InvoicesSendToClientCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/send_to_client',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static invoicesSendToClientCreateCreate(data: InvoicesSendToClientCreateCreateData): CancelablePromise<InvoicesSendToClientCreateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/send_to_client_create',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * sent_on: When is the invoice last sent
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static invoicesUnfinalizeCreate(data: InvoicesUnfinalizeCreateData): CancelablePromise<InvoicesUnfinalizeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/invoices/{uid}/unfinalize',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class LeaveMutationService {
    /**
     * View set for the Leave objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.contactUid
     * @param data.contactUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @returns LeaveAllowanceMutation
     * @throws ApiError
     */
    public static leaveMutationList(data: LeaveMutationListData): CancelablePromise<LeaveMutationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/leave_mutation',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                contact__uid: data.contactUid,
                contact__uid__in: data.contactUidIn,
                o: data.o
            }
        });
    }
    
    /**
     * View set for the Leave objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns LeaveAllowanceMutation
     * @throws ApiError
     */
    public static leaveMutationCreate(data: LeaveMutationCreateData): CancelablePromise<LeaveMutationCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/leave_mutation',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Leave objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns LeaveAllowanceMutation
     * @throws ApiError
     */
    public static leaveMutationRetrieve(data: LeaveMutationRetrieveData): CancelablePromise<LeaveMutationRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/leave_mutation/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * View set for the Leave objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns LeaveAllowanceMutation
     * @throws ApiError
     */
    public static leaveMutationUpdate(data: LeaveMutationUpdateData): CancelablePromise<LeaveMutationUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/leave_mutation/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Leave objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns LeaveAllowanceMutation
     * @throws ApiError
     */
    public static leaveMutationPartialUpdate(data: LeaveMutationPartialUpdateData): CancelablePromise<LeaveMutationPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/leave_mutation/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Leave objects.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static leaveMutationDestroy(data: LeaveMutationDestroyData): CancelablePromise<LeaveMutationDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/leave_mutation/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class ManureService {
    /**
     * **Step 1/3 in the manure administration**
     *
     * Fertilizer is consumed by farm land. Depending on the type of land and type of crop on
     * that land, it will consume some yearly amount of different types of fertilizer.
     * By summarizing an organization's grass lands and crops, you'll know the yearly budget
     * (or 'gebruiksruimte') for different types of fertilizer, which can then be balanced
     * against fertilizer producers.
     *
     * These records are usable in the budget tables in the yearly manure administration. The
     * record's FertilizerBudgetType identifies the respective table.
     *
     * Expected usage for the Dutch RvO manure balance calculation is exemplified in steps 1 2 and 3
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * | RvO Table | fertilizer_budget_type | description examples |
     * |-----------|------------------------|----------------------|
     * | stikstof uit dierlijke mest     | ANIMAL_NITROGEN  | landbouwgrond |
     * | totale stikstof gerbruiksruimte | TOTAL_NITROGEN   | grasland (met beweiden), suikerbieten |
     * | totale fosfaat gerbruiksruimte  | TOTAL_PHOSPHATE | grasland, bouwland |
     *
     *
     * Note: The summary of areas does not represent the total farmland that belonged
     * to the respective contact in the respective year. Plots of land can be entered
     * multiple times with different descriptions, for different budgets. For example:
     * - the amounts of grass lands and crop lands together define the total farmland
     * - the summarized crops that aren't follow-ups define the amount of crop lands
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.contactUid
     * @param data.contactUidIn Multiple values may be separated by commas.
     * @param data.fertilizerBudgetType * `ANIMAL_NITROGEN` - nitrogen from animals
     * * `TOTAL_NITROGEN` - total nitrogen
     * * `TOTAL_PHOSPHATE` - total phosphate
     * @param data.fertilizerBudgetTypeIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.year
     * @returns PaginatedFertilizerConsumerList
     * @throws ApiError
     */
    public static manureFertilizerConsumersList(data: ManureFertilizerConsumersListData): CancelablePromise<ManureFertilizerConsumersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_consumers',
            path: {
                contact__organisation__uid: data.contactOrganisationUid
            },
            query: {
                contact__uid: data.contactUid,
                contact__uid__in: data.contactUidIn,
                fertilizer_budget_type: data.fertilizerBudgetType,
                fertilizer_budget_type__in: data.fertilizerBudgetTypeIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                year: data.year
            }
        });
    }
    
    /**
     * **Step 1/3 in the manure administration**
     *
     * Fertilizer is consumed by farm land. Depending on the type of land and type of crop on
     * that land, it will consume some yearly amount of different types of fertilizer.
     * By summarizing an organization's grass lands and crops, you'll know the yearly budget
     * (or 'gebruiksruimte') for different types of fertilizer, which can then be balanced
     * against fertilizer producers.
     *
     * These records are usable in the budget tables in the yearly manure administration. The
     * record's FertilizerBudgetType identifies the respective table.
     *
     * Expected usage for the Dutch RvO manure balance calculation is exemplified in steps 1 2 and 3
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * | RvO Table | fertilizer_budget_type | description examples |
     * |-----------|------------------------|----------------------|
     * | stikstof uit dierlijke mest     | ANIMAL_NITROGEN  | landbouwgrond |
     * | totale stikstof gerbruiksruimte | TOTAL_NITROGEN   | grasland (met beweiden), suikerbieten |
     * | totale fosfaat gerbruiksruimte  | TOTAL_PHOSPHATE | grasland, bouwland |
     *
     *
     * Note: The summary of areas does not represent the total farmland that belonged
     * to the respective contact in the respective year. Plots of land can be entered
     * multiple times with different descriptions, for different budgets. For example:
     * - the amounts of grass lands and crop lands together define the total farmland
     * - the summarized crops that aren't follow-ups define the amount of crop lands
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.requestBody
     * @returns FertilizerConsumer
     * @throws ApiError
     */
    public static manureFertilizerConsumersCreate(data: ManureFertilizerConsumersCreateData): CancelablePromise<ManureFertilizerConsumersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_consumers',
            path: {
                contact__organisation__uid: data.contactOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 1/3 in the manure administration**
     *
     * Fertilizer is consumed by farm land. Depending on the type of land and type of crop on
     * that land, it will consume some yearly amount of different types of fertilizer.
     * By summarizing an organization's grass lands and crops, you'll know the yearly budget
     * (or 'gebruiksruimte') for different types of fertilizer, which can then be balanced
     * against fertilizer producers.
     *
     * These records are usable in the budget tables in the yearly manure administration. The
     * record's FertilizerBudgetType identifies the respective table.
     *
     * Expected usage for the Dutch RvO manure balance calculation is exemplified in steps 1 2 and 3
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * | RvO Table | fertilizer_budget_type | description examples |
     * |-----------|------------------------|----------------------|
     * | stikstof uit dierlijke mest     | ANIMAL_NITROGEN  | landbouwgrond |
     * | totale stikstof gerbruiksruimte | TOTAL_NITROGEN   | grasland (met beweiden), suikerbieten |
     * | totale fosfaat gerbruiksruimte  | TOTAL_PHOSPHATE | grasland, bouwland |
     *
     *
     * Note: The summary of areas does not represent the total farmland that belonged
     * to the respective contact in the respective year. Plots of land can be entered
     * multiple times with different descriptions, for different budgets. For example:
     * - the amounts of grass lands and crop lands together define the total farmland
     * - the summarized crops that aren't follow-ups define the amount of crop lands
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @returns FertilizerConsumer
     * @throws ApiError
     */
    public static manureFertilizerConsumersRetrieve(data: ManureFertilizerConsumersRetrieveData): CancelablePromise<ManureFertilizerConsumersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_consumers/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * **Step 1/3 in the manure administration**
     *
     * Fertilizer is consumed by farm land. Depending on the type of land and type of crop on
     * that land, it will consume some yearly amount of different types of fertilizer.
     * By summarizing an organization's grass lands and crops, you'll know the yearly budget
     * (or 'gebruiksruimte') for different types of fertilizer, which can then be balanced
     * against fertilizer producers.
     *
     * These records are usable in the budget tables in the yearly manure administration. The
     * record's FertilizerBudgetType identifies the respective table.
     *
     * Expected usage for the Dutch RvO manure balance calculation is exemplified in steps 1 2 and 3
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * | RvO Table | fertilizer_budget_type | description examples |
     * |-----------|------------------------|----------------------|
     * | stikstof uit dierlijke mest     | ANIMAL_NITROGEN  | landbouwgrond |
     * | totale stikstof gerbruiksruimte | TOTAL_NITROGEN   | grasland (met beweiden), suikerbieten |
     * | totale fosfaat gerbruiksruimte  | TOTAL_PHOSPHATE | grasland, bouwland |
     *
     *
     * Note: The summary of areas does not represent the total farmland that belonged
     * to the respective contact in the respective year. Plots of land can be entered
     * multiple times with different descriptions, for different budgets. For example:
     * - the amounts of grass lands and crop lands together define the total farmland
     * - the summarized crops that aren't follow-ups define the amount of crop lands
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FertilizerConsumer
     * @throws ApiError
     */
    public static manureFertilizerConsumersUpdate(data: ManureFertilizerConsumersUpdateData): CancelablePromise<ManureFertilizerConsumersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_consumers/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 1/3 in the manure administration**
     *
     * Fertilizer is consumed by farm land. Depending on the type of land and type of crop on
     * that land, it will consume some yearly amount of different types of fertilizer.
     * By summarizing an organization's grass lands and crops, you'll know the yearly budget
     * (or 'gebruiksruimte') for different types of fertilizer, which can then be balanced
     * against fertilizer producers.
     *
     * These records are usable in the budget tables in the yearly manure administration. The
     * record's FertilizerBudgetType identifies the respective table.
     *
     * Expected usage for the Dutch RvO manure balance calculation is exemplified in steps 1 2 and 3
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * | RvO Table | fertilizer_budget_type | description examples |
     * |-----------|------------------------|----------------------|
     * | stikstof uit dierlijke mest     | ANIMAL_NITROGEN  | landbouwgrond |
     * | totale stikstof gerbruiksruimte | TOTAL_NITROGEN   | grasland (met beweiden), suikerbieten |
     * | totale fosfaat gerbruiksruimte  | TOTAL_PHOSPHATE | grasland, bouwland |
     *
     *
     * Note: The summary of areas does not represent the total farmland that belonged
     * to the respective contact in the respective year. Plots of land can be entered
     * multiple times with different descriptions, for different budgets. For example:
     * - the amounts of grass lands and crop lands together define the total farmland
     * - the summarized crops that aren't follow-ups define the amount of crop lands
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns FertilizerConsumer
     * @throws ApiError
     */
    public static manureFertilizerConsumersPartialUpdate(data: ManureFertilizerConsumersPartialUpdateData): CancelablePromise<ManureFertilizerConsumersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_consumers/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 1/3 in the manure administration**
     *
     * Fertilizer is consumed by farm land. Depending on the type of land and type of crop on
     * that land, it will consume some yearly amount of different types of fertilizer.
     * By summarizing an organization's grass lands and crops, you'll know the yearly budget
     * (or 'gebruiksruimte') for different types of fertilizer, which can then be balanced
     * against fertilizer producers.
     *
     * These records are usable in the budget tables in the yearly manure administration. The
     * record's FertilizerBudgetType identifies the respective table.
     *
     * Expected usage for the Dutch RvO manure balance calculation is exemplified in steps 1 2 and 3
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * | RvO Table | fertilizer_budget_type | description examples |
     * |-----------|------------------------|----------------------|
     * | stikstof uit dierlijke mest     | ANIMAL_NITROGEN  | landbouwgrond |
     * | totale stikstof gerbruiksruimte | TOTAL_NITROGEN   | grasland (met beweiden), suikerbieten |
     * | totale fosfaat gerbruiksruimte  | TOTAL_PHOSPHATE | grasland, bouwland |
     *
     *
     * Note: The summary of areas does not represent the total farmland that belonged
     * to the respective contact in the respective year. Plots of land can be entered
     * multiple times with different descriptions, for different budgets. For example:
     * - the amounts of grass lands and crop lands together define the total farmland
     * - the summarized crops that aren't follow-ups define the amount of crop lands
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static manureFertilizerConsumersDestroy(data: ManureFertilizerConsumersDestroyData): CancelablePromise<ManureFertilizerConsumersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_consumers/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * **Step 2/3 in the manure administration**
     *
     * An contact's yearly manure balance is made up of different items; from animal feed that was
     * locally produced to this year's manure on stock. Depending on the mutation of these items,
     * their respective nitrogen and phosphate will be added or subtracted on the balance.
     *
     * The origin and mutation types correspond to the ones displayed in the RvO example
     * in steps 4 and 5 [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * A contact's yearly records will add up to a nitrogen and phosphor surplus that need to be
     * equal or lower than the respective budgets captured by the FertilizerConsumer table.
     * The phosphorous component can be compared directly to the budget for the nitrogenous component
     * you should first fill calculate the effective application weight in step 3/3, see
     * `/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen`
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.contactUid
     * @param data.contactUidIn Multiple values may be separated by commas.
     * @param data.fertilizerOrigin indicate the type of this fertilizer or where it originated from
     *
     * * `ANIMAL_MANURE_SUPPLY` - animal manure supply
     * * `MILK_PRODUCING_COWS` - milk producing cows
     * * `GRAZING_ANIMALS` - grazing animals
     * * `EQUINEM_HORSES` - equinem horses
     * * `STABLE_ANIMALS_FEED` - stable animals feed
     * * `OTHER_ORGANIC_SUPPLY` - other organic supply
     * * `ANORGANIC_SUPPLY` - anorganic supply
     * @param data.fertilizerOriginIn Multiple values may be separated by commas.
     * @param data.mutationType End amounts and Exports are subtractions on the balance, the others are additions
     *
     * * `BEGIN_AMOUNT` - begin amount
     * * `IMPORT` - import
     * * `PRODUCTION` - production
     * * `EXPORT` - export
     * * `END_AMOUNT` - end amount
     * @param data.mutationTypeIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.year
     * @returns PaginatedProductionBalanceItemList
     * @throws ApiError
     */
    public static manureFertilizerProducersBalanceList(data: ManureFertilizerProducersBalanceListData): CancelablePromise<ManureFertilizerProducersBalanceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/balance',
            path: {
                contact__organisation__uid: data.contactOrganisationUid
            },
            query: {
                contact__uid: data.contactUid,
                contact__uid__in: data.contactUidIn,
                fertilizer_origin: data.fertilizerOrigin,
                fertilizer_origin__in: data.fertilizerOriginIn,
                mutation_type: data.mutationType,
                mutation_type__in: data.mutationTypeIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                year: data.year
            }
        });
    }
    
    /**
     * **Step 2/3 in the manure administration**
     *
     * An contact's yearly manure balance is made up of different items; from animal feed that was
     * locally produced to this year's manure on stock. Depending on the mutation of these items,
     * their respective nitrogen and phosphate will be added or subtracted on the balance.
     *
     * The origin and mutation types correspond to the ones displayed in the RvO example
     * in steps 4 and 5 [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * A contact's yearly records will add up to a nitrogen and phosphor surplus that need to be
     * equal or lower than the respective budgets captured by the FertilizerConsumer table.
     * The phosphorous component can be compared directly to the budget for the nitrogenous component
     * you should first fill calculate the effective application weight in step 3/3, see
     * `/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen`
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.requestBody
     * @returns ProductionBalanceItem
     * @throws ApiError
     */
    public static manureFertilizerProducersBalanceCreate(data: ManureFertilizerProducersBalanceCreateData): CancelablePromise<ManureFertilizerProducersBalanceCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/balance',
            path: {
                contact__organisation__uid: data.contactOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 2/3 in the manure administration**
     *
     * An contact's yearly manure balance is made up of different items; from animal feed that was
     * locally produced to this year's manure on stock. Depending on the mutation of these items,
     * their respective nitrogen and phosphate will be added or subtracted on the balance.
     *
     * The origin and mutation types correspond to the ones displayed in the RvO example
     * in steps 4 and 5 [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * A contact's yearly records will add up to a nitrogen and phosphor surplus that need to be
     * equal or lower than the respective budgets captured by the FertilizerConsumer table.
     * The phosphorous component can be compared directly to the budget for the nitrogenous component
     * you should first fill calculate the effective application weight in step 3/3, see
     * `/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen`
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @returns ProductionBalanceItem
     * @throws ApiError
     */
    public static manureFertilizerProducersBalanceRetrieve(data: ManureFertilizerProducersBalanceRetrieveData): CancelablePromise<ManureFertilizerProducersBalanceRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/balance/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * **Step 2/3 in the manure administration**
     *
     * An contact's yearly manure balance is made up of different items; from animal feed that was
     * locally produced to this year's manure on stock. Depending on the mutation of these items,
     * their respective nitrogen and phosphate will be added or subtracted on the balance.
     *
     * The origin and mutation types correspond to the ones displayed in the RvO example
     * in steps 4 and 5 [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * A contact's yearly records will add up to a nitrogen and phosphor surplus that need to be
     * equal or lower than the respective budgets captured by the FertilizerConsumer table.
     * The phosphorous component can be compared directly to the budget for the nitrogenous component
     * you should first fill calculate the effective application weight in step 3/3, see
     * `/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen`
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ProductionBalanceItem
     * @throws ApiError
     */
    public static manureFertilizerProducersBalanceUpdate(data: ManureFertilizerProducersBalanceUpdateData): CancelablePromise<ManureFertilizerProducersBalanceUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/balance/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 2/3 in the manure administration**
     *
     * An contact's yearly manure balance is made up of different items; from animal feed that was
     * locally produced to this year's manure on stock. Depending on the mutation of these items,
     * their respective nitrogen and phosphate will be added or subtracted on the balance.
     *
     * The origin and mutation types correspond to the ones displayed in the RvO example
     * in steps 4 and 5 [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * A contact's yearly records will add up to a nitrogen and phosphor surplus that need to be
     * equal or lower than the respective budgets captured by the FertilizerConsumer table.
     * The phosphorous component can be compared directly to the budget for the nitrogenous component
     * you should first fill calculate the effective application weight in step 3/3, see
     * `/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen`
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ProductionBalanceItem
     * @throws ApiError
     */
    public static manureFertilizerProducersBalancePartialUpdate(data: ManureFertilizerProducersBalancePartialUpdateData): CancelablePromise<ManureFertilizerProducersBalancePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/balance/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 2/3 in the manure administration**
     *
     * An contact's yearly manure balance is made up of different items; from animal feed that was
     * locally produced to this year's manure on stock. Depending on the mutation of these items,
     * their respective nitrogen and phosphate will be added or subtracted on the balance.
     *
     * The origin and mutation types correspond to the ones displayed in the RvO example
     * in steps 4 and 5 [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf).
     *
     * A contact's yearly records will add up to a nitrogen and phosphor surplus that need to be
     * equal or lower than the respective budgets captured by the FertilizerConsumer table.
     * The phosphorous component can be compared directly to the budget for the nitrogenous component
     * you should first fill calculate the effective application weight in step 3/3, see
     * `/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen`
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static manureFertilizerProducersBalanceDestroy(data: ManureFertilizerProducersBalanceDestroyData): CancelablePromise<ManureFertilizerProducersBalanceDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/balance/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * **Step 3/3 in the manure administration**
     *
     * The nitrogen fertilizer component in manure that gets applied to the land is not fully
     * absorbed by the ground. The items on the balance in step 2/3 will tell us the yearly
     * surplus of manure production for a Contact; this endpoint will record how that surplus
     * has been applied. In the end the RvO needs to know how much fertilizer has been *effectively*
     * applied to the land and this depends on the type of fertilizer and the type of land.
     *
     * This endpoint will help you recorde the table in the RvO's example, step 6, visible
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf)
     *
     * The resulting `effective_nitrogen_weight` is the number that needs to add up to the yearly
     * nitrogen budget captured in step 1/3 for the respective contact.
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.contactUid
     * @param data.contactUidIn Multiple values may be separated by commas.
     * @param data.isAnimalManure
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.year
     * @returns PaginatedNitrogenApplicationList
     * @throws ApiError
     */
    public static manureFertilizerProducersEffectiveNitrogenList(data: ManureFertilizerProducersEffectiveNitrogenListData): CancelablePromise<ManureFertilizerProducersEffectiveNitrogenListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen',
            path: {
                contact__organisation__uid: data.contactOrganisationUid
            },
            query: {
                contact__uid: data.contactUid,
                contact__uid__in: data.contactUidIn,
                is_animal_manure: data.isAnimalManure,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                year: data.year
            }
        });
    }
    
    /**
     * **Step 3/3 in the manure administration**
     *
     * The nitrogen fertilizer component in manure that gets applied to the land is not fully
     * absorbed by the ground. The items on the balance in step 2/3 will tell us the yearly
     * surplus of manure production for a Contact; this endpoint will record how that surplus
     * has been applied. In the end the RvO needs to know how much fertilizer has been *effectively*
     * applied to the land and this depends on the type of fertilizer and the type of land.
     *
     * This endpoint will help you recorde the table in the RvO's example, step 6, visible
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf)
     *
     * The resulting `effective_nitrogen_weight` is the number that needs to add up to the yearly
     * nitrogen budget captured in step 1/3 for the respective contact.
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.requestBody
     * @returns NitrogenApplication
     * @throws ApiError
     */
    public static manureFertilizerProducersEffectiveNitrogenCreate(data: ManureFertilizerProducersEffectiveNitrogenCreateData): CancelablePromise<ManureFertilizerProducersEffectiveNitrogenCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen',
            path: {
                contact__organisation__uid: data.contactOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 3/3 in the manure administration**
     *
     * The nitrogen fertilizer component in manure that gets applied to the land is not fully
     * absorbed by the ground. The items on the balance in step 2/3 will tell us the yearly
     * surplus of manure production for a Contact; this endpoint will record how that surplus
     * has been applied. In the end the RvO needs to know how much fertilizer has been *effectively*
     * applied to the land and this depends on the type of fertilizer and the type of land.
     *
     * This endpoint will help you recorde the table in the RvO's example, step 6, visible
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf)
     *
     * The resulting `effective_nitrogen_weight` is the number that needs to add up to the yearly
     * nitrogen budget captured in step 1/3 for the respective contact.
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @returns NitrogenApplication
     * @throws ApiError
     */
    public static manureFertilizerProducersEffectiveNitrogenRetrieve(data: ManureFertilizerProducersEffectiveNitrogenRetrieveData): CancelablePromise<ManureFertilizerProducersEffectiveNitrogenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * **Step 3/3 in the manure administration**
     *
     * The nitrogen fertilizer component in manure that gets applied to the land is not fully
     * absorbed by the ground. The items on the balance in step 2/3 will tell us the yearly
     * surplus of manure production for a Contact; this endpoint will record how that surplus
     * has been applied. In the end the RvO needs to know how much fertilizer has been *effectively*
     * applied to the land and this depends on the type of fertilizer and the type of land.
     *
     * This endpoint will help you recorde the table in the RvO's example, step 6, visible
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf)
     *
     * The resulting `effective_nitrogen_weight` is the number that needs to add up to the yearly
     * nitrogen budget captured in step 1/3 for the respective contact.
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns NitrogenApplication
     * @throws ApiError
     */
    public static manureFertilizerProducersEffectiveNitrogenUpdate(data: ManureFertilizerProducersEffectiveNitrogenUpdateData): CancelablePromise<ManureFertilizerProducersEffectiveNitrogenUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 3/3 in the manure administration**
     *
     * The nitrogen fertilizer component in manure that gets applied to the land is not fully
     * absorbed by the ground. The items on the balance in step 2/3 will tell us the yearly
     * surplus of manure production for a Contact; this endpoint will record how that surplus
     * has been applied. In the end the RvO needs to know how much fertilizer has been *effectively*
     * applied to the land and this depends on the type of fertilizer and the type of land.
     *
     * This endpoint will help you recorde the table in the RvO's example, step 6, visible
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf)
     *
     * The resulting `effective_nitrogen_weight` is the number that needs to add up to the yearly
     * nitrogen budget captured in step 1/3 for the respective contact.
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns NitrogenApplication
     * @throws ApiError
     */
    public static manureFertilizerProducersEffectiveNitrogenPartialUpdate(data: ManureFertilizerProducersEffectiveNitrogenPartialUpdateData): CancelablePromise<ManureFertilizerProducersEffectiveNitrogenPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **Step 3/3 in the manure administration**
     *
     * The nitrogen fertilizer component in manure that gets applied to the land is not fully
     * absorbed by the ground. The items on the balance in step 2/3 will tell us the yearly
     * surplus of manure production for a Contact; this endpoint will record how that surplus
     * has been applied. In the end the RvO needs to know how much fertilizer has been *effectively*
     * applied to the land and this depends on the type of fertilizer and the type of land.
     *
     * This endpoint will help you recorde the table in the RvO's example, step 6, visible
     * [here](https://www.rvo.nl/sites/default/files/2023-08/Brochure-Hoeveel-mest-gebruiken-hoe-rekent-u-dat-uit-v1.7-Aug2023_0.pdf)
     *
     * The resulting `effective_nitrogen_weight` is the number that needs to add up to the yearly
     * nitrogen budget captured in step 1/3 for the respective contact.
     * @param data The data for the request.
     * @param data.contactOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static manureFertilizerProducersEffectiveNitrogenDestroy(data: ManureFertilizerProducersEffectiveNitrogenDestroyData): CancelablePromise<ManureFertilizerProducersEffectiveNitrogenDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{contact__organisation__uid}/manure/fertilizer_producers/effective-nitrogen/{uid}',
            path: {
                contact__organisation__uid: data.contactOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * When filing the manure administration, a stable manager needs to know how many horses and ponies
     * haven been in his stable over the course of the past year. This endpoint serializes that for the
     * provided contact and year. The result will contain a 'head count' made at the first of the month
     * and how that averages over the year.
     *
     * The production balance registration is based on a contact (uid). The uid in the url provided for
     * this endpoint should be the same and (e.g. the stable's location). You can only provide the
     * current or past years. Month that have not yet come to pass are filled in with the numbers
     * based on the current horse locations.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.year
     * @returns AveragedHistoricHorseCount
     * @throws ApiError
     */
    public static manureStableHistoricHorseCountContactRetrieve(data: ManureStableHistoricHorseCountContactRetrieveData): CancelablePromise<ManureStableHistoricHorseCountContactRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/manure/stable-historic-horse-count/{year}/contact/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid,
                year: data.year
            }
        });
    }
}

export class MapsService {
    /**
     * View set for the Maps.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns Map
     * @throws ApiError
     */
    public static mapsList(data: MapsListData): CancelablePromise<MapsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/maps',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * View set for the Maps.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Map
     * @throws ApiError
     */
    public static mapsCreate(data: MapsCreateData): CancelablePromise<MapsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/maps',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Maps.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Map
     * @throws ApiError
     */
    public static mapsRetrieve(data: MapsRetrieveData): CancelablePromise<MapsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/maps/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * View set for the Maps.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Map
     * @throws ApiError
     */
    public static mapsUpdate(data: MapsUpdateData): CancelablePromise<MapsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/maps/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Maps.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Map
     * @throws ApiError
     */
    public static mapsPartialUpdate(data: MapsPartialUpdateData): CancelablePromise<MapsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/maps/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the Maps.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static mapsDestroy(data: MapsDestroyData): CancelablePromise<MapsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/maps/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class MarecyclecheckService {
    /**
     * The pregnancy_check_term is required when there is no activity given AND no activity can be found on the given date.
     *
     * For the update if you change the activity.uid, you will swap out the activity.
     * This means the pregnancy_check_term and extra_info from the old activity will be copied, unless (one of) these are given in the data.
     * The old activity will also be made empty in that case.
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.activityOrderItemUid
     * @param data.activityOrderItemUidIn Multiple values may be separated by commas.
     * @param data.date
     * @param data.dateGt
     * @param data.dateGte
     * @param data.dateLt
     * @param data.dateLte
     * @param data.mareUid
     * @param data.mareUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedMareCycleCheckList
     * @throws ApiError
     */
    public static marecyclecheckList(data: MarecyclecheckListData): CancelablePromise<MarecyclecheckListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{mare__organisation__uid}/marecyclecheck',
            path: {
                mare__organisation__uid: data.mareOrganisationUid
            },
            query: {
                activity__order_item__uid: data.activityOrderItemUid,
                activity__order_item__uid__in: data.activityOrderItemUidIn,
                date: data.date,
                date__gt: data.dateGt,
                date__gte: data.dateGte,
                date__lt: data.dateLt,
                date__lte: data.dateLte,
                mare__uid: data.mareUid,
                mare__uid__in: data.mareUidIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * The pregnancy_check_term is required when there is no activity given AND no activity can be found on the given date.
     *
     * For the update if you change the activity.uid, you will swap out the activity.
     * This means the pregnancy_check_term and extra_info from the old activity will be copied, unless (one of) these are given in the data.
     * The old activity will also be made empty in that case.
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.requestBody
     * @returns MareCycleCheck
     * @throws ApiError
     */
    public static marecyclecheckCreate(data: MarecyclecheckCreateData): CancelablePromise<MarecyclecheckCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{mare__organisation__uid}/marecyclecheck',
            path: {
                mare__organisation__uid: data.mareOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * The pregnancy_check_term is required when there is no activity given AND no activity can be found on the given date.
     *
     * For the update if you change the activity.uid, you will swap out the activity.
     * This means the pregnancy_check_term and extra_info from the old activity will be copied, unless (one of) these are given in the data.
     * The old activity will also be made empty in that case.
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @returns MareCycleCheck
     * @throws ApiError
     */
    public static marecyclecheckRetrieve(data: MarecyclecheckRetrieveData): CancelablePromise<MarecyclecheckRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{mare__organisation__uid}/marecyclecheck/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * The pregnancy_check_term is required when there is no activity given AND no activity can be found on the given date.
     *
     * For the update if you change the activity.uid, you will swap out the activity.
     * This means the pregnancy_check_term and extra_info from the old activity will be copied, unless (one of) these are given in the data.
     * The old activity will also be made empty in that case.
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns MareCycleCheck
     * @throws ApiError
     */
    public static marecyclecheckUpdate(data: MarecyclecheckUpdateData): CancelablePromise<MarecyclecheckUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{mare__organisation__uid}/marecyclecheck/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * The pregnancy_check_term is required when there is no activity given AND no activity can be found on the given date.
     *
     * For the update if you change the activity.uid, you will swap out the activity.
     * This means the pregnancy_check_term and extra_info from the old activity will be copied, unless (one of) these are given in the data.
     * The old activity will also be made empty in that case.
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns MareCycleCheck
     * @throws ApiError
     */
    public static marecyclecheckPartialUpdate(data: MarecyclecheckPartialUpdateData): CancelablePromise<MarecyclecheckPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{mare__organisation__uid}/marecyclecheck/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * The pregnancy_check_term is required when there is no activity given AND no activity can be found on the given date.
     *
     * For the update if you change the activity.uid, you will swap out the activity.
     * This means the pregnancy_check_term and extra_info from the old activity will be copied, unless (one of) these are given in the data.
     * The old activity will also be made empty in that case.
     * @param data The data for the request.
     * @param data.mareOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static marecyclecheckDestroy(data: MarecyclecheckDestroyData): CancelablePromise<MarecyclecheckDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{mare__organisation__uid}/marecyclecheck/{uid}',
            path: {
                mare__organisation__uid: data.mareOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class OauthService {
    /**
     * This is the view that is called on callback from the provider.
     * @param data The data for the request.
     * @param data.provider
     * @throws ApiError
     */
    public static apiV5AuthorizeRetrieve(data: ApiV5AuthorizeRetrieveData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/{provider}/authorize',
            path: {
                provider: data.provider
            },
            errors: {
                302: 'No response body'
            }
        });
    }
    
    /**
     * This is the view that is called on callback from the provider.
     *
     * Please note that additional keyword argument can be send (the Serializer is not used internally)
     * @param data The data for the request.
     * @param data.provider
     * @param data.requestBody
     * @throws ApiError
     */
    public static apiV5AuthorizeCreate(data: ApiV5AuthorizeCreateData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/{provider}/authorize',
            path: {
                provider: data.provider
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                302: 'No response body'
            }
        });
    }
    
    /**
     * View to build a full authorize callback uri and sets state in the session.
     *
     * In the javascript client you should check response.redirected. If true, open the redirect url (in a new window)
     *
     * The callback url will be of the form: /api/v5/{provider}/authorize
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Redirect
     * @throws ApiError
     */
    public static apiV5OauthLoginCreate(data: ApiV5OauthLoginCreateData): CancelablePromise<ApiV5OauthLoginCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/oauth/login',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns OAuth2Token
     * @throws ApiError
     */
    public static oauthTokensList(data: OauthTokensListData): CancelablePromise<OauthTokensListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/oauth/tokens',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns OAuth2Token
     * @throws ApiError
     */
    public static oauthTokensRetrieve(data: OauthTokensRetrieveData): CancelablePromise<OauthTokensRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/oauth/tokens/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static oauthTokensDestroy(data: OauthTokensDestroyData): CancelablePromise<OauthTokensDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/oauth/tokens/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class OrdersService {
    /**
     * Creates the relation linking this semen order line and the stallion mount that was picked after validating:
     * - the stallion_mounts can be picked by this user
     * - the total requested amount from the corresponding mount is available
     * - the total requested amount corresponds to the required amount of this order_item
     *
     * You should pick the entire order_item in one request. You can supply multiple stallion_mount and amount
     * tuples, but the tuple should be unique.
     * @param data The data for the request.
     * @param data.orderSupplierUid
     * @param data.orderUid
     * @param data.uid
     * @param data.requestBody
     * @returns OrderItemStallionMountPicker
     * @throws ApiError
     */
    public static ordersSuppliedSemenorderitemsPickstallionmountsCreate(data: OrdersSuppliedSemenorderitemsPickstallionmountsCreateData): CancelablePromise<OrdersSuppliedSemenorderitemsPickstallionmountsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{order__supplier__uid}/orders/supplied/{order__uid}/semenorderitems/{uid}/pickstallionmounts',
            path: {
                order__supplier__uid: data.orderSupplierUid,
                order__uid: data.orderUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Unpick a previously picked Oderitem, in case the wrong stallion mount was picked
     * @param data The data for the request.
     * @param data.orderSupplierUid
     * @param data.orderUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static ordersSuppliedSemenorderitemsUnpickstallionmountsDestroy(data: OrdersSuppliedSemenorderitemsUnpickstallionmountsDestroyData): CancelablePromise<OrdersSuppliedSemenorderitemsUnpickstallionmountsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{order__supplier__uid}/orders/supplied/{order__uid}/semenorderitems/{uid}/unpickstallionmounts',
            path: {
                order__supplier__uid: data.orderSupplierUid,
                order__uid: data.orderUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Orders endpoint intended for horse breeders or anyone that wants to POST an order directly at a stallion keeper.
     * The organisation in the path corresponds to the purchaser's organisation (typically the HB). The stallion keeper's
     * organisation is reflected in the 'supplier' field and show's the organisation's public_access_uuid.
     * (See `supplied-orders` for order management at the stallion keeper.)
     *
     * For the Customer and Horse fields two instances are made: one for the supplier and one for the purchaser.
     * The former are linked to the order, yet this endpoint will expect and provide the purchaser's variants
     * (both uid and nested objects).
     *
     * The PATCH endpoint allows the horse breeder to set or change the purchaser organisation (to one of his own). All
     * other fields are ignored.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.breedingPlanUid
     * @param data.breedingPlanUidIn Multiple values may be separated by commas.
     * @param data.number
     * @param data.numberIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.orderitemMareUid
     * @param data.orderitemMareUidIn Multiple values may be separated by commas.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.paymentStatus * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     * @param data.paymentStatusIn Multiple values may be separated by commas.
     * @param data.shippingDate
     * @param data.shippingDateGt
     * @param data.shippingDateGte
     * @param data.shippingDateLt
     * @param data.shippingDateLte
     * @param data.supplierPublicAccessUuid
     * @param data.supplierPublicAccessUuidIn Multiple values may be separated by commas.
     * @param data.uid
     * @param data.uidIn Multiple values may be separated by commas.
     * @returns PaginatedPurchaserOrderList
     * @throws ApiError
     */
    public static ordersPurchasedList(data: OrdersPurchasedListData): CancelablePromise<OrdersPurchasedListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{purchaser__uid}/orders/purchased',
            path: {
                purchaser__uid: data.purchaserUid
            },
            query: {
                breeding_plan__uid: data.breedingPlanUid,
                breeding_plan__uid__in: data.breedingPlanUidIn,
                number: data.number,
                number__in: data.numberIn,
                o: data.o,
                orderitem__mare__uid: data.orderitemMareUid,
                orderitem__mare__uid__in: data.orderitemMareUidIn,
                page: data.page,
                page_size: data.pageSize,
                payment_status: data.paymentStatus,
                payment_status__in: data.paymentStatusIn,
                shipping_date: data.shippingDate,
                shipping_date__gt: data.shippingDateGt,
                shipping_date__gte: data.shippingDateGte,
                shipping_date__lt: data.shippingDateLt,
                shipping_date__lte: data.shippingDateLte,
                supplier__public_access_uuid: data.supplierPublicAccessUuid,
                supplier__public_access_uuid__in: data.supplierPublicAccessUuidIn,
                uid: data.uid,
                uid__in: data.uidIn
            }
        });
    }
    
    /**
     * Orders endpoint intended for horse breeders or anyone that wants to POST an order directly at a stallion keeper.
     * The organisation in the path corresponds to the purchaser's organisation (typically the HB). The stallion keeper's
     * organisation is reflected in the 'supplier' field and show's the organisation's public_access_uuid.
     * (See `supplied-orders` for order management at the stallion keeper.)
     *
     * For the Customer and Horse fields two instances are made: one for the supplier and one for the purchaser.
     * The former are linked to the order, yet this endpoint will expect and provide the purchaser's variants
     * (both uid and nested objects).
     *
     * The PATCH endpoint allows the horse breeder to set or change the purchaser organisation (to one of his own). All
     * other fields are ignored.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.requestBody
     * @returns PurchaserOrderDetail
     * @throws ApiError
     */
    public static ordersPurchasedCreate(data: OrdersPurchasedCreateData): CancelablePromise<OrdersPurchasedCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{purchaser__uid}/orders/purchased',
            path: {
                purchaser__uid: data.purchaserUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders endpoint intended for horse breeders or anyone that wants to POST an order directly at a stallion keeper.
     * The organisation in the path corresponds to the purchaser's organisation (typically the HB). The stallion keeper's
     * organisation is reflected in the 'supplier' field and show's the organisation's public_access_uuid.
     * (See `supplied-orders` for order management at the stallion keeper.)
     *
     * For the Customer and Horse fields two instances are made: one for the supplier and one for the purchaser.
     * The former are linked to the order, yet this endpoint will expect and provide the purchaser's variants
     * (both uid and nested objects).
     *
     * The PATCH endpoint allows the horse breeder to set or change the purchaser organisation (to one of his own). All
     * other fields are ignored.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @returns PurchaserOrderDetail
     * @throws ApiError
     */
    public static ordersPurchasedRetrieve(data: OrdersPurchasedRetrieveData): CancelablePromise<OrdersPurchasedRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{purchaser__uid}/orders/purchased/{uid}',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Orders endpoint intended for horse breeders or anyone that wants to POST an order directly at a stallion keeper.
     * The organisation in the path corresponds to the purchaser's organisation (typically the HB). The stallion keeper's
     * organisation is reflected in the 'supplier' field and show's the organisation's public_access_uuid.
     * (See `supplied-orders` for order management at the stallion keeper.)
     *
     * For the Customer and Horse fields two instances are made: one for the supplier and one for the purchaser.
     * The former are linked to the order, yet this endpoint will expect and provide the purchaser's variants
     * (both uid and nested objects).
     *
     * The PATCH endpoint allows the horse breeder to set or change the purchaser organisation (to one of his own). All
     * other fields are ignored.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @param data.requestBody
     * @returns PurchaserOrderUpdate
     * @throws ApiError
     */
    public static ordersPurchasedUpdate(data: OrdersPurchasedUpdateData): CancelablePromise<OrdersPurchasedUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{purchaser__uid}/orders/purchased/{uid}',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders endpoint intended for horse breeders or anyone that wants to POST an order directly at a stallion keeper.
     * The organisation in the path corresponds to the purchaser's organisation (typically the HB). The stallion keeper's
     * organisation is reflected in the 'supplier' field and show's the organisation's public_access_uuid.
     * (See `supplied-orders` for order management at the stallion keeper.)
     *
     * For the Customer and Horse fields two instances are made: one for the supplier and one for the purchaser.
     * The former are linked to the order, yet this endpoint will expect and provide the purchaser's variants
     * (both uid and nested objects).
     *
     * The PATCH endpoint allows the horse breeder to set or change the purchaser organisation (to one of his own). All
     * other fields are ignored.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @param data.requestBody
     * @returns PurchaserOrderUpdate
     * @throws ApiError
     */
    public static ordersPurchasedPartialUpdate(data: OrdersPurchasedPartialUpdateData): CancelablePromise<OrdersPurchasedPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{purchaser__uid}/orders/purchased/{uid}',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * It will return only the last one (ordered by shipping_date) if exclude_children is True (the default)
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.requestBody
     * @returns PurchaserOrderDetail
     * @throws ApiError
     */
    public static ordersPurchasedFindParentSemenOrdersCreate(data: OrdersPurchasedFindParentSemenOrdersCreateData): CancelablePromise<OrdersPurchasedFindParentSemenOrdersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{purchaser__uid}/orders/purchased/find_parent_semen_orders',
            path: {
                purchaser__uid: data.purchaserUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders endpoint intended for stallion keepers: for entering orders made over different channels (phone email)
     * from customers that want to order horse semen (typically horse breeders).
     * (See `purchased-orders` for order management at the horse breeder.)
     *
     * Available orders are looked up through the order's customer's organization.
     *
     * When POSTing an Order:
     * - You should supply a contact uid for the customer (requester is optional). These contact's
     * organizations should be available to the requesting user (typically they are the same contact).
     * - You can (and should) supply embedded order_items.
     * The order item's stallion_mount picking can be done over
     * `/api/v5/organisations/{order__customer__organisation__uid}/suppliedorders/{order__uid}/orderitems/{uid}/pickstallionmounts`
     * once the order is made.
     * - You don't need to care about read-only fields.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.breedingPlanUid
     * @param data.breedingPlanUidIn Multiple values may be separated by commas.
     * @param data.createdOnAfter
     * @param data.createdOnBefore
     * @param data.customerCustomerId
     * @param data.customerCustomerIdIn Multiple values may be separated by commas.
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.hasExclusivelySubscriptionItems
     * @param data.hasSubscriptionItems
     * @param data.inseminatorUid
     * @param data.inseminatorUidIn Multiple values may be separated by commas.
     * @param data.isComplete
     * @param data.isPicked The order is picked when it has no pickable (default or breeding type) order items left without a 'picked_on' value.
     *
     * * `YES` - yes
     * * `NO` - no
     * * `NO_PICKING_NEEDED` - n/a
     * @param data.number
     * @param data.numberIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.orderitemMareUidAnd
     * @param data.orderitemProductUidAnd
     * @param data.orderitemProductTypeAnd Every order item needs a product type. This is used in the business logic to identify the type of the order item.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.paymentStatus * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     * @param data.paymentStatusIn Multiple values may be separated by commas.
     * @param data.q
     * @param data.requesterUid
     * @param data.requesterUidIn Multiple values may be separated by commas.
     * @param data.semenCollectionStationUidAnd semen_collection_station
     * @param data.shippingAddressLine1
     * @param data.shippingAddressLine1In Multiple values may be separated by commas.
     * @param data.shippingAddressLine2
     * @param data.shippingAddressLine2In Multiple values may be separated by commas.
     * @param data.shippingAddressLine3
     * @param data.shippingAddressLine3In Multiple values may be separated by commas.
     * @param data.shippingCity
     * @param data.shippingCityIn Multiple values may be separated by commas.
     * @param data.shippingCountry * `AF` - Afghanistan
     * * `AX` - Åland Islands
     * * `AL` - Albania
     * * `DZ` - Algeria
     * * `AS` - American Samoa
     * * `AD` - Andorra
     * * `AO` - Angola
     * * `AI` - Anguilla
     * * `AQ` - Antarctica
     * * `AG` - Antigua and Barbuda
     * * `AR` - Argentina
     * * `AM` - Armenia
     * * `AW` - Aruba
     * * `AU` - Australia
     * * `AT` - Austria
     * * `AZ` - Azerbaijan
     * * `BS` - Bahamas
     * * `BH` - Bahrain
     * * `BD` - Bangladesh
     * * `BB` - Barbados
     * * `BY` - Belarus
     * * `BE` - Belgium
     * * `BZ` - Belize
     * * `BJ` - Benin
     * * `BM` - Bermuda
     * * `BT` - Bhutan
     * * `BO` - Bolivia
     * * `BQ` - Bonaire, Sint Eustatius and Saba
     * * `BA` - Bosnia and Herzegovina
     * * `BW` - Botswana
     * * `BV` - Bouvet Island
     * * `BR` - Brazil
     * * `IO` - British Indian Ocean Territory
     * * `BN` - Brunei
     * * `BG` - Bulgaria
     * * `BF` - Burkina Faso
     * * `BI` - Burundi
     * * `CV` - Cabo Verde
     * * `KH` - Cambodia
     * * `CM` - Cameroon
     * * `CA` - Canada
     * * `KY` - Cayman Islands
     * * `CF` - Central African Republic
     * * `TD` - Chad
     * * `CL` - Chile
     * * `CN` - China
     * * `CX` - Christmas Island
     * * `CC` - Cocos (Keeling) Islands
     * * `CO` - Colombia
     * * `KM` - Comoros
     * * `CG` - Congo
     * * `CD` - Congo (the Democratic Republic of the)
     * * `CK` - Cook Islands
     * * `CR` - Costa Rica
     * * `CI` - Côte d'Ivoire
     * * `HR` - Croatia
     * * `CU` - Cuba
     * * `CW` - Curaçao
     * * `CY` - Cyprus
     * * `CZ` - Czechia
     * * `DK` - Denmark
     * * `DJ` - Djibouti
     * * `DM` - Dominica
     * * `DO` - Dominican Republic
     * * `EC` - Ecuador
     * * `EG` - Egypt
     * * `SV` - El Salvador
     * * `GQ` - Equatorial Guinea
     * * `ER` - Eritrea
     * * `EE` - Estonia
     * * `SZ` - Eswatini
     * * `ET` - Ethiopia
     * * `FK` - Falkland Islands (Malvinas)
     * * `FO` - Faroe Islands
     * * `FJ` - Fiji
     * * `FI` - Finland
     * * `FR` - France
     * * `GF` - French Guiana
     * * `PF` - French Polynesia
     * * `TF` - French Southern Territories
     * * `GA` - Gabon
     * * `GM` - Gambia
     * * `GE` - Georgia
     * * `DE` - Germany
     * * `GH` - Ghana
     * * `GI` - Gibraltar
     * * `GR` - Greece
     * * `GL` - Greenland
     * * `GD` - Grenada
     * * `GP` - Guadeloupe
     * * `GU` - Guam
     * * `GT` - Guatemala
     * * `GG` - Guernsey
     * * `GN` - Guinea
     * * `GW` - Guinea-Bissau
     * * `GY` - Guyana
     * * `HT` - Haiti
     * * `HM` - Heard Island and McDonald Islands
     * * `VA` - Holy See
     * * `HN` - Honduras
     * * `HK` - Hong Kong
     * * `HU` - Hungary
     * * `IS` - Iceland
     * * `IN` - India
     * * `ID` - Indonesia
     * * `IR` - Iran
     * * `IQ` - Iraq
     * * `IE` - Ireland
     * * `IM` - Isle of Man
     * * `IL` - Israel
     * * `IT` - Italy
     * * `JM` - Jamaica
     * * `JP` - Japan
     * * `JE` - Jersey
     * * `JO` - Jordan
     * * `KZ` - Kazakhstan
     * * `KE` - Kenya
     * * `KI` - Kiribati
     * * `KW` - Kuwait
     * * `KG` - Kyrgyzstan
     * * `LA` - Laos
     * * `LV` - Latvia
     * * `LB` - Lebanon
     * * `LS` - Lesotho
     * * `LR` - Liberia
     * * `LY` - Libya
     * * `LI` - Liechtenstein
     * * `LT` - Lithuania
     * * `LU` - Luxembourg
     * * `MO` - Macao
     * * `MG` - Madagascar
     * * `MW` - Malawi
     * * `MY` - Malaysia
     * * `MV` - Maldives
     * * `ML` - Mali
     * * `MT` - Malta
     * * `MH` - Marshall Islands
     * * `MQ` - Martinique
     * * `MR` - Mauritania
     * * `MU` - Mauritius
     * * `YT` - Mayotte
     * * `MX` - Mexico
     * * `FM` - Micronesia
     * * `MD` - Moldova
     * * `MC` - Monaco
     * * `MN` - Mongolia
     * * `ME` - Montenegro
     * * `MS` - Montserrat
     * * `MA` - Morocco
     * * `MZ` - Mozambique
     * * `MM` - Myanmar
     * * `NA` - Namibia
     * * `NR` - Nauru
     * * `NP` - Nepal
     * * `NL` - Netherlands
     * * `NC` - New Caledonia
     * * `NZ` - New Zealand
     * * `NI` - Nicaragua
     * * `NE` - Niger
     * * `NG` - Nigeria
     * * `NU` - Niue
     * * `NF` - Norfolk Island
     * * `KP` - North Korea
     * * `MK` - North Macedonia
     * * `MP` - Northern Mariana Islands
     * * `NO` - Norway
     * * `OM` - Oman
     * * `PK` - Pakistan
     * * `PW` - Palau
     * * `PS` - Palestine, State of
     * * `PA` - Panama
     * * `PG` - Papua New Guinea
     * * `PY` - Paraguay
     * * `PE` - Peru
     * * `PH` - Philippines
     * * `PN` - Pitcairn
     * * `PL` - Poland
     * * `PT` - Portugal
     * * `PR` - Puerto Rico
     * * `QA` - Qatar
     * * `RE` - Réunion
     * * `RO` - Romania
     * * `RU` - Russia
     * * `RW` - Rwanda
     * * `BL` - Saint Barthélemy
     * * `SH` - Saint Helena, Ascension and Tristan da Cunha
     * * `KN` - Saint Kitts and Nevis
     * * `LC` - Saint Lucia
     * * `MF` - Saint Martin (French part)
     * * `PM` - Saint Pierre and Miquelon
     * * `VC` - Saint Vincent and the Grenadines
     * * `WS` - Samoa
     * * `SM` - San Marino
     * * `ST` - Sao Tome and Principe
     * * `SA` - Saudi Arabia
     * * `SN` - Senegal
     * * `RS` - Serbia
     * * `SC` - Seychelles
     * * `SL` - Sierra Leone
     * * `SG` - Singapore
     * * `SX` - Sint Maarten (Dutch part)
     * * `SK` - Slovakia
     * * `SI` - Slovenia
     * * `SB` - Solomon Islands
     * * `SO` - Somalia
     * * `ZA` - South Africa
     * * `GS` - South Georgia and the South Sandwich Islands
     * * `KR` - South Korea
     * * `SS` - South Sudan
     * * `ES` - Spain
     * * `LK` - Sri Lanka
     * * `SD` - Sudan
     * * `SR` - Suriname
     * * `SJ` - Svalbard and Jan Mayen
     * * `SE` - Sweden
     * * `CH` - Switzerland
     * * `SY` - Syria
     * * `TW` - Taiwan
     * * `TJ` - Tajikistan
     * * `TZ` - Tanzania
     * * `TH` - Thailand
     * * `TL` - Timor-Leste
     * * `TG` - Togo
     * * `TK` - Tokelau
     * * `TO` - Tonga
     * * `TT` - Trinidad and Tobago
     * * `TN` - Tunisia
     * * `TR` - Türkiye
     * * `TM` - Turkmenistan
     * * `TC` - Turks and Caicos Islands
     * * `TV` - Tuvalu
     * * `UG` - Uganda
     * * `UA` - Ukraine
     * * `AE` - United Arab Emirates
     * * `GB` - United Kingdom
     * * `UM` - United States Minor Outlying Islands
     * * `US` - United States of America
     * * `UY` - Uruguay
     * * `UZ` - Uzbekistan
     * * `VU` - Vanuatu
     * * `VE` - Venezuela
     * * `VN` - Vietnam
     * * `VG` - Virgin Islands (British)
     * * `VI` - Virgin Islands (U.S.)
     * * `WF` - Wallis and Futuna
     * * `EH` - Western Sahara
     * * `YE` - Yemen
     * * `ZM` - Zambia
     * * `ZW` - Zimbabwe
     * @param data.shippingCountryIn Multiple values may be separated by commas.
     * @param data.shippingDate
     * @param data.shippingDateGt
     * @param data.shippingDateGte
     * @param data.shippingDateLt
     * @param data.shippingDateLte
     * @param data.shippingName
     * @param data.shippingNameIn Multiple values may be separated by commas.
     * @param data.shippingPostcode
     * @param data.shippingPostcodeIn Multiple values may be separated by commas.
     * @param data.shippingSearchText
     * @param data.shippingSearchTextIn Multiple values may be separated by commas.
     * @param data.shippingState
     * @param data.shippingStateIn Multiple values may be separated by commas.
     * @param data.showShippingOnInseminationRoute The order has a shipping order item that should be shown on the insemination route.
     * @param data.uid
     * @param data.uidIn Multiple values may be separated by commas.
     * @returns PaginatedSupplierOrderList
     * @throws ApiError
     */
    public static ordersSuppliedList(data: OrdersSuppliedListData): CancelablePromise<OrdersSuppliedListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied',
            path: {
                supplier__uid: data.supplierUid
            },
            query: {
                breeding_plan__uid: data.breedingPlanUid,
                breeding_plan__uid__in: data.breedingPlanUidIn,
                created_on_after: data.createdOnAfter,
                created_on_before: data.createdOnBefore,
                customer__customer_id: data.customerCustomerId,
                customer__customer_id__in: data.customerCustomerIdIn,
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                has_exclusively_subscription_items: data.hasExclusivelySubscriptionItems,
                has_subscription_items: data.hasSubscriptionItems,
                inseminator__uid: data.inseminatorUid,
                inseminator__uid__in: data.inseminatorUidIn,
                is_complete: data.isComplete,
                is_picked: data.isPicked,
                number: data.number,
                number__in: data.numberIn,
                o: data.o,
                orderitem__mare__uid_and: data.orderitemMareUidAnd,
                orderitem__product__uid_and: data.orderitemProductUidAnd,
                orderitem__product_type_and: data.orderitemProductTypeAnd,
                page: data.page,
                page_size: data.pageSize,
                payment_status: data.paymentStatus,
                payment_status__in: data.paymentStatusIn,
                q: data.q,
                requester__uid: data.requesterUid,
                requester__uid__in: data.requesterUidIn,
                semen_collection_station__uid_and: data.semenCollectionStationUidAnd,
                shipping_address_line1: data.shippingAddressLine1,
                shipping_address_line1__in: data.shippingAddressLine1In,
                shipping_address_line2: data.shippingAddressLine2,
                shipping_address_line2__in: data.shippingAddressLine2In,
                shipping_address_line3: data.shippingAddressLine3,
                shipping_address_line3__in: data.shippingAddressLine3In,
                shipping_city: data.shippingCity,
                shipping_city__in: data.shippingCityIn,
                shipping_country: data.shippingCountry,
                shipping_country__in: data.shippingCountryIn,
                shipping_date: data.shippingDate,
                shipping_date__gt: data.shippingDateGt,
                shipping_date__gte: data.shippingDateGte,
                shipping_date__lt: data.shippingDateLt,
                shipping_date__lte: data.shippingDateLte,
                shipping_name: data.shippingName,
                shipping_name__in: data.shippingNameIn,
                shipping_postcode: data.shippingPostcode,
                shipping_postcode__in: data.shippingPostcodeIn,
                shipping_search_text: data.shippingSearchText,
                shipping_search_text__in: data.shippingSearchTextIn,
                shipping_state: data.shippingState,
                shipping_state__in: data.shippingStateIn,
                show_shipping_on_insemination_route: data.showShippingOnInseminationRoute,
                uid: data.uid,
                uid__in: data.uidIn
            }
        });
    }
    
    /**
     * Orders endpoint intended for stallion keepers: for entering orders made over different channels (phone email)
     * from customers that want to order horse semen (typically horse breeders).
     * (See `purchased-orders` for order management at the horse breeder.)
     *
     * Available orders are looked up through the order's customer's organization.
     *
     * When POSTing an Order:
     * - You should supply a contact uid for the customer (requester is optional). These contact's
     * organizations should be available to the requesting user (typically they are the same contact).
     * - You can (and should) supply embedded order_items.
     * The order item's stallion_mount picking can be done over
     * `/api/v5/organisations/{order__customer__organisation__uid}/suppliedorders/{order__uid}/orderitems/{uid}/pickstallionmounts`
     * once the order is made.
     * - You don't need to care about read-only fields.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.requestBody
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static ordersSuppliedCreate(data: OrdersSuppliedCreateData): CancelablePromise<OrdersSuppliedCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied',
            path: {
                supplier__uid: data.supplierUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders endpoint intended for stallion keepers: for entering orders made over different channels (phone email)
     * from customers that want to order horse semen (typically horse breeders).
     * (See `purchased-orders` for order management at the horse breeder.)
     *
     * Available orders are looked up through the order's customer's organization.
     *
     * When POSTing an Order:
     * - You should supply a contact uid for the customer (requester is optional). These contact's
     * organizations should be available to the requesting user (typically they are the same contact).
     * - You can (and should) supply embedded order_items.
     * The order item's stallion_mount picking can be done over
     * `/api/v5/organisations/{order__customer__organisation__uid}/suppliedorders/{order__uid}/orderitems/{uid}/pickstallionmounts`
     * once the order is made.
     * - You don't need to care about read-only fields.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.uid
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static ordersSuppliedRetrieve(data: OrdersSuppliedRetrieveData): CancelablePromise<OrdersSuppliedRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied/{uid}',
            path: {
                supplier__uid: data.supplierUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Orders endpoint intended for stallion keepers: for entering orders made over different channels (phone email)
     * from customers that want to order horse semen (typically horse breeders).
     * (See `purchased-orders` for order management at the horse breeder.)
     *
     * Available orders are looked up through the order's customer's organization.
     *
     * When POSTing an Order:
     * - You should supply a contact uid for the customer (requester is optional). These contact's
     * organizations should be available to the requesting user (typically they are the same contact).
     * - You can (and should) supply embedded order_items.
     * The order item's stallion_mount picking can be done over
     * `/api/v5/organisations/{order__customer__organisation__uid}/suppliedorders/{order__uid}/orderitems/{uid}/pickstallionmounts`
     * once the order is made.
     * - You don't need to care about read-only fields.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.uid
     * @param data.requestBody
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static ordersSuppliedUpdate(data: OrdersSuppliedUpdateData): CancelablePromise<OrdersSuppliedUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied/{uid}',
            path: {
                supplier__uid: data.supplierUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders endpoint intended for stallion keepers: for entering orders made over different channels (phone email)
     * from customers that want to order horse semen (typically horse breeders).
     * (See `purchased-orders` for order management at the horse breeder.)
     *
     * Available orders are looked up through the order's customer's organization.
     *
     * When POSTing an Order:
     * - You should supply a contact uid for the customer (requester is optional). These contact's
     * organizations should be available to the requesting user (typically they are the same contact).
     * - You can (and should) supply embedded order_items.
     * The order item's stallion_mount picking can be done over
     * `/api/v5/organisations/{order__customer__organisation__uid}/suppliedorders/{order__uid}/orderitems/{uid}/pickstallionmounts`
     * once the order is made.
     * - You don't need to care about read-only fields.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.uid
     * @param data.requestBody
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static ordersSuppliedPartialUpdate(data: OrdersSuppliedPartialUpdateData): CancelablePromise<OrdersSuppliedPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied/{uid}',
            path: {
                supplier__uid: data.supplierUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders endpoint intended for stallion keepers: for entering orders made over different channels (phone email)
     * from customers that want to order horse semen (typically horse breeders).
     * (See `purchased-orders` for order management at the horse breeder.)
     *
     * Available orders are looked up through the order's customer's organization.
     *
     * When POSTing an Order:
     * - You should supply a contact uid for the customer (requester is optional). These contact's
     * organizations should be available to the requesting user (typically they are the same contact).
     * - You can (and should) supply embedded order_items.
     * The order item's stallion_mount picking can be done over
     * `/api/v5/organisations/{order__customer__organisation__uid}/suppliedorders/{order__uid}/orderitems/{uid}/pickstallionmounts`
     * once the order is made.
     * - You don't need to care about read-only fields.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static ordersSuppliedDestroy(data: OrdersSuppliedDestroyData): CancelablePromise<OrdersSuppliedDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied/{uid}',
            path: {
                supplier__uid: data.supplierUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * The order shows the version of the *customer* at the time the order was made.
     * By using this action that version will be updated to the most recent.
     *
     * Note: Everything added to the body is ignored.
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.uid
     * @param data.requestBody
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static ordersSuppliedUpdateCustomerContactPartialUpdate(data: OrdersSuppliedUpdateCustomerContactPartialUpdateData): CancelablePromise<OrdersSuppliedUpdateCustomerContactPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied/{uid}/update_customer_contact',
            path: {
                supplier__uid: data.supplierUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * It will return only the last one (ordered by shipping_date) if exclude_children is True (the default)
     * @param data The data for the request.
     * @param data.supplierUid
     * @param data.requestBody
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static ordersSuppliedFindParentSemenOrdersCreate(data: OrdersSuppliedFindParentSemenOrdersCreateData): CancelablePromise<OrdersSuppliedFindParentSemenOrdersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{supplier__uid}/orders/supplied/find_parent_semen_orders',
            path: {
                supplier__uid: data.supplierUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class OrganisationService {
    /**
     * The detail view has many sub-urls, for example {organisation_uid}/horses/, {organisation_uid}/stables/
     * @param data The data for the request.
     * @param data.o Which field to use when ordering the results.
     * @returns OrganisationList
     * @throws ApiError
     */
    public static rootList(data: RootListData = {}): CancelablePromise<RootListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations',
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * The detail view has many sub-urls, for example {organisation_uid}/horses/, {organisation_uid}/stables/
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Organisation
     * @throws ApiError
     */
    public static rootCreate(data: RootCreateData): CancelablePromise<RootCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * The detail view has many sub-urls, for example {organisation_uid}/horses/, {organisation_uid}/stables/
     * @param data The data for the request.
     * @param data.uid
     * @returns Organisation
     * @throws ApiError
     */
    public static rootRetrieve(data: RootRetrieveData): CancelablePromise<RootRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{uid}',
            path: {
                uid: data.uid
            }
        });
    }
    
    /**
     * The detail view has many sub-urls, for example {organisation_uid}/horses/, {organisation_uid}/stables/
     * @param data The data for the request.
     * @param data.uid
     * @param data.requestBody
     * @returns Organisation
     * @throws ApiError
     */
    public static rootUpdate(data: RootUpdateData): CancelablePromise<RootUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{uid}',
            path: {
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * The detail view has many sub-urls, for example {organisation_uid}/horses/, {organisation_uid}/stables/
     * @param data The data for the request.
     * @param data.uid
     * @param data.requestBody
     * @returns Organisation
     * @throws ApiError
     */
    public static rootPartialUpdate(data: RootPartialUpdateData): CancelablePromise<RootPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{uid}',
            path: {
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * The detail view has many sub-urls, for example {organisation_uid}/horses/, {organisation_uid}/stables/
     * @param data The data for the request.
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static rootDestroy(data: RootDestroyData): CancelablePromise<RootDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{uid}',
            path: {
                uid: data.uid
            }
        });
    }
}

export class PaymentProvidersService {
    /**
     * List and create a ContactPaymentProvider where the purchaser in the url represents the organisation giving
     * the mandate. The mandate is given to the supplier organisation identified by the uuid in the posted body.
     *
     * In other words: with this the purchaser is making a payment link with which he can give the supplier a
     * mandate for billing recurring expenses from e.g. service contracts.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedPurchaserPaymentProviderList
     * @throws ApiError
     */
    public static paymentProvidersList(data: PaymentProvidersListData): CancelablePromise<PaymentProvidersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{purchaser__uid}/payment_providers',
            path: {
                purchaser__uid: data.purchaserUid
            },
            query: {
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * List and create a ContactPaymentProvider where the purchaser in the url represents the organisation giving
     * the mandate. The mandate is given to the supplier organisation identified by the uuid in the posted body.
     *
     * In other words: with this the purchaser is making a payment link with which he can give the supplier a
     * mandate for billing recurring expenses from e.g. service contracts.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @returns PurchaserPaymentProvider
     * @throws ApiError
     */
    public static paymentProvidersRetrieve(data: PaymentProvidersRetrieveData): CancelablePromise<PaymentProvidersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{purchaser__uid}/payment_providers/{uid}',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * List and create a ContactPaymentProvider where the purchaser in the url represents the organisation giving
     * the mandate. The mandate is given to the supplier organisation identified by the uuid in the posted body.
     *
     * In other words: with this the purchaser is making a payment link with which he can give the supplier a
     * mandate for billing recurring expenses from e.g. service contracts.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static paymentProvidersDestroy(data: PaymentProvidersDestroyData): CancelablePromise<PaymentProvidersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{purchaser__uid}/payment_providers/{uid}',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Creates a ContactPaymentProvider and a new payment valued at 1 cent. The response will be a redirect with
     * a url to fulfill that payment with the respective payment provider (currently we support only Mollie).
     *
     * During the procedure, the user can provide a mandate. When completed the provider will POST to a callback
     * in which backend will check if the mandate was provided and update the mandate for the related (purchaser,
     * supplier) tuple.
     *
     * When successful this should be visible in the list call.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.requestBody
     * @returns Redirect
     * @throws ApiError
     */
    public static paymentProvidersCreateWithMandateCreate(data: PaymentProvidersCreateWithMandateCreateData): CancelablePromise<PaymentProvidersCreateWithMandateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{purchaser__uid}/payment_providers/create_with_mandate',
            path: {
                purchaser__uid: data.purchaserUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
}

export class PaymentsService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.amountGte
     * @param data.amountLte
     * @param data.o Which field to use when ordering the results.
     * @param data.orderUid
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.status * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     * @param data.type * `Bank` - Bank
     * * `Cash` - Cash
     * * `Mollie` - Mollie
     * * `PayPal` - PayPal
     * * `Pin` - Pin
     * * `CreditCard` - CreditCard
     * @returns PaginatedPaymentList
     * @throws ApiError
     */
    public static paymentsList(data: PaymentsListData): CancelablePromise<PaymentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/payments',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                amount__gte: data.amountGte,
                amount__lte: data.amountLte,
                o: data.o,
                order__uid: data.orderUid,
                page: data.page,
                page_size: data.pageSize,
                status: data.status,
                type: data.type
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Payment
     * @throws ApiError
     */
    public static paymentsCreate(data: PaymentsCreateData): CancelablePromise<PaymentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/payments',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this payment.
     * @param data.organisationUid
     * @returns Payment
     * @throws ApiError
     */
    public static paymentsRetrieve(data: PaymentsRetrieveData): CancelablePromise<PaymentsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/payments/{id}',
            path: {
                id: data.id,
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this payment.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Payment
     * @throws ApiError
     */
    public static paymentsUpdate(data: PaymentsUpdateData): CancelablePromise<PaymentsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/payments/{id}',
            path: {
                id: data.id,
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this payment.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Payment
     * @throws ApiError
     */
    public static paymentsPartialUpdate(data: PaymentsPartialUpdateData): CancelablePromise<PaymentsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/payments/{id}',
            path: {
                id: data.id,
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this payment.
     * @param data.organisationUid
     * @returns void No response body
     * @throws ApiError
     */
    public static paymentsDestroy(data: PaymentsDestroyData): CancelablePromise<PaymentsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/payments/{id}',
            path: {
                id: data.id,
                organisation__uid: data.organisationUid
            }
        });
    }
}

export class PoiService {
    /**
     * View set for the polymorphic point of interest.
     * @param data The data for the request.
     * @param data.parentMapOrganisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns PointOfInterest
     * @throws ApiError
     */
    public static poiList(data: PoiListData): CancelablePromise<PoiListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{parent_map__organisation__uid}/poi',
            path: {
                parent_map__organisation__uid: data.parentMapOrganisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * View set for the polymorphic point of interest.
     * @param data The data for the request.
     * @param data.parentMapOrganisationUid
     * @param data.requestBody
     * @returns PointOfInterest
     * @throws ApiError
     */
    public static poiCreate(data: PoiCreateData): CancelablePromise<PoiCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{parent_map__organisation__uid}/poi',
            path: {
                parent_map__organisation__uid: data.parentMapOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the polymorphic point of interest.
     * @param data The data for the request.
     * @param data.parentMapOrganisationUid
     * @param data.uid
     * @returns PointOfInterest
     * @throws ApiError
     */
    public static poiRetrieve(data: PoiRetrieveData): CancelablePromise<PoiRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{parent_map__organisation__uid}/poi/{uid}',
            path: {
                parent_map__organisation__uid: data.parentMapOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * View set for the polymorphic point of interest.
     * @param data The data for the request.
     * @param data.parentMapOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns PointOfInterest
     * @throws ApiError
     */
    public static poiUpdate(data: PoiUpdateData): CancelablePromise<PoiUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{parent_map__organisation__uid}/poi/{uid}',
            path: {
                parent_map__organisation__uid: data.parentMapOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the polymorphic point of interest.
     * @param data The data for the request.
     * @param data.parentMapOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns PointOfInterest
     * @throws ApiError
     */
    public static poiPartialUpdate(data: PoiPartialUpdateData): CancelablePromise<PoiPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{parent_map__organisation__uid}/poi/{uid}',
            path: {
                parent_map__organisation__uid: data.parentMapOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * View set for the polymorphic point of interest.
     * @param data The data for the request.
     * @param data.parentMapOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static poiDestroy(data: PoiDestroyData): CancelablePromise<PoiDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{parent_map__organisation__uid}/poi/{uid}',
            path: {
                parent_map__organisation__uid: data.parentMapOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class ProductsService {
    /**
     * Products come in different flavors. Currently we distinguish 4: [Breeding, Shipping, subscription, activity].
     * The model's fields constitutes the union of each category's required fields:
     * - Breeding: needs a `stallion` and the `product_type` should be BREEDING.
     * - Shipping: needs a `shipping_provider_name` and `shipping_service_type`. The `product_type` should be SHIPPING.
     * - Subscription: needs a (generic) `plan` and te product_type should be SUBSCRIPTION.
     * - Activity: needs an `activity_type` and `to_invoice_start_date`. The product_type should be ACTIVITY.
     *
     * Product supports two prices:
     * - `current_price` (in the filter indicated as 'price_A'): if set, this represents the current price of
     * this product should it be ordered.
     * - `future_price` (in the filter indicated as 'price_B'): to set a price that should apply to this
     * product somewhere in the future.
     *
     * This comes as a pair with `future_price_application_date`: you should set or null both at a time.
     * Once the application date has passed, you can expect Backend to have updates the product such that
     * the once future_price is now the (current) price.
     *
     * Notes on Subscription product:
     * - The organisation will be able to create a service contract for its customers based on this product.
     * - Currently we only support Flat-Fee based plans, so you should supply a `price_A` on creation (and not
     * price points)
     * - The plan must be a 'generic plan', meaning that it can be offered by any organisation (and not just EquineM)
     *
     * Notes on Activity Product:
     * - The organisation can use this to make certain activities billable. A billable item will be made
     * whenever a customer marks an activity with the same `activity_type` as done.
     * - You can indicate a date from when these billable items should be produced (also retroactively).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.category
     * @param data.categoryDefaultIn Multiple values may be separated by commas.
     * @param data.currentPriceGte Current price is greater than or equal to
     * @param data.currentPriceLte Current price is smaller than or equal to
     * @param data.freshAvailable
     * @param data.frozenAvailable
     * @param data.futurePriceGte Future price is greater than or equal to
     * @param data.futurePriceLte Future price is smaller than or equal to
     * @param data.hidden
     * @param data.isCustomProduct
     * @param data.nameIcontains
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.planModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.planModuleIn Multiple values may be separated by commas.
     * @param data.productType Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     * @param data.productTypeIn Multiple values may be separated by commas.
     * @param data.shippingCountriesIcontains
     * @param data.shippingProviderNameIcontains
     * @param data.shippingServiceType * `REGULAR` - Regular
     * * `PICK_UP` - Pick up
     * * `SAME_DAY_DELIVERY` - Same day delivery
     * * `NEXT_DAY_DELIVERY` - Next day delivery
     * * `SUNDAY_HOLIDAY_DELIVERY` - Sunday and holiday delivery
     * * `STAFF_DELIVERY` - staff delivery
     * @param data.showInShop
     * @param data.stallionUid
     * @param data.stallionUidIn Multiple values may be separated by commas.
     * @returns PaginatedProductList
     * @throws ApiError
     */
    public static productsList(data: ProductsListData): CancelablePromise<ProductsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/products',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                category: data.category,
                category__default__in: data.categoryDefaultIn,
                current_price_gte: data.currentPriceGte,
                current_price_lte: data.currentPriceLte,
                fresh_available: data.freshAvailable,
                frozen_available: data.frozenAvailable,
                future_price_gte: data.futurePriceGte,
                future_price_lte: data.futurePriceLte,
                hidden: data.hidden,
                is_custom_product: data.isCustomProduct,
                name__icontains: data.nameIcontains,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                plan__module: data.planModule,
                plan__module__in: data.planModuleIn,
                product_type: data.productType,
                product_type__in: data.productTypeIn,
                shipping_countries__icontains: data.shippingCountriesIcontains,
                shipping_provider_name__icontains: data.shippingProviderNameIcontains,
                shipping_service_type: data.shippingServiceType,
                show_in_shop: data.showInShop,
                stallion__uid: data.stallionUid,
                stallion__uid__in: data.stallionUidIn
            }
        });
    }
    
    /**
     * Products come in different flavors. Currently we distinguish 4: [Breeding, Shipping, subscription, activity].
     * The model's fields constitutes the union of each category's required fields:
     * - Breeding: needs a `stallion` and the `product_type` should be BREEDING.
     * - Shipping: needs a `shipping_provider_name` and `shipping_service_type`. The `product_type` should be SHIPPING.
     * - Subscription: needs a (generic) `plan` and te product_type should be SUBSCRIPTION.
     * - Activity: needs an `activity_type` and `to_invoice_start_date`. The product_type should be ACTIVITY.
     *
     * Product supports two prices:
     * - `current_price` (in the filter indicated as 'price_A'): if set, this represents the current price of
     * this product should it be ordered.
     * - `future_price` (in the filter indicated as 'price_B'): to set a price that should apply to this
     * product somewhere in the future.
     *
     * This comes as a pair with `future_price_application_date`: you should set or null both at a time.
     * Once the application date has passed, you can expect Backend to have updates the product such that
     * the once future_price is now the (current) price.
     *
     * Notes on Subscription product:
     * - The organisation will be able to create a service contract for its customers based on this product.
     * - Currently we only support Flat-Fee based plans, so you should supply a `price_A` on creation (and not
     * price points)
     * - The plan must be a 'generic plan', meaning that it can be offered by any organisation (and not just EquineM)
     *
     * Notes on Activity Product:
     * - The organisation can use this to make certain activities billable. A billable item will be made
     * whenever a customer marks an activity with the same `activity_type` as done.
     * - You can indicate a date from when these billable items should be produced (also retroactively).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Product
     * @throws ApiError
     */
    public static productsCreate(data: ProductsCreateData): CancelablePromise<ProductsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/products',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Products come in different flavors. Currently we distinguish 4: [Breeding, Shipping, subscription, activity].
     * The model's fields constitutes the union of each category's required fields:
     * - Breeding: needs a `stallion` and the `product_type` should be BREEDING.
     * - Shipping: needs a `shipping_provider_name` and `shipping_service_type`. The `product_type` should be SHIPPING.
     * - Subscription: needs a (generic) `plan` and te product_type should be SUBSCRIPTION.
     * - Activity: needs an `activity_type` and `to_invoice_start_date`. The product_type should be ACTIVITY.
     *
     * Product supports two prices:
     * - `current_price` (in the filter indicated as 'price_A'): if set, this represents the current price of
     * this product should it be ordered.
     * - `future_price` (in the filter indicated as 'price_B'): to set a price that should apply to this
     * product somewhere in the future.
     *
     * This comes as a pair with `future_price_application_date`: you should set or null both at a time.
     * Once the application date has passed, you can expect Backend to have updates the product such that
     * the once future_price is now the (current) price.
     *
     * Notes on Subscription product:
     * - The organisation will be able to create a service contract for its customers based on this product.
     * - Currently we only support Flat-Fee based plans, so you should supply a `price_A` on creation (and not
     * price points)
     * - The plan must be a 'generic plan', meaning that it can be offered by any organisation (and not just EquineM)
     *
     * Notes on Activity Product:
     * - The organisation can use this to make certain activities billable. A billable item will be made
     * whenever a customer marks an activity with the same `activity_type` as done.
     * - You can indicate a date from when these billable items should be produced (also retroactively).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Product
     * @throws ApiError
     */
    public static productsRetrieve(data: ProductsRetrieveData): CancelablePromise<ProductsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/products/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Products come in different flavors. Currently we distinguish 4: [Breeding, Shipping, subscription, activity].
     * The model's fields constitutes the union of each category's required fields:
     * - Breeding: needs a `stallion` and the `product_type` should be BREEDING.
     * - Shipping: needs a `shipping_provider_name` and `shipping_service_type`. The `product_type` should be SHIPPING.
     * - Subscription: needs a (generic) `plan` and te product_type should be SUBSCRIPTION.
     * - Activity: needs an `activity_type` and `to_invoice_start_date`. The product_type should be ACTIVITY.
     *
     * Product supports two prices:
     * - `current_price` (in the filter indicated as 'price_A'): if set, this represents the current price of
     * this product should it be ordered.
     * - `future_price` (in the filter indicated as 'price_B'): to set a price that should apply to this
     * product somewhere in the future.
     *
     * This comes as a pair with `future_price_application_date`: you should set or null both at a time.
     * Once the application date has passed, you can expect Backend to have updates the product such that
     * the once future_price is now the (current) price.
     *
     * Notes on Subscription product:
     * - The organisation will be able to create a service contract for its customers based on this product.
     * - Currently we only support Flat-Fee based plans, so you should supply a `price_A` on creation (and not
     * price points)
     * - The plan must be a 'generic plan', meaning that it can be offered by any organisation (and not just EquineM)
     *
     * Notes on Activity Product:
     * - The organisation can use this to make certain activities billable. A billable item will be made
     * whenever a customer marks an activity with the same `activity_type` as done.
     * - You can indicate a date from when these billable items should be produced (also retroactively).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Product
     * @throws ApiError
     */
    public static productsUpdate(data: ProductsUpdateData): CancelablePromise<ProductsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/products/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Products come in different flavors. Currently we distinguish 4: [Breeding, Shipping, subscription, activity].
     * The model's fields constitutes the union of each category's required fields:
     * - Breeding: needs a `stallion` and the `product_type` should be BREEDING.
     * - Shipping: needs a `shipping_provider_name` and `shipping_service_type`. The `product_type` should be SHIPPING.
     * - Subscription: needs a (generic) `plan` and te product_type should be SUBSCRIPTION.
     * - Activity: needs an `activity_type` and `to_invoice_start_date`. The product_type should be ACTIVITY.
     *
     * Product supports two prices:
     * - `current_price` (in the filter indicated as 'price_A'): if set, this represents the current price of
     * this product should it be ordered.
     * - `future_price` (in the filter indicated as 'price_B'): to set a price that should apply to this
     * product somewhere in the future.
     *
     * This comes as a pair with `future_price_application_date`: you should set or null both at a time.
     * Once the application date has passed, you can expect Backend to have updates the product such that
     * the once future_price is now the (current) price.
     *
     * Notes on Subscription product:
     * - The organisation will be able to create a service contract for its customers based on this product.
     * - Currently we only support Flat-Fee based plans, so you should supply a `price_A` on creation (and not
     * price points)
     * - The plan must be a 'generic plan', meaning that it can be offered by any organisation (and not just EquineM)
     *
     * Notes on Activity Product:
     * - The organisation can use this to make certain activities billable. A billable item will be made
     * whenever a customer marks an activity with the same `activity_type` as done.
     * - You can indicate a date from when these billable items should be produced (also retroactively).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Product
     * @throws ApiError
     */
    public static productsPartialUpdate(data: ProductsPartialUpdateData): CancelablePromise<ProductsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/products/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Products come in different flavors. Currently we distinguish 4: [Breeding, Shipping, subscription, activity].
     * The model's fields constitutes the union of each category's required fields:
     * - Breeding: needs a `stallion` and the `product_type` should be BREEDING.
     * - Shipping: needs a `shipping_provider_name` and `shipping_service_type`. The `product_type` should be SHIPPING.
     * - Subscription: needs a (generic) `plan` and te product_type should be SUBSCRIPTION.
     * - Activity: needs an `activity_type` and `to_invoice_start_date`. The product_type should be ACTIVITY.
     *
     * Product supports two prices:
     * - `current_price` (in the filter indicated as 'price_A'): if set, this represents the current price of
     * this product should it be ordered.
     * - `future_price` (in the filter indicated as 'price_B'): to set a price that should apply to this
     * product somewhere in the future.
     *
     * This comes as a pair with `future_price_application_date`: you should set or null both at a time.
     * Once the application date has passed, you can expect Backend to have updates the product such that
     * the once future_price is now the (current) price.
     *
     * Notes on Subscription product:
     * - The organisation will be able to create a service contract for its customers based on this product.
     * - Currently we only support Flat-Fee based plans, so you should supply a `price_A` on creation (and not
     * price points)
     * - The plan must be a 'generic plan', meaning that it can be offered by any organisation (and not just EquineM)
     *
     * Notes on Activity Product:
     * - The organisation can use this to make certain activities billable. A billable item will be made
     * whenever a customer marks an activity with the same `activity_type` as done.
     * - You can indicate a date from when these billable items should be produced (also retroactively).
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static productsDestroy(data: ProductsDestroyData): CancelablePromise<ProductsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/products/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class PublicService {
    /**
     * @param data The data for the request.
     * @param data.year
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedFertilizerNormList
     * @throws ApiError
     */
    public static apiV5AdministrationManureFertilizerNormsList(data: ApiV5AdministrationManureFertilizerNormsListData): CancelablePromise<ApiV5AdministrationManureFertilizerNormsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/administration/manure/fertilizer_norms/{year}',
            path: {
                year: data.year
            },
            query: {
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * Publicly accessible endpoint to retrieve a specific horsepage.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @returns PublicHorsePage
     * @throws ApiError
     */
    public static apiV5HorsepagesRetrieve(data: ApiV5HorsepagesRetrieveData): CancelablePromise<ApiV5HorsepagesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/horsepages/{public_access_uuid}',
            path: {
                public_access_uuid: data.publicAccessUuid
            }
        });
    }
    
    /**
     * Publicly accessible endpoint to retrieve a specific invoice.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @returns PublicInvoice
     * @throws ApiError
     */
    public static apiV5InvoicesRetrieve(data: ApiV5InvoicesRetrieveData): CancelablePromise<ApiV5InvoicesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/invoices/{public_access_uuid}',
            path: {
                public_access_uuid: data.publicAccessUuid
            }
        });
    }
    
    /**
     * Publicly accessible endpoint to retrieve a specific invoice.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @param data.requestBody
     * @returns Redirect
     * @throws ApiError
     */
    public static apiV5InvoicesMolliePaymentLinkCreate(data: ApiV5InvoicesMolliePaymentLinkCreateData): CancelablePromise<ApiV5InvoicesMolliePaymentLinkCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/invoices/{public_access_uuid}/mollie_payment_link',
            path: {
                public_access_uuid: data.publicAccessUuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders _not_ made by the (logged-in) purchaser (typically a horse breeder) may not have a purchaser because
     * the supplier doesn't know the purchaser's organisation. To facilitate a purchaser lookup, the order has a
     * `public_access_uuid` field. Knowing the uuid allows any logged-in user to:
     * - look up the respective order;
     * - patch the purchaser field to any organisation accessible to that user.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @returns SupplierOrderDetail
     * @throws ApiError
     */
    public static apiV5OrdersRetrieve(data: ApiV5OrdersRetrieveData): CancelablePromise<ApiV5OrdersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/orders/{public_access_uuid}',
            path: {
                public_access_uuid: data.publicAccessUuid
            }
        });
    }
    
    /**
     * Orders _not_ made by the (logged-in) purchaser (typically a horse breeder) may not have a purchaser because
     * the supplier doesn't know the purchaser's organisation. To facilitate a purchaser lookup, the order has a
     * `public_access_uuid` field. Knowing the uuid allows any logged-in user to:
     * - look up the respective order;
     * - patch the purchaser field to any organisation accessible to that user.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @param data.requestBody
     * @returns PurchaserOrderUpdate
     * @throws ApiError
     */
    public static apiV5OrdersUpdate(data: ApiV5OrdersUpdateData): CancelablePromise<ApiV5OrdersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/orders/{public_access_uuid}',
            path: {
                public_access_uuid: data.publicAccessUuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders _not_ made by the (logged-in) purchaser (typically a horse breeder) may not have a purchaser because
     * the supplier doesn't know the purchaser's organisation. To facilitate a purchaser lookup, the order has a
     * `public_access_uuid` field. Knowing the uuid allows any logged-in user to:
     * - look up the respective order;
     * - patch the purchaser field to any organisation accessible to that user.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @param data.requestBody
     * @returns PurchaserOrderUpdate
     * @throws ApiError
     */
    public static apiV5OrdersPartialUpdate(data: ApiV5OrdersPartialUpdateData): CancelablePromise<ApiV5OrdersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/orders/{public_access_uuid}',
            path: {
                public_access_uuid: data.publicAccessUuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Orders _not_ made by the (logged-in) purchaser (typically a horse breeder) may not have a purchaser because
     * the supplier doesn't know the purchaser's organisation. To facilitate a purchaser lookup, the order has a
     * `public_access_uuid` field. Knowing the uuid allows any logged-in user to:
     * - look up the respective order;
     * - patch the purchaser field to any organisation accessible to that user.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @param data.requestBody
     * @returns Redirect
     * @throws ApiError
     */
    public static apiV5OrdersMolliePaymentLinkCreate(data: ApiV5OrdersMolliePaymentLinkCreateData): CancelablePromise<ApiV5OrdersMolliePaymentLinkCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/orders/{public_access_uuid}/mollie_payment_link',
            path: {
                public_access_uuid: data.publicAccessUuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * **PUBLIC** endpoint to retrieve the provided organisation's catalog of products that can be ordered.
     * Note that products come in various categories and that the fields will differ per category. For example a BREEDING
     * product will nest a stallion, and a SHIPPING product will have a not-null shipping_provider_name.
     *
     * POST to the organisation/products endpoint to add products to your organisation's catalog.
     * @param data The data for the request.
     * @param data.organisationPublicAccessUuid
     * @param data.category
     * @param data.categoryDefaultIn Multiple values may be separated by commas.
     * @param data.currentPriceGte Current price is greater than or equal to
     * @param data.currentPriceLte Current price is smaller than or equal to
     * @param data.freshAvailable
     * @param data.frozenAvailable
     * @param data.futurePriceGte Future price is greater than or equal to
     * @param data.futurePriceLte Future price is smaller than or equal to
     * @param data.hidden
     * @param data.isCustomProduct
     * @param data.nameIcontains
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.planModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.planModuleIn Multiple values may be separated by commas.
     * @param data.productType Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     * @param data.productTypeIn Multiple values may be separated by commas.
     * @param data.shippingCountriesIcontains
     * @param data.shippingProviderNameIcontains
     * @param data.shippingServiceType * `REGULAR` - Regular
     * * `PICK_UP` - Pick up
     * * `SAME_DAY_DELIVERY` - Same day delivery
     * * `NEXT_DAY_DELIVERY` - Next day delivery
     * * `SUNDAY_HOLIDAY_DELIVERY` - Sunday and holiday delivery
     * * `STAFF_DELIVERY` - staff delivery
     * @param data.showInShop
     * @param data.stallionUid
     * @param data.stallionUidIn Multiple values may be separated by commas.
     * @returns PaginatedCatalogueProductList
     * @throws ApiError
     */
    public static apiV5PublicOrganisationsProductCatalogueList(data: ApiV5PublicOrganisationsProductCatalogueListData): CancelablePromise<ApiV5PublicOrganisationsProductCatalogueListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/public_organisations/{organisation__public_access_uuid}/product_catalogue',
            path: {
                organisation__public_access_uuid: data.organisationPublicAccessUuid
            },
            query: {
                category: data.category,
                category__default__in: data.categoryDefaultIn,
                current_price_gte: data.currentPriceGte,
                current_price_lte: data.currentPriceLte,
                fresh_available: data.freshAvailable,
                frozen_available: data.frozenAvailable,
                future_price_gte: data.futurePriceGte,
                future_price_lte: data.futurePriceLte,
                hidden: data.hidden,
                is_custom_product: data.isCustomProduct,
                name__icontains: data.nameIcontains,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                plan__module: data.planModule,
                plan__module__in: data.planModuleIn,
                product_type: data.productType,
                product_type__in: data.productTypeIn,
                shipping_countries__icontains: data.shippingCountriesIcontains,
                shipping_provider_name__icontains: data.shippingProviderNameIcontains,
                shipping_service_type: data.shippingServiceType,
                show_in_shop: data.showInShop,
                stallion__uid: data.stallionUid,
                stallion__uid__in: data.stallionUidIn
            }
        });
    }
    
    /**
     * **PUBLIC** endpoint to retrieve the VAT percentages set by the organization belonging to the provided uuid.
     *
     * For more info on the VAT percentage rules see `/api/v5/organisations/{organisation__uid}/vatpercentages`
     * @param data The data for the request.
     * @param data.organisationPublicAccessUuid
     * @param data.countryIexact
     * @param data.isActive The vat percentage is currently applicable for this country and product category
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.vatCategory * `S` - Normal sale
     * * `AE` - Reverse-charging VAT
     * * `G` - Export
     * @param data.vatLevel * `STANDARD` - standard
     * * `REDUCED` - reduced
     * * `SECOND_REDUCED` - second reduced
     * * `SUPER_REDUCED` - super reduced
     * * `ZERO` - zero
     * @param data.vatLevelIn Multiple values may be separated by commas.
     * @returns PaginatedVATPercentageList
     * @throws ApiError
     */
    public static apiV5PublicOrganisationsVatPercentagesList(data: ApiV5PublicOrganisationsVatPercentagesListData): CancelablePromise<ApiV5PublicOrganisationsVatPercentagesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/public_organisations/{organisation__public_access_uuid}/vat_percentages',
            path: {
                organisation__public_access_uuid: data.organisationPublicAccessUuid
            },
            query: {
                country__iexact: data.countryIexact,
                is_active: data.isActive,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                vat_category: data.vatCategory,
                vat_level: data.vatLevel,
                vat_level__in: data.vatLevelIn
            }
        });
    }
    
    /**
     * **PUBLIC** endpoint to retrieve the public information (name) of an organisation.
     * @param data The data for the request.
     * @param data.publicAccessUuid
     * @returns PublicOrganisation
     * @throws ApiError
     */
    public static apiV5PublicOrganisationsRetrieve(data: ApiV5PublicOrganisationsRetrieveData): CancelablePromise<ApiV5PublicOrganisationsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/public_organisations/{public_access_uuid}',
            path: {
                public_access_uuid: data.publicAccessUuid
            }
        });
    }
}

export class ReportedhorserelocationsService {
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.arrivalOrDepartureType Filter by arrival (a) or departure (d)
     * @param data.horse
     * @param data.horselocation
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @returns PaginatedReportedHorseRelocationList
     * @throws ApiError
     */
    public static reportedhorserelocationsList(data: ReportedhorserelocationsListData): CancelablePromise<ReportedhorserelocationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/reportedhorserelocations',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            query: {
                arrival_or_departure_type: data.arrivalOrDepartureType,
                horse: data.horse,
                horselocation: data.horselocation,
                o: data.o,
                page: data.page,
                page_size: data.pageSize
            }
        });
    }
    
    /**
     * Create a location report from a horse location.
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.requestBody
     * @returns CreateReportedHorseRelocation
     * @throws ApiError
     */
    public static reportedhorserelocationsCreate(data: ReportedhorserelocationsCreateData): CancelablePromise<ReportedhorserelocationsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/reportedhorserelocations',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns ReportedHorseRelocation
     * @throws ApiError
     */
    public static reportedhorserelocationsRetrieve(data: ReportedhorserelocationsRetrieveData): CancelablePromise<ReportedhorserelocationsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/reportedhorserelocations/{uid}',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Checks status for an existing report
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns ReportedHorseRelocation
     * @throws ApiError
     */
    public static reportedhorserelocationsCheckStatusCreate(data: ReportedhorserelocationsCheckStatusCreateData): CancelablePromise<ReportedhorserelocationsCheckStatusCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/reportedhorserelocations/{uid}/check_status',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Withdraws an existing report
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @param data.uid
     * @returns ReportedHorseRelocation
     * @throws ApiError
     */
    public static reportedhorserelocationsWithdrawReportCreate(data: ReportedhorserelocationsWithdrawReportCreateData): CancelablePromise<ReportedhorserelocationsWithdrawReportCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{horse__organisation__uid}/reportedhorserelocations/{uid}/withdraw_report',
            path: {
                horse__organisation__uid: data.horseOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.horseOrganisationUid
     * @returns RvOHorseHairColor
     * @throws ApiError
     */
    public static reportedhorserelocationsRvOHorseHairColorsList(data: ReportedhorserelocationsRvOHorseHairColorsListData): CancelablePromise<ReportedhorserelocationsRvOHorseHairColorsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{horse__organisation__uid}/reportedhorserelocations/RvOHorseHairColors',
            path: {
                horse__organisation__uid: data.horseOrganisationUid
            }
        });
    }
}

export class RolesService {
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns Role
     * @throws ApiError
     */
    public static rolesList(data: RolesListData): CancelablePromise<RolesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/roles',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Role
     * @throws ApiError
     */
    public static rolesCreate(data: RolesCreateData): CancelablePromise<RolesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/roles',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Role
     * @throws ApiError
     */
    public static rolesRetrieve(data: RolesRetrieveData): CancelablePromise<RolesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/roles/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Role
     * @throws ApiError
     */
    public static rolesUpdate(data: RolesUpdateData): CancelablePromise<RolesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/roles/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Role
     * @throws ApiError
     */
    public static rolesPartialUpdate(data: RolesPartialUpdateData): CancelablePromise<RolesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/roles/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static rolesDestroy(data: RolesDestroyData): CancelablePromise<RolesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/roles/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * This action will override the role's exising permissions with those that correspond to the module permission.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ModulePermissions
     * @throws ApiError
     */
    public static rolesModulePermissionsUpdate(data: RolesModulePermissionsUpdateData): CancelablePromise<RolesModulePermissionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/roles/{uid}/module_permissions',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Returns the module permissions of the admin, which by definition are all permissions.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns ModulePermissionsList
     * @throws ApiError
     */
    public static rolesAllModulePermissionsList(data: RolesAllModulePermissionsListData): CancelablePromise<RolesAllModulePermissionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/roles/all_module_permissions',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * Gives back the possible roles.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns ModulePermissionsList
     * @throws ApiError
     */
    public static rolesModulePermissionsList(data: RolesModulePermissionsListData): CancelablePromise<RolesModulePermissionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/roles/module_permissions',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
}

export class ServiceService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns Service
     * @throws ApiError
     */
    public static serviceList(data: ServiceListData): CancelablePromise<ServiceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/service',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Service
     * @throws ApiError
     */
    public static serviceCreate(data: ServiceCreateData): CancelablePromise<ServiceCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/service',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Service
     * @throws ApiError
     */
    public static serviceRetrieve(data: ServiceRetrieveData): CancelablePromise<ServiceRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/service/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Service
     * @throws ApiError
     */
    public static serviceUpdate(data: ServiceUpdateData): CancelablePromise<ServiceUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/service/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Service
     * @throws ApiError
     */
    public static servicePartialUpdate(data: ServicePartialUpdateData): CancelablePromise<ServicePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/service/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static serviceDestroy(data: ServiceDestroyData): CancelablePromise<ServiceDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/service/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class ServicecontactsService {
    /**
     * @param data The data for the request.
     * @param data.customerOrganisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns ServiceContact
     * @throws ApiError
     */
    public static servicecontactsList(data: ServicecontactsListData): CancelablePromise<ServicecontactsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{customer__organisation__uid}/servicecontacts',
            path: {
                customer__organisation__uid: data.customerOrganisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.customerOrganisationUid
     * @param data.requestBody
     * @returns ServiceContact
     * @throws ApiError
     */
    public static servicecontactsCreate(data: ServicecontactsCreateData): CancelablePromise<ServicecontactsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{customer__organisation__uid}/servicecontacts',
            path: {
                customer__organisation__uid: data.customerOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.customerOrganisationUid
     * @param data.uid
     * @returns ServiceContact
     * @throws ApiError
     */
    public static servicecontactsRetrieve(data: ServicecontactsRetrieveData): CancelablePromise<ServicecontactsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{customer__organisation__uid}/servicecontacts/{uid}',
            path: {
                customer__organisation__uid: data.customerOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.customerOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ServiceContact
     * @throws ApiError
     */
    public static servicecontactsUpdate(data: ServicecontactsUpdateData): CancelablePromise<ServicecontactsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{customer__organisation__uid}/servicecontacts/{uid}',
            path: {
                customer__organisation__uid: data.customerOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.customerOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns ServiceContact
     * @throws ApiError
     */
    public static servicecontactsPartialUpdate(data: ServicecontactsPartialUpdateData): CancelablePromise<ServicecontactsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{customer__organisation__uid}/servicecontacts/{uid}',
            path: {
                customer__organisation__uid: data.customerOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.customerOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static servicecontactsDestroy(data: ServicecontactsDestroyData): CancelablePromise<ServicecontactsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{customer__organisation__uid}/servicecontacts/{uid}',
            path: {
                customer__organisation__uid: data.customerOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class ServiceContractsService {
    /**
     * Make and modify ServiceContracts, provided by the supplier.
     *
     * The supplying organisation needs to define subscription products that represent a continuing monthly service.
     * The supplier can then create a service contract for any of their customers.
     *
     * For the contract period you can supply a start, duration unit (Year) and duration amount (1). The end_dt will
     * be inferred from that. Duration unit and amount can be left out to signify the contract is open-ended.
     * Contracts can be set to extend automatically into a new one, but only if the duration unit and amount are defined.
     *
     * Currently, we only support supplier contracts on products applying a Fixed-fee pricing model. The fixed_price
     * represents the monthly price excl. vat and will default to the product's current price. This can be overridden.
     *
     * On existing contracts you can patch the duration, auto-extend, horse and price. Changing the customer or
     * product requires a new service contract.
     * @param data The data for the request.
     * @param data.productOrganisationUid
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.endDtGte
     * @param data.endDtLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.isActive A contract is active if start_dt < now() < end_dt
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.productCategoryDefault * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * @param data.productCategoryDefaultIn Multiple values may be separated by commas.
     * @param data.productName
     * @param data.productNameIn Multiple values may be separated by commas.
     * @param data.productPlanModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.productPlanModuleIn Multiple values may be separated by commas.
     * @param data.startDtGte
     * @param data.startDtLte
     * @returns PaginatedSupplierServiceContractList
     * @throws ApiError
     */
    public static serviceContractsSuppliedList(data: ServiceContractsSuppliedListData): CancelablePromise<ServiceContractsSuppliedListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{product__organisation__uid}/service_contracts/supplied',
            path: {
                product__organisation__uid: data.productOrganisationUid
            },
            query: {
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                end_dt__gte: data.endDtGte,
                end_dt__lte: data.endDtLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                is_active: data.isActive,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                product__category__default: data.productCategoryDefault,
                product__category__default__in: data.productCategoryDefaultIn,
                product__name: data.productName,
                product__name__in: data.productNameIn,
                product__plan__module: data.productPlanModule,
                product__plan__module__in: data.productPlanModuleIn,
                start_dt__gte: data.startDtGte,
                start_dt__lte: data.startDtLte
            }
        });
    }
    
    /**
     * Make and modify ServiceContracts, provided by the supplier.
     *
     * The supplying organisation needs to define subscription products that represent a continuing monthly service.
     * The supplier can then create a service contract for any of their customers.
     *
     * For the contract period you can supply a start, duration unit (Year) and duration amount (1). The end_dt will
     * be inferred from that. Duration unit and amount can be left out to signify the contract is open-ended.
     * Contracts can be set to extend automatically into a new one, but only if the duration unit and amount are defined.
     *
     * Currently, we only support supplier contracts on products applying a Fixed-fee pricing model. The fixed_price
     * represents the monthly price excl. vat and will default to the product's current price. This can be overridden.
     *
     * On existing contracts you can patch the duration, auto-extend, horse and price. Changing the customer or
     * product requires a new service contract.
     * @param data The data for the request.
     * @param data.productOrganisationUid
     * @param data.requestBody
     * @returns SupplierServiceContract
     * @throws ApiError
     */
    public static serviceContractsSuppliedCreate(data: ServiceContractsSuppliedCreateData): CancelablePromise<ServiceContractsSuppliedCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{product__organisation__uid}/service_contracts/supplied',
            path: {
                product__organisation__uid: data.productOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Make and modify ServiceContracts, provided by the supplier.
     *
     * The supplying organisation needs to define subscription products that represent a continuing monthly service.
     * The supplier can then create a service contract for any of their customers.
     *
     * For the contract period you can supply a start, duration unit (Year) and duration amount (1). The end_dt will
     * be inferred from that. Duration unit and amount can be left out to signify the contract is open-ended.
     * Contracts can be set to extend automatically into a new one, but only if the duration unit and amount are defined.
     *
     * Currently, we only support supplier contracts on products applying a Fixed-fee pricing model. The fixed_price
     * represents the monthly price excl. vat and will default to the product's current price. This can be overridden.
     *
     * On existing contracts you can patch the duration, auto-extend, horse and price. Changing the customer or
     * product requires a new service contract.
     * @param data The data for the request.
     * @param data.productOrganisationUid
     * @param data.uid
     * @returns SupplierServiceContract
     * @throws ApiError
     */
    public static serviceContractsSuppliedRetrieve(data: ServiceContractsSuppliedRetrieveData): CancelablePromise<ServiceContractsSuppliedRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{product__organisation__uid}/service_contracts/supplied/{uid}',
            path: {
                product__organisation__uid: data.productOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Make and modify ServiceContracts, provided by the supplier.
     *
     * The supplying organisation needs to define subscription products that represent a continuing monthly service.
     * The supplier can then create a service contract for any of their customers.
     *
     * For the contract period you can supply a start, duration unit (Year) and duration amount (1). The end_dt will
     * be inferred from that. Duration unit and amount can be left out to signify the contract is open-ended.
     * Contracts can be set to extend automatically into a new one, but only if the duration unit and amount are defined.
     *
     * Currently, we only support supplier contracts on products applying a Fixed-fee pricing model. The fixed_price
     * represents the monthly price excl. vat and will default to the product's current price. This can be overridden.
     *
     * On existing contracts you can patch the duration, auto-extend, horse and price. Changing the customer or
     * product requires a new service contract.
     * @param data The data for the request.
     * @param data.productOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns SupplierServiceContractUpdate
     * @throws ApiError
     */
    public static serviceContractsSuppliedUpdate(data: ServiceContractsSuppliedUpdateData): CancelablePromise<ServiceContractsSuppliedUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{product__organisation__uid}/service_contracts/supplied/{uid}',
            path: {
                product__organisation__uid: data.productOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Make and modify ServiceContracts, provided by the supplier.
     *
     * The supplying organisation needs to define subscription products that represent a continuing monthly service.
     * The supplier can then create a service contract for any of their customers.
     *
     * For the contract period you can supply a start, duration unit (Year) and duration amount (1). The end_dt will
     * be inferred from that. Duration unit and amount can be left out to signify the contract is open-ended.
     * Contracts can be set to extend automatically into a new one, but only if the duration unit and amount are defined.
     *
     * Currently, we only support supplier contracts on products applying a Fixed-fee pricing model. The fixed_price
     * represents the monthly price excl. vat and will default to the product's current price. This can be overridden.
     *
     * On existing contracts you can patch the duration, auto-extend, horse and price. Changing the customer or
     * product requires a new service contract.
     * @param data The data for the request.
     * @param data.productOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns SupplierServiceContractUpdate
     * @throws ApiError
     */
    public static serviceContractsSuppliedPartialUpdate(data: ServiceContractsSuppliedPartialUpdateData): CancelablePromise<ServiceContractsSuppliedPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{product__organisation__uid}/service_contracts/supplied/{uid}',
            path: {
                product__organisation__uid: data.productOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve your organisation's service contracts and up-, downgrade or cancel them. Cancelled contracts can be
     * reactivated as long as they haven't ended.
     *
     * The service contract represents the agreement of an organisation to gain access to some (amount of a) module on
     * some endpoint or some model. This is managed at three levels:
     * - Plan: defines the pricing model and the models needed to access certain modules. <-- defined by EquineM
     * - Subscription product: implements a plan and defines costs and max allowed instances. <-- defined by any Org
     * - Service Contract: implements a subscription product and buys access to a module for the active period.
     * TODO:
     * - new contracts should generate payment links, collect from credit cards or invoice on credit, depending on
     * organisation settings (doesn't exist yet)
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.endDtGte
     * @param data.endDtLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.isActive A contract is active if start_dt < now() < end_dt
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.productCategoryDefault * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * @param data.productCategoryDefaultIn Multiple values may be separated by commas.
     * @param data.productName
     * @param data.productNameIn Multiple values may be separated by commas.
     * @param data.productPlanModule Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     * @param data.productPlanModuleIn Multiple values may be separated by commas.
     * @param data.startDtGte
     * @param data.startDtLte
     * @returns PaginatedPurchaserServiceContractList
     * @throws ApiError
     */
    public static serviceContractsPurchasedList(data: ServiceContractsPurchasedListData): CancelablePromise<ServiceContractsPurchasedListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{purchaser__uid}/service_contracts/purchased',
            path: {
                purchaser__uid: data.purchaserUid
            },
            query: {
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                end_dt__gte: data.endDtGte,
                end_dt__lte: data.endDtLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                is_active: data.isActive,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                product__category__default: data.productCategoryDefault,
                product__category__default__in: data.productCategoryDefaultIn,
                product__name: data.productName,
                product__name__in: data.productNameIn,
                product__plan__module: data.productPlanModule,
                product__plan__module__in: data.productPlanModuleIn,
                start_dt__gte: data.startDtGte,
                start_dt__lte: data.startDtLte
            }
        });
    }
    
    /**
     * Retrieve your organisation's service contracts and up-, downgrade or cancel them. Cancelled contracts can be
     * reactivated as long as they haven't ended.
     *
     * The service contract represents the agreement of an organisation to gain access to some (amount of a) module on
     * some endpoint or some model. This is managed at three levels:
     * - Plan: defines the pricing model and the models needed to access certain modules. <-- defined by EquineM
     * - Subscription product: implements a plan and defines costs and max allowed instances. <-- defined by any Org
     * - Service Contract: implements a subscription product and buys access to a module for the active period.
     * TODO:
     * - new contracts should generate payment links, collect from credit cards or invoice on credit, depending on
     * organisation settings (doesn't exist yet)
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @returns PurchaserServiceContract
     * @throws ApiError
     */
    public static serviceContractsPurchasedRetrieve(data: ServiceContractsPurchasedRetrieveData): CancelablePromise<ServiceContractsPurchasedRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{purchaser__uid}/service_contracts/purchased/{uid}',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Updates the contract such that it won't extend automatically and has an appropriate end date.
     * The response will have the updated contract.
     *
     * Contracts on subscription products having flat-fee, tiered and stairstep pricing models are extended
     * automatically by default. You can cancel currently active and future service contracts:
     * - Past, inactive contracts: cannot be cancelled as they are immutable
     * - Active contracts, the currently active contact won't be extended automatically and no follow-up contract
     * will be made. Existing follow-ups will be deleted. The end date is set one month in the future or kept at
     * the original, whichever comes sooner.
     * - Future, inactive contract: the contract will be deleted.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @param data.requestBody
     * @returns PurchaserServiceContract
     * @throws ApiError
     */
    public static serviceContractsPurchasedCancelPartialUpdate(data: ServiceContractsPurchasedCancelPartialUpdateData): CancelablePromise<ServiceContractsPurchasedCancelPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{purchaser__uid}/service_contracts/purchased/{uid}/cancel',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Upgrade or downgrade this contract towards the provided price point. Returns a validation error
     * if no (max_amount) matching price point can be found. Returns a new ServiceContract (that is already
     * stored in the database).
     *
     * The request will fail if:
     * - the provided service contract is not about a product with a tiered subscription type.
     * - the provided max_amount does not match on an existing price point (that belongs to this contract's product)
     * - the provided max_amount is the same as this contract's max_amount
     *
     * ---
     *
     * If the price point has a higher price or a higher max than the one for the current contract, then this
     * contract is **upgraded**.
     *
     * The current contract (in the url) will end now and the new contract (in the response) will be effective
     * immediately. The new contract's end date will be set to the current's end date if there isn't a follow-up
     * contract yet; if there is, the new contract will take the follow-up's end date and the follow up is deleted.
     *
     * ---
     *
     * If the price point has a lower price or max than the one for the current contract, then this contract is
     * **downgraded**, meaning it will extend into a new one for the same subscription product, but at a lower tier.
     * The response will have the current, updated contract. This is only sensible for stair-step based contracts.
     *
     * This can be performed on current (active) and future contracts. The behavior will vary:
     * - Past contract: cannot be downgraded (validation error).
     * - Active contracts: the current contract will not be extended automatically. Instead, a new contract
     * is made for the same service, but at a lower price point. If the contact has a one-month notice (this
     * is the default), the contact will end one month from now or on the original end date, whichever comes
     * sooner. The new contract will start when the current ends.
     * - Future contracts: they can be patched like a regular resource to a different subscription product (uid), that
     * offers the same plan, but at a lower tier (max_amount).
     *
     * If this contract has a follow-up contract (e.g. because we are close to the current contract's end date,
     * and it was already extended automatically), that future contract will be deleted as another will take its
     * place for the respective plan and price point.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @param data.requestBody
     * @returns UpgradeDowngradePurchaserServiceContract
     * @throws ApiError
     */
    public static serviceContractsPurchasedChangePartialUpdate(data: ServiceContractsPurchasedChangePartialUpdateData): CancelablePromise<ServiceContractsPurchasedChangePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{purchaser__uid}/service_contracts/purchased/{uid}/change',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Contracts that have been canceled or downgraded but that are still active can be reactivated with this endpoint.
     * The response will have the updated contract.
     *
     * An active, cancelled contract (which has an end date less than one month from now and which won't extend),
     * can be reactivated. This will reset the end dt based on the contract's duration unit (month/year) and
     * duration count (int). It will also extend automatically again.
     * @param data The data for the request.
     * @param data.purchaserUid
     * @param data.uid
     * @param data.requestBody
     * @returns PurchaserServiceContract
     * @throws ApiError
     */
    public static serviceContractsPurchasedReactivatePartialUpdate(data: ServiceContractsPurchasedReactivatePartialUpdateData): CancelablePromise<ServiceContractsPurchasedReactivatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{purchaser__uid}/service_contracts/purchased/{uid}/reactivate',
            path: {
                purchaser__uid: data.purchaserUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * When an organisation is in trial the user can choose to end this trial period and continue with the
     * free-of-charge modules. This will:
     * - end the trial (flag) for the organisation
     * - un-set the paid services for all horses
     * - downgrade the UserAccounts to the free-of-charge module
     *
     * This can only be performed for organisations that are in trial
     * @param data The data for the request.
     * @param data.purchaserUid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static serviceContractsPurchasedContinueForFreeCreate(data: ServiceContractsPurchasedContinueForFreeCreateData): CancelablePromise<ServiceContractsPurchasedContinueForFreeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{purchaser__uid}/service_contracts/purchased/continue_for_free',
            path: {
                purchaser__uid: data.purchaserUid
            }
        });
    }
}

export class StablesService {
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns Stable
     * @throws ApiError
     */
    public static stablesList(data: StablesListData): CancelablePromise<StablesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/stables',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns Stable
     * @throws ApiError
     */
    public static stablesCreate(data: StablesCreateData): CancelablePromise<StablesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/stables',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns Stable
     * @throws ApiError
     */
    public static stablesRetrieve(data: StablesRetrieveData): CancelablePromise<StablesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/stables/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Stable
     * @throws ApiError
     */
    public static stablesUpdate(data: StablesUpdateData): CancelablePromise<StablesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/stables/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns Stable
     * @throws ApiError
     */
    public static stablesPartialUpdate(data: StablesPartialUpdateData): CancelablePromise<StablesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/stables/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static stablesDestroy(data: StablesDestroyData): CancelablePromise<StablesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/stables/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class StallionmountsService {
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.collectionDate
     * @param data.collectionDateGt
     * @param data.collectionDateGte
     * @param data.collectionDateLt
     * @param data.collectionDateLte
     * @param data.createdOnGt
     * @param data.createdOnLt
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.portionsFreshGte
     * @param data.portionsFreshLte
     * @param data.portionsFreshAvailableGte Portions fresh available is greater than or equal to
     * @param data.stallionUid
     * @param data.stallionUidIn Multiple values may be separated by commas.
     * @param data.strawsFrozenGte
     * @param data.strawsFrozenLte
     * @param data.strawsFrozenAvailableGte Frozen straws available is greater than or equal to
     * @returns PaginatedStallionMountList
     * @throws ApiError
     */
    public static stallionmountsList(data: StallionmountsListData): CancelablePromise<StallionmountsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid
            },
            query: {
                collection_date: data.collectionDate,
                collection_date__gt: data.collectionDateGt,
                collection_date__gte: data.collectionDateGte,
                collection_date__lt: data.collectionDateLt,
                collection_date__lte: data.collectionDateLte,
                created_on__gt: data.createdOnGt,
                created_on__lt: data.createdOnLt,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                portions_fresh__gte: data.portionsFreshGte,
                portions_fresh__lte: data.portionsFreshLte,
                portions_fresh_available__gte: data.portionsFreshAvailableGte,
                stallion__uid: data.stallionUid,
                stallion__uid__in: data.stallionUidIn,
                straws_frozen__gte: data.strawsFrozenGte,
                straws_frozen__lte: data.strawsFrozenLte,
                straws_frozen_available__gte: data.strawsFrozenAvailableGte
            }
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.requestBody
     * @returns StallionMount
     * @throws ApiError
     */
    public static stallionmountsCreate(data: StallionmountsCreateData): CancelablePromise<StallionmountsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @returns StallionMountDetail
     * @throws ApiError
     */
    public static stallionmountsRetrieve(data: StallionmountsRetrieveData): CancelablePromise<StallionmountsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns StallionMount
     * @throws ApiError
     */
    public static stallionmountsUpdate(data: StallionmountsUpdateData): CancelablePromise<StallionmountsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns StallionMount
     * @throws ApiError
     */
    public static stallionmountsPartialUpdate(data: StallionmountsPartialUpdateData): CancelablePromise<StallionmountsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
     * And GetQuerySetForUser can not have a parent.
     * And we need to annotate the queryset.
     * So the order of this mixin is super important and it works. *PRAGMATISM*
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static stallionmountsDestroy(data: StallionmountsDestroyData): CancelablePromise<StallionmountsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Mark all currently remaining *Fresh* portions as destroyed.
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @returns StallionMount
     * @throws ApiError
     */
    public static stallionmountsDestroyFreshPartialUpdate(data: StallionmountsDestroyFreshPartialUpdateData): CancelablePromise<StallionmountsDestroyFreshPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}/destroy_fresh',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Mark all currently remaining *Frozen* straws as destroyed.
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @returns StallionMount
     * @throws ApiError
     */
    public static stallionmountsDestroyFrozenPartialUpdate(data: StallionmountsDestroyFrozenPartialUpdateData): CancelablePromise<StallionmountsDestroyFrozenPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}/destroy_frozen',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Mark all currently remaining fresh portions *and* frozen straws as destroyed.
     * @param data The data for the request.
     * @param data.stallionOrganisationUid
     * @param data.uid
     * @returns StallionMount
     * @throws ApiError
     */
    public static stallionmountsDestroyRemainingPartialUpdate(data: StallionmountsDestroyRemainingPartialUpdateData): CancelablePromise<StallionmountsDestroyRemainingPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{stallion__organisation__uid}/stallionmounts/{uid}/destroy_remaining',
            path: {
                stallion__organisation__uid: data.stallionOrganisationUid,
                uid: data.uid
            }
        });
    }
}

export class TransactionsService {
    /**
     * Crud Transactions.
     *
     * A transaction records incomes and expenses, represented by TransactionItems. The field `organisation` represents
     * the organisation that manages the transaction i.e. your organisation. The field `supplier` represents the contact
     * from whom the goods or services where bought or earned from. (For disambiguation: the object and its items do not
     * track a potential purchaser contact for whom the goods are intended; this is done over BillableItems)
     *
     * The List endpoint will yield 'simple' transaction instances; The Fetch/Patch/Post endpoint also has the nested
     * transaction items. Updates show the same behavior as the invoice and order detail api. See the serializer doc for
     * more details.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.createdOnGte
     * @param data.createdOnLte
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.supplierUid
     * @returns PaginatedTransactionList
     * @throws ApiError
     */
    public static transactionsList(data: TransactionsListData): CancelablePromise<TransactionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/transactions',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                created_on__gte: data.createdOnGte,
                created_on__lte: data.createdOnLte,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                supplier__uid: data.supplierUid
            }
        });
    }
    
    /**
     * Crud Transactions.
     *
     * A transaction records incomes and expenses, represented by TransactionItems. The field `organisation` represents
     * the organisation that manages the transaction i.e. your organisation. The field `supplier` represents the contact
     * from whom the goods or services where bought or earned from. (For disambiguation: the object and its items do not
     * track a potential purchaser contact for whom the goods are intended; this is done over BillableItems)
     *
     * The List endpoint will yield 'simple' transaction instances; The Fetch/Patch/Post endpoint also has the nested
     * transaction items. Updates show the same behavior as the invoice and order detail api. See the serializer doc for
     * more details.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns TransactionDetail
     * @throws ApiError
     */
    public static transactionsCreate(data: TransactionsCreateData): CancelablePromise<TransactionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/transactions',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Crud Transactions.
     *
     * A transaction records incomes and expenses, represented by TransactionItems. The field `organisation` represents
     * the organisation that manages the transaction i.e. your organisation. The field `supplier` represents the contact
     * from whom the goods or services where bought or earned from. (For disambiguation: the object and its items do not
     * track a potential purchaser contact for whom the goods are intended; this is done over BillableItems)
     *
     * The List endpoint will yield 'simple' transaction instances; The Fetch/Patch/Post endpoint also has the nested
     * transaction items. Updates show the same behavior as the invoice and order detail api. See the serializer doc for
     * more details.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns TransactionDetail
     * @throws ApiError
     */
    public static transactionsRetrieve(data: TransactionsRetrieveData): CancelablePromise<TransactionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/transactions/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Crud Transactions.
     *
     * A transaction records incomes and expenses, represented by TransactionItems. The field `organisation` represents
     * the organisation that manages the transaction i.e. your organisation. The field `supplier` represents the contact
     * from whom the goods or services where bought or earned from. (For disambiguation: the object and its items do not
     * track a potential purchaser contact for whom the goods are intended; this is done over BillableItems)
     *
     * The List endpoint will yield 'simple' transaction instances; The Fetch/Patch/Post endpoint also has the nested
     * transaction items. Updates show the same behavior as the invoice and order detail api. See the serializer doc for
     * more details.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns TransactionDetail
     * @throws ApiError
     */
    public static transactionsUpdate(data: TransactionsUpdateData): CancelablePromise<TransactionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/transactions/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Crud Transactions.
     *
     * A transaction records incomes and expenses, represented by TransactionItems. The field `organisation` represents
     * the organisation that manages the transaction i.e. your organisation. The field `supplier` represents the contact
     * from whom the goods or services where bought or earned from. (For disambiguation: the object and its items do not
     * track a potential purchaser contact for whom the goods are intended; this is done over BillableItems)
     *
     * The List endpoint will yield 'simple' transaction instances; The Fetch/Patch/Post endpoint also has the nested
     * transaction items. Updates show the same behavior as the invoice and order detail api. See the serializer doc for
     * more details.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns TransactionDetail
     * @throws ApiError
     */
    public static transactionsPartialUpdate(data: TransactionsPartialUpdateData): CancelablePromise<TransactionsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/transactions/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Crud Transactions.
     *
     * A transaction records incomes and expenses, represented by TransactionItems. The field `organisation` represents
     * the organisation that manages the transaction i.e. your organisation. The field `supplier` represents the contact
     * from whom the goods or services where bought or earned from. (For disambiguation: the object and its items do not
     * track a potential purchaser contact for whom the goods are intended; this is done over BillableItems)
     *
     * The List endpoint will yield 'simple' transaction instances; The Fetch/Patch/Post endpoint also has the nested
     * transaction items. Updates show the same behavior as the invoice and order detail api. See the serializer doc for
     * more details.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static transactionsDestroy(data: TransactionsDestroyData): CancelablePromise<TransactionsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/transactions/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * List all your organisation's TransactionItems. Note that these are part of a transaction;
     * you can get the full details from the transaction-detail endpoint.
     * @param data The data for the request.
     * @param data.transactionOrganisationUid
     * @param data.amountGte
     * @param data.amountLte
     * @param data.createdOnGte
     * @param data.createdOnLte
     * @param data.customerUid
     * @param data.customerUidIn Multiple values may be separated by commas.
     * @param data.dateGt
     * @param data.dateGte
     * @param data.dateLt
     * @param data.dateLte
     * @param data.horseUid
     * @param data.horseUidIn Multiple values may be separated by commas.
     * @param data.o Which field to use when ordering the results.
     * @param data.page A page number within the paginated result set.
     * @param data.pageSize Number of results to return per page.
     * @param data.transactionSupplierUid
     * @param data.transactionSupplierUidIn Multiple values may be separated by commas.
     * @param data.transactionType * `EXPENSE` - Expense
     * * `INCOME` - Income
     * @returns PaginatedTransactionItemList
     * @throws ApiError
     */
    public static transactionsItemsList(data: TransactionsItemsListData): CancelablePromise<TransactionsItemsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{transaction__organisation__uid}/transactions/items',
            path: {
                transaction__organisation__uid: data.transactionOrganisationUid
            },
            query: {
                amount__gte: data.amountGte,
                amount__lte: data.amountLte,
                created_on__gte: data.createdOnGte,
                created_on__lte: data.createdOnLte,
                customer__uid: data.customerUid,
                customer__uid__in: data.customerUidIn,
                date__gt: data.dateGt,
                date__gte: data.dateGte,
                date__lt: data.dateLt,
                date__lte: data.dateLte,
                horse__uid: data.horseUid,
                horse__uid__in: data.horseUidIn,
                o: data.o,
                page: data.page,
                page_size: data.pageSize,
                transaction__supplier__uid: data.transactionSupplierUid,
                transaction__supplier__uid__in: data.transactionSupplierUidIn,
                transaction_type: data.transactionType
            }
        });
    }
}

export class VaccinationrulesService {
    /**
     * Viewset for VaccinationRules
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns VaccinationRule
     * @throws ApiError
     */
    public static vaccinationrulesList(data: VaccinationrulesListData): CancelablePromise<VaccinationrulesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/vaccinationrules',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
    
    /**
     * Viewset for VaccinationRules
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns VaccinationRule
     * @throws ApiError
     */
    public static vaccinationrulesCreate(data: VaccinationrulesCreateData): CancelablePromise<VaccinationrulesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/vaccinationrules',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Viewset for VaccinationRules
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns VaccinationRule
     * @throws ApiError
     */
    public static vaccinationrulesRetrieve(data: VaccinationrulesRetrieveData): CancelablePromise<VaccinationrulesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/vaccinationrules/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * Viewset for VaccinationRules
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns VaccinationRule
     * @throws ApiError
     */
    public static vaccinationrulesUpdate(data: VaccinationrulesUpdateData): CancelablePromise<VaccinationrulesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/vaccinationrules/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Viewset for VaccinationRules
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns VaccinationRule
     * @throws ApiError
     */
    public static vaccinationrulesPartialUpdate(data: VaccinationrulesPartialUpdateData): CancelablePromise<VaccinationrulesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/vaccinationrules/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Viewset for VaccinationRules
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static vaccinationrulesDestroy(data: VaccinationrulesDestroyData): CancelablePromise<VaccinationrulesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/vaccinationrules/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
}

export class VatpercentageexternalprovideridsService {
    /**
     * Stores the external_ids for vat_percentages
     * @param data The data for the request.
     * @param data.vatPercentageOrganisationUid
     * @param data.o Which field to use when ordering the results.
     * @returns VATPercentageExternalProviderId
     * @throws ApiError
     */
    public static vatpercentageexternalprovideridsList(data: VatpercentageexternalprovideridsListData): CancelablePromise<VatpercentageexternalprovideridsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{vat_percentage__organisation__uid}/vatpercentageexternalproviderids',
            path: {
                vat_percentage__organisation__uid: data.vatPercentageOrganisationUid
            },
            query: {
                o: data.o
            }
        });
    }
    
    /**
     * Stores the external_ids for vat_percentages
     * @param data The data for the request.
     * @param data.vatPercentageOrganisationUid
     * @param data.requestBody
     * @returns VATPercentageExternalProviderId
     * @throws ApiError
     */
    public static vatpercentageexternalprovideridsCreate(data: VatpercentageexternalprovideridsCreateData): CancelablePromise<VatpercentageexternalprovideridsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{vat_percentage__organisation__uid}/vatpercentageexternalproviderids',
            path: {
                vat_percentage__organisation__uid: data.vatPercentageOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Stores the external_ids for vat_percentages
     * @param data The data for the request.
     * @param data.uid
     * @param data.vatPercentageOrganisationUid
     * @returns VATPercentageExternalProviderId
     * @throws ApiError
     */
    public static vatpercentageexternalprovideridsRetrieve(data: VatpercentageexternalprovideridsRetrieveData): CancelablePromise<VatpercentageexternalprovideridsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{vat_percentage__organisation__uid}/vatpercentageexternalproviderids/{uid}',
            path: {
                uid: data.uid,
                vat_percentage__organisation__uid: data.vatPercentageOrganisationUid
            }
        });
    }
    
    /**
     * Stores the external_ids for vat_percentages
     * @param data The data for the request.
     * @param data.uid
     * @param data.vatPercentageOrganisationUid
     * @param data.requestBody
     * @returns VATPercentageExternalProviderId
     * @throws ApiError
     */
    public static vatpercentageexternalprovideridsUpdate(data: VatpercentageexternalprovideridsUpdateData): CancelablePromise<VatpercentageexternalprovideridsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{vat_percentage__organisation__uid}/vatpercentageexternalproviderids/{uid}',
            path: {
                uid: data.uid,
                vat_percentage__organisation__uid: data.vatPercentageOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Stores the external_ids for vat_percentages
     * @param data The data for the request.
     * @param data.uid
     * @param data.vatPercentageOrganisationUid
     * @param data.requestBody
     * @returns VATPercentageExternalProviderId
     * @throws ApiError
     */
    public static vatpercentageexternalprovideridsPartialUpdate(data: VatpercentageexternalprovideridsPartialUpdateData): CancelablePromise<VatpercentageexternalprovideridsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{vat_percentage__organisation__uid}/vatpercentageexternalproviderids/{uid}',
            path: {
                uid: data.uid,
                vat_percentage__organisation__uid: data.vatPercentageOrganisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Stores the external_ids for vat_percentages
     * @param data The data for the request.
     * @param data.uid
     * @param data.vatPercentageOrganisationUid
     * @returns void No response body
     * @throws ApiError
     */
    public static vatpercentageexternalprovideridsDestroy(data: VatpercentageexternalprovideridsDestroyData): CancelablePromise<VatpercentageexternalprovideridsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{vat_percentage__organisation__uid}/vatpercentageexternalproviderids/{uid}',
            path: {
                uid: data.uid,
                vat_percentage__organisation__uid: data.vatPercentageOrganisationUid
            }
        });
    }
}

export class VatpercentagesService {
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.countryIexact
     * @param data.isActive The vat percentage is currently applicable for this country and product category
     * @param data.o Which field to use when ordering the results.
     * @param data.vatCategory * `S` - Normal sale
     * * `AE` - Reverse-charging VAT
     * * `G` - Export
     * @param data.vatLevel * `STANDARD` - standard
     * * `REDUCED` - reduced
     * * `SECOND_REDUCED` - second reduced
     * * `SUPER_REDUCED` - super reduced
     * * `ZERO` - zero
     * @param data.vatLevelIn Multiple values may be separated by commas.
     * @returns VATPercentage
     * @throws ApiError
     */
    public static vatpercentagesList(data: VatpercentagesListData): CancelablePromise<VatpercentagesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                country__iexact: data.countryIexact,
                is_active: data.isActive,
                o: data.o,
                vat_category: data.vatCategory,
                vat_level: data.vatLevel,
                vat_level__in: data.vatLevelIn
            }
        });
    }
    
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.requestBody
     * @returns VATPercentage
     * @throws ApiError
     */
    public static vatpercentagesCreate(data: VatpercentagesCreateData): CancelablePromise<VatpercentagesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages',
            path: {
                organisation__uid: data.organisationUid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns VATPercentage
     * @throws ApiError
     */
    public static vatpercentagesRetrieve(data: VatpercentagesRetrieveData): CancelablePromise<VatpercentagesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns VATPercentageUpdate
     * @throws ApiError
     */
    public static vatpercentagesUpdate(data: VatpercentagesUpdateData): CancelablePromise<VatpercentagesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @param data.requestBody
     * @returns VATPercentageUpdate
     * @throws ApiError
     */
    public static vatpercentagesPartialUpdate(data: VatpercentagesPartialUpdateData): CancelablePromise<VatpercentagesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.uid
     * @returns void No response body
     * @throws ApiError
     */
    public static vatpercentagesDestroy(data: VatpercentagesDestroyData): CancelablePromise<VatpercentagesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages/{uid}',
            path: {
                organisation__uid: data.organisationUid,
                uid: data.uid
            }
        });
    }
    
    /**
     * VAT percentages are stored as relations to ordered products. The set of fields that may be changed is therefore
     * limited; you can't change a percentage, but you can make a new instance. So, whenever a country dictates a
     * different vat percentage, organizations are expected to make new instances that reflect that. A start_date
     * indicating when the respective vat percentage should become active must be included. At that date the previous
     * instance should no longer be applied to new or existing object e.g. new orders.
     *
     * This means an organization can have multiple vat percentages per country and per vat_level. The is_active
     * field will indicate which of them is applicable at the current date. Filtering by `country`, `vat_level` and
     * `is_active` will yield max one result.
     *
     * Note: A product of product type (and category) 'SHIPPING' requires the existence of a VAT percentage for each of that product's
     * shipping countries. Also, products that can be ordered in general require that their respective product.category
     * has a vat_level for the respective country, and that a VATPercentage exists for that country with that vat_level.
     * This means that you may not delete a VAT percentage that would be needed for one or more or your organization's
     * products.
     * @param data The data for the request.
     * @param data.organisationUid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static vatpercentagesImportDefaultEuVatPercentagesCreate(data: VatpercentagesImportDefaultEuVatPercentagesCreateData): CancelablePromise<VatpercentagesImportDefaultEuVatPercentagesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/organisations/{organisation__uid}/vatpercentages/import_default_eu_vat_percentages',
            path: {
                organisation__uid: data.organisationUid
            }
        });
    }
}

export class WebhookService {
    /**
     * A purchaser can set a Mollie mandate over a backend call which creates a ContactPaymentProvider and a
     * mollie payment for 1 cent (enabling different payment vendors). The customer can then 'do' the resulting
     * payment.
     *
     * On completion (pass or fail) mollie will post to this webhook with a mollie payment id for us to do what's
     * needed:
     * - inspect if that payment succeeded an if the mandate was given
     * - updates the corresponding ContactPaymentProvider accordingly
     *
     * :param request: a POST with 'id' in its params
     * :return: OK
     * @param data The data for the request.
     * @param data.organisationPublicAccessUuid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static apiV5WebhookMollieMandateCreate(data: ApiV5WebhookMollieMandateCreateData): CancelablePromise<ApiV5WebhookMollieMandateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/webhook/mollie/mandate/{organisation_public_access_uuid}',
            path: {
                organisation_public_access_uuid: data.organisationPublicAccessUuid
            }
        });
    }
    
    /**
     * The mollie webhook is called as POST with a mollie payment id whenever the status of the corresponding payment
     * on their side changes. This method will fetch and inspect the corresponding mollie payment object and act
     * according to its payment status; new payments are stored (on our side) in the Payment model. Existing (equinem)
     * payments will be updated according to the fetched (mollie) payment.
     * https://docs.mollie.com/reference/v2/payments-api/get-payment
     * https://docs.mollie.com/payments/status-changes
     *
     * By returning OK this method communicates back to mollie that the info was received and processed. Mollie will
     * retry multiple times if something else is returned.
     *
     * :param request: a POST with 'id' in its params
     * :return: OK
     * @param data The data for the request.
     * @param data.organisationPublicAccessUuid
     * @returns unknown No response body
     * @throws ApiError
     */
    public static apiV5WebhookMolliePaymentCreate(data: ApiV5WebhookMolliePaymentCreateData): CancelablePromise<ApiV5WebhookMolliePaymentCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/webhook/mollie/payment/{organisation_public_access_uuid}',
            path: {
                organisation_public_access_uuid: data.organisationPublicAccessUuid
            }
        });
    }
    
    /**
     * :return: OK
     * @returns unknown No response body
     * @throws ApiError
     */
    public static apiV5WebhookSnelstartCreate(): CancelablePromise<ApiV5WebhookSnelstartCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v5/webhook/snelstart'
        });
    }
}

export class WorkdayAvailabilityService {
    /**
     * View set WorkDayAvailability from the Employee's perspective.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.dendGt
     * @param data.dstartLt
     * @returns WorkDayAvailability
     * @throws ApiError
     */
    public static workdayAvailabilityActivitiesList(data: WorkdayAvailabilityActivitiesListData): CancelablePromise<WorkdayAvailabilityActivitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/workday_availability/activities',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                dend__gt: data.dendGt,
                dstart__lt: data.dstartLt
            }
        });
    }
    
    /**
     * View set for the WorkDayAvailability from the Manager's perspective.
     * @param data The data for the request.
     * @param data.organisationUid
     * @param data.contactUid
     * @param data.contactUidIn Multiple values may be separated by commas.
     * @param data.dendGt
     * @param data.dstartLt
     * @returns WorkDayAvailabilityManager
     * @throws ApiError
     */
    public static workdayAvailabilityManagerList(data: WorkdayAvailabilityManagerListData): CancelablePromise<WorkdayAvailabilityManagerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v5/organisations/{organisation__uid}/workday_availability/manager',
            path: {
                organisation__uid: data.organisationUid
            },
            query: {
                contact__uid: data.contactUid,
                contact__uid__in: data.contactUidIn,
                dend__gt: data.dendGt,
                dstart__lt: data.dstartLt
            }
        });
    }
}